// @flow

export default {
  BI_TYPE_FULL: 'FULL_BI',
  BI_TYPE_MINI: 'MINI_BI',
  CATEGORY_WHOLE_LIFE: 'WHOLE_LIFE',
  CATEGORY_PERFECT_LIFE: 'PERFECTLIFE',
  CATEGORY_SUKHAPABDEKDEE: 'SUKHAPABDEKDEE',
  CATEGORY_WHOLE_LIFE_25PL: 'WHOLE_LIFE_25PL',
  CATEGORY_WHOLE_LIFE_12PL: 'WHOLE_LIFE_12PL',
  CATEGORY_WHOLE_LIFE_LIFEPROTECT: 'WHOLE_LIFE_LIFEPROTECT',
  CATEGORY_WHOLE_LIFE_LIFEENSURE: 'WHOLE_LIFE_LIFEENSURE',
  CATEGORY_WHOLE_LIFE_LIFEREADY: 'WHOLE_LIFE_LIFEREADY',
  CATEGORY_INVESTMENT: 'INVESTMENT',
  CATEGORY_HEALTH: 'HEALTH',
  CATEGORY_SAVING: 'SAVING',
  CATEGORY_PROTECTION: 'PROTECTION',
  CATEGORY_LIFE_SAVE_PRO: 'LIFE_SAVE_PRO',
  CATEGORY_LIFE_SAVE_PRO_25P15: 'LIFE_SAVE_PRO_25P15',
  CATEGORY_RETIREMENT: 'RETIREMENT',
  CATEGORY_RETIREMENT_LR05: 'RETIREMENT_LR05',
  CATEGORY_BUMNAN_READY: 'BUMNAN_READY',
  CATEGORY_LIFE_SAVE_PRO_20P10: 'LIFE_SAVE_PRO_20P10',
  CATEGORY_FLEXI_HEALTH: 'FLEXI_HEALTH',
  CATEGORY_HEALTH_TOPPING: 'HEALTH_TOPPING',
  CATEGORY_IHEALTHYULTRA: 'IHEALTHYULTRA',
  CATEGORY_LIFE_READY: 'LIFE_READY',
  CATEGORY_PRODUCT_SIO: 'PRODUCT_SIO',
  CATEGORY_TERM_LIFE: 'TERM_LIFE',
  CATEGORY_ISHIELD: 'ISHIELD',
  CATEGORY_LOAN: 'LOAN',
  CATEGORY_LIFE_LEGACY: 'LIFE_LEGACY',
  CATEGORY_S7: 'S7',
  CATEGORY_TERM_LIFE_GIO: 'TERM_LIFE_GIO',
  CATEGORY_MRTA: 'MRTA',
  BI_TYPE_PRODUCT_CODE_IINVEST: 'SPUL',
  BI_TYPE_PRODUCT_CODE_IWEALTHY: 'RPUL',
  BI_TYPE_PRODUCT_CODE_RPUDR: 'RPUDR',
  INVESTMENT_BENEFITS: 'ตารางสรุปผลประโยชน์ตามกรมธรรม์',
  INVESTMENT_BENEFITS_SUMMARY: 'สรุปผลประโยชน์ตามกรมธรรม์',
  INVESTMENT_BENEFITS_GUARANTEE: 'ผลประโยชน์รับรองการจ่าย',
  INVESTMENT_BENEFITS_SCENARIO:
    'ตัวอย่างผลประโยชน์ตามกรมธรรม์ \n เมื่อรวมเงินปันผลไม่รับรองการจ่าย โดยเทียบกับ\nอัตราผลตอบแทนจากการลงทุนที่แตกต่างกัน**',
  INVESTMENT_BENEFITS_GUARANTEE_CASHDROP: '1) เงินจ่ายคืนตามกรมธรรม์ประกันภัย',
  INVESTMENT_BENEFITS_GUARANTEE_MATURITY: '2) เงินครบกำหนดสัญญา',
  INVESTMENT_BENEFITS_GUARANTEE_TOTAL: 'รวมผลประโยชน์เงินจ่ายคืนตลอดสัญญา',
  INVESTMENT_BENEFITS_NONGUARANTEE_MATURITY: '3) เงินปันผล** ไม่รับรองการจ่าย ณ วันครบกำหนดสัญญา',
  INVESTMENT_BENEFITS_NONGUARANTEE_TOTAL: 'รวมผลประโยชน์ตามกรมธรรม์ทั้งสิ้นตลอดสัญญา (รวมเงินปันผล**)',
  EXAMPLE: 'ตัวอย่าง',
  EXAMPLE_1: 'ตัวอย่างที่ 1',
  EXAMPLE_2: 'ตัวอย่างที่ 2',
  EXAMPLE_3: 'ตัวอย่างที่ 3',
  BENEFIT_SUMMARY: 'ตารางสรุปความคุ้มครอง',
  BENEFIT_LIST: 'รายการผลประโยชน์',
  BENEFIT_BAHT: 'ผลประโยชน์ (บาท)',
  RIDERS_BENEFITS: 'รายละเอียดของสัญญาเพิ่มเติม',
  RIDERS_BENEFITS_IGROW: 'รายละเอียดของสัญญาไอโกรว์ (iGrow)',
  RIDER_BENEFIT_DISCLAIMER_ONE:
    '* สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปีโดยเบี้ยประกันภัยของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  RIDER_BENEFIT_CANCER_DISCLAIMER_TWO:
    '** นับจากวันเริ่มมีผลคุ้มครองสัญญาเพิ่มเติมนี้ หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้ายแล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
  EXCEPTION_NOTE: 'ข้อยกเว้นสำคัญ',
  IMPORTANT_EXCEPTION_NOTE: 'ข้อยกเว้นที่สำคัญ* สำหรับการให้ความคุ้มครอง',
  BASIC_PLAN_DETAILS: 'รายละเอียดของสัญญาหลัก {{& name }} ({{ code }})',
  BASIC_PLAN_DETAILS_WITHOUT_CODE: 'รายละเอียดของสัญญาหลัก {{& name }}',
  BASIC_PLAN_DETAILS_MRTA: 'รายละเอียดของสัญญาหลัก {{& name }} ({{ planCode }}) ({{ code }})',
  PROTECTION_LIST: 'รายการทดแทน',
  AREA_INVOLVED: 'บริเวณที่ไหม้',
  PERCENT_OF_TOTAL_BODY_SURFACE_AREA_BURNT: 'ความเสียหายคิดเป็นเปอร์เซ็นต์ของผิวหนังทั้งหมด',
  // -- insured information header
  SPECIALLY_FOR: 'พิเศษสำหรับ',
  DEFAULT_TITLE: 'คุณ',
  DEFAULT_FIRSTNAME: 'ลูกค้า',
  DEFAULT_LASTNAME: 'คนพิเศษ',
  // -- agent information header
  PRESENTER_CODE: 'รหัสผู้เสนอ',
  BRANCH_GA: 'สาขา / GA',
  TELEPHONE_NUMBER_CONTACT: 'โทรศัพท์ติดต่อ',
  DAY: 'วัน',
  MONTH: 'เดือน',
  YEAR: 'ปี',
  YEAR_AT: 'ปีที่',
  GENDER: 'เพศ',
  AGE: 'อายุ',
  YES: 'ใช่',
  NO: 'ไม่ใช่',

  // -- policy-value/policy-value-table
  POLICY_VALUE_TABLE: 'ตารางมูลค่ากรมธรรม์',
  POLICY_VALUE_TABLE_BUMNAN_READY: 'ตารางผลประโยชน์ตามกรมธรรม์',
  POLICY_VALUE_TABLE_ONE: 'ตารางแสดงผลประโยชน์แบบประกันสุขภาพสำเร็จรูป {{productName}}',
  POLICY_VALUE_TABLE_TWO: 'ตารางแสดงผลประโยชน์แบบประกันสุขภาพแบบเลือกได้ {{productName}}',
  POLICY_VALUE_TABLE_INSURANCE_YEAR: 'ปี\nกรมธรรม์\nที่',
  POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE: 'มูลค่าเวนคืนกรมธรรม์ของสัญญาหลัก',
  POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER: 'เงินค่าเวนคืนกรมธรรม์ประกันภัย',
  POLICY_VALUE_TABLE_CASH_SURRENDER_VALUE_NORIDER_BI_PDF: 'เงินค่าเวนคืน\nกรมธรรม์\nประกันภัย',
  POLICY_VALUE_TABLE_DEATH_BENEFIT: 'ความคุ้มครองการเสียชีวิตของสัญญาหลัก',
  POLICY_VALUE_TABLE_DEATH_BENEFIT_NO_RIDER_BI_PDF: 'ความคุ้มครอง\nกรณีเสียชีวิต',
  UNTIL_AGE: 'ถึงอายุ',
  PLAN: 'แผน',
  PLAN_1: 'แผน 1',
  PLAN_2: 'แผน 2',
  PLAN_3: 'แผน 3',
  CASH_SURRENDER_VALUE: 'มูลค่าเวนคืนเงินสด',
  DEATH_BENEFIT: 'ความคุ้มครองการเสียชีวิต',
  END_OF_THE_YEAR: 'สิ้นปี',
  END_OF_THE_YEAR_AT: 'สิ้นปีที่',
  END_OF_YEAR_POLICY: 'ณ สิ้นปีกรมธรรม์',
  END_OF_YEAR_POLICY_WITH_BRACKET: '(ณ สิ้นปีกรมธรรม์)',
  PREMIUM: 'เบี้ยประกันภัย',
  CUMULATIVE_PREMIUM: 'เบี้ยประกันภัยสัญญาหลักสะสม',
  BASIC_PLAN: 'สัญญาหลัก',
  BASIC_PREMIUM: 'เบี้ยประกันภัยสัญญาหลัก',
  BASIC_PREMIUM_PER_YEAR: 'เบี้ยประกันภัยสัญญาหลักรายปี',
  RIDER: 'สัญญาเพิ่มเติม',
  RIDER_1_STAR: 'สัญญาเพิ่มเติม*',
  RIDER_2_STAR: 'สัญญาเพิ่มเติม**',
  RIDER_HEALTH: 'สัญญาเพิ่มเติมค่ารักษาพยาบาล',
  RIDER_PREMIUM: 'เบี้ยประกันภัยสัญญาเพิ่มเติม',
  TOTAL_RIDER_PREMIUM: 'เบี้ยประกันภัยสัญญาเพิ่มเติมรวมงวดแรก',
  MEDICAL_FEE: 'ค่ารักษาพยาบาล',
  WPTPD_QQ_NAME: 'ยกเว้นเบี้ยหลัก กรณี ผอป. ทุพพลภาพ',
  WPTPDCI_QQ_NAME: 'ยกเว้นเบี้ยหลัก กรณี ผอป. ทุพพลภาพ หรือ เป็นโรคร้ายแรง',
  ULTIMATE_GROWTH_QQ_SELECT_PLAN: 'ระยะเวลาคุ้มครอง/ระยะเวลาชำระเบี้ยประกันภัย',
  ULTIMATE_GROWTH_CODE_2010: 'E20F10',
  ULTIMATE_GROWTH_CODE_2515: 'E25F15',
  ULTIMATE_GROWTH_CODE_2525: 'E25F25',
  ULTIMATE_GROWTH_QQ_2010: '20/10',
  ULTIMATE_GROWTH_QQ_2515: '25/15',
  ULTIMATE_GROWTH_QQ_2525: '25/25',
  QQ_SELECT_PLAN: 'แผนแบบประกัน',
  CANCERX5_1_PLANCODE: 'CANCERX5-1',
  CANCERX5_2_PLANCODE: 'CANCERX5-2',
  CANCERX5_3_PLANCODE: 'CANCERX5-3',
  CANCERX5_1_QQ_PLANNAME: 'แผน 200,000',
  CANCERX5_2_QQ_PLANNAME: 'แผน 400,000',
  CANCERX5_3_QQ_PLANNAME: 'แผน 1,000,000',
  NOTE: 'หมายเหตุ',
  TOTAL: 'รวม',
  EACH_TOTAL_PREMIUM: 'เบี้ยประกันภัยรวม',
  POLICY_VALUE_TABLE_NOTE_1:
    'เงินค่าเวนคืนกรมธรรม์ประกันภัยท่ีแสดงไว้ในตารางเป็นจํานวนเงินที่หักเงินจ่ายคืน (ถ้ามี) ออกแล้ว',
  POLICY_VALUE_TABLE_NOTE_2:
    'กรณีท่ีมีการกู้เงินตามเงินกรมธรรม์ มูลค่าเวนคืนเงินสดจะลดลงตามจํานวนเงินกู้และอัตราดอกเบี้ยเงินกู้',
  DEATH_COVERAGE: 'ความคุ้มครองกรณีเสียชีวิต',
  IN_CASE_DEATH_COVERAGE_END_OF_POLICY: 'กรณีเสียชีวิต (ณ สิ้นปีกรมธรรม์)',
  INCLUDE_DIVIDEND: 'รวมเงินปันผล',
  DIVIDEND: 'เงินปันผล',
  MATURITY_DATE: 'ณ วันครบกำหนดสัญญา',
  ISHIELD_POLICY_TABLE_INFO:
    'เบี้ยประกันภัยที่ชำระมาแล้วทั้งหมดมากกว่าจำนวนเงินเอาประกันภัย เมื่อผู้เอาประกันภัยอายุ {{age}} ปี หรือ ตั้งแต่ปีกรมธรรม์ที่ {{yearEndPolicy}} เป็นต้นไป',
  CASH_DROP_VALUE: 'เงินจ่ายคืนและเงินครบกำหนดสัญญา (ณ สิ้นปี) ตามกรมธรรม์ประกันภัย',
  INCASE_OF_SAVING_WITH_COMPANY: 'เงินจ่ายคืนสะสม ด้วยอัตราดอกเบี้ย',
  INCASE_OF_CASH: 'กรณีรับเป็นเงินสด',
  LOW_LEVEL: 'ขั้นต่ำ',
  MEDIUM_LEVEL: 'ระดับกลาง',
  HIGH_LEVEL: 'ระดับสูง',
  PERCENTS_PER_YEAR: '{{ percent }}% ต่อปี',
  PREMIUM_PER_YEAR: 'เบี้ยประกันภัยต่อปี',
  POLICY_SURRENDER_VALUE: 'มูลค่าเวนคืนกรมธรรม์** (ณ สิ้นปีกรมธรรม์)',
  SURRENDER_VALUE_END_OF_YEAR: 'เงินค่าเวนคืนกรมธรรม์ประกันภัย (ณ สิ้นปีกรมธรรม์)',
  IN_CASE_SURRENDER_VALUE_END_OF_POLICY: 'กรณีเวนคืนกรมธรรม์ประกันภัย (ณ สิ้นปีกรมธรรม์)',
  GIO_END_OF_POLICY: 'ปีกรมธรรม์ที่',
  GIO_CUMULATIVE_PREMIUM_PER_YEAR: 'เบี้ยประกันภัยสะสม',
  GIO_CASHDROP_VALUE_1: 'เงินจ่ายคืนตาม',
  GIO_CASHDROP_VALUE_2: 'กรมธรรม์ประกันภัยและ',
  GIO_CASHDROP_VALUE_3: 'เงินครบกำหนดสัญญา',
  GIO_DEATH_BENEFIT_OF_POLICY_1: 'ความคุ้มครอง',
  GIO_DEATH_BENEFIT_OF_POLICY_2: 'การเสียชีวิต',
  GIO_CUMULATIVE_DEATH_BENEFIT_1: 'รวมเงินจ่ายคืน',
  GIO_CUMULATIVE_DEATH_BENEFIT_2: 'ระหว่างสัญญา',
  GIO_CUMULATIVE_DEATH_BENEFIT_3: 'ที่จ่ายไปแล้ว',
  SURRENDER_CASH_VALUE: 'มูลค่าเวนคืนกรมธรรม์',
  GIO_POLICY_SURRENDER_VALUE_2: 'ของสัญญาหลัก',
  IN_CASE_INVESTMENT_RATE: 'กรณีดัชนีอ้างอิงมีผลตอบแทนจากการลงทุนเฉลี่ยที่ {{rate}}% ต่อปี',

  // Basic Plan
  BASIC_PLAN_BENEFITS: 'ผลประโยชน์ที่ท่านจะได้รับจากสัญญาหลัก',
  BASIC_PLAN_COVERAGE_BENEFITS: 'ผลประโยชน์ความคุ้มครองสัญญาหลัก',
  BASIC_PLAN_DEATH_BENEFIT: 'ผลประโยชน์กรณีเสียชีวิต',

  // -- profile-snapshot
  COVERAGE_PERIOD: 'ระยะเวลาคุ้มครอง',
  PAYMENT_PERIOD: 'ระยะเวลาชำระเบี้ย',
  SUM_ASSURED: 'จำนวนเงินเอาประกันภัย',
  BASIC_PLAN_SUM_ASSURED: 'จำนวนเงินเอาประกันภัยสัญญาหลัก',
  TOTAL_PREMIUM_FIRST_PREMIUM: 'เบี้ยประกันภัยรวมงวดแรก',
  COVERAGE_PERIOD_RETIREMENT_SUFFIX: 'ครบอายุ 85 ปี',
  COVERAGE_PERIOD_BUMNAN_READY_SUFFIX: 'ครบอายุ 88 ปี',
  COVERAGE_PERIOD_ISMART_SUFFIX: 'ครบอายุ 80 ปี',

  // --summary-table
  SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS: 'สรุปสัญญาหลักและสัญญาเพิ่มเติม',
  SUMMARY_OF_MAIN_CONTRACTS: 'สรุปสัญญาหลัก',
  CONTRACTS: 'แบบประกัน',
  BASIC_PLAN_RIDER: 'สัญญาหลัก/สัญญาเพิ่มเติม',
  SUMMARY_TABLE_WP_SUMASSURED: 'ตามเงื่อนไขกรมธรรม์',
  SUMMARY_TABLE_MEK_SUMASSURED: 'ตามที่ระบุในสรุปผลประโยชน์สำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล',
  SUMMARY_OF_MAIN_CONTRACTS_PA: 'ตารางแสดงผลประโยชน์',
  BASIC_PLAN_RIDER_PA: 'ความคุ้มครอง',

  SUMMARY_TABLE_DISCLAIMER_HAS_NON_LEVEL_RIDER:
    'บริษัทฯ ขอสงวนสิทธิ์ไม่ต่ออายุสัญญาเพิ่มเติมนี้ในวันครบรอบปีกรมธรรม์ โดยแจ้งให้ผู้เอาประกันภัยทราบล่วงหน้าเป็นลายลักษณ์อักษรไม่น้อยกว่า 30 วัน',
  SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_TITLE:
    'สัญญาเพิ่มเติมนี้ จะต่ออายุเมื่อครบรอบปีกรมธรรม์ประกันภัย เว้นแต่กรณีใดกรณีหนึ่งดังต่อไปนี้ บริษัทจะสงวนสิทธิ์ไม่ต่ออายุสัญญาเพิ่มเติม',
  SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_FIRST:
    'ในกรณีที่มีหลักฐานว่าผู้เอาประกันภัยไม่แถลงข้อความจริงตามใบคำขอเอาประกันภัย หรือคำขอต่ออายุ (Reinstatement) ใบแถลงสุขภาพ และข้อแถลงเพิ่มเติมอื่นใดที่เกี่ยวข้องกับการทำสัญญาเพิ่มเติมการประกันภัยสุขภาพ ซึ่งเป็นสาระสำคัญที่อาจทำให้บริษัทเรียกเบี้ยประกันภัยสูงขึ้น หรือบอกปัดไม่รับทำสัญญา หรือรับประกันภัยแบบมีเงื่อนไข',
  SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_SECOND:
    'ผู้เอาประกันภัยเรียกร้องผลประโยชน์จากการที่ตนให้มีการรักษาการบาดเจ็บหรือการป่วยโดยไม่มีความจำเป็นทางการแพทย์',
  SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_THIRD:
    'ผู้เอาประกันภัยเรียกร้องผลประโยชน์ค่าชดเชยจากการนอนพักรักษาตัวในโรงพยาบาล รวมกันทุกบริษัทเกินกว่ารายได้ที่แท้จริง',
  SUMMARY_TABLE_DISCLAIMER_HEALTH_RIDER_THIRD_2:
    'การไม่ต่ออายุสัญญาเพิ่มเติมนี้ด้วยเหตุข้างต้น บริษัทจะแจ้งให้ผู้เอาประกันภัยทราบล่วงหน้าเป็นลายลักษณ์อักษรไม่น้อยกว่า 30 วัน',

  RIDER_BENEFIT_DAY_OR_TIME: 'จำนวนสูงสุด (วันหรือครั้ง)',
  RIDER_TOTAL_BENEFIT_BAHT: 'ผลประโยชน์สูงสุด (บาท)',
  RIDER_TOTAL_BENEFIT_BAHT_HAVE_STAR: 'ผลประโยชน์สูงสุด * (บาท)',
  RIDER_ENDORSE_ADDITIONAL_BENEFIT: 'บันทึกสลักหลัง ผลประโยชน์ เพิ่มเติม',
  RIDER_SUMMARY_TITLE: 'ผลประโยชน์{{riderDescription}} ({{riderName}})',
  RIDER_SUMMARY_TITLE_WITH_CODE: 'ความคุ้มครองชีวิต (เพิ่มจากสัญญาหลัก) ({{riderSelectedPlanCode}})',
  RIDER_SUMMARY_TITLE_AP_ECARE: 'อุบัติเหตุและค่ารักษาพยาบาล (AP & ECARE)',
  RIDER_SUMMARY_TITLE_WITHOUT_CODE: '{{riderDescription}}',
  RIDER_SUMMARY_TITLE_DEFAULT: '{{riderDescription}} ({{riderName}})',

  // Disclaimers
  LEGAL_DISCLAIMER: 'ข้อกำหนดและเงื่อนไข',
  POLICY_MAY_CHANGE: 'เบี้ยประกันภัยข้างต้นอาจมีการเปลี่ยนแปลงเนื่องจาก',
  INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT:
    'เบี้ยประกันภัยต่อปี อาจมีการปรับเพิ่มขึ้นเนื่องจากเบี้ยประกันภัยของสัญญาเพิ่มเติม',
  INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT_DETAIL:
    'เบี้ยประกันภัยสัญญาเพิ่มเติมในปีต่ออายุที่มีผลบังคับใช้ในปัจจุบันสามารถขอรายละเอียดได้จากตัวแทนประกันชีวิต/นายหน้าประกันชีวิต โดยเบี้ยประกันภัยของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจากอายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจาก\nประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้',
  AGE_HEALTH_OR_CAREER: 'อายุ สุขภาพ หรือขั้นอาชีพ',
  PRELIMINARY_OFFER_MAY_CHANGE:
    'บริษัทฯ ขอสงวนสิทธิ์และลูกค้ารับทราบว่ารายละเอียดตามใบข้อเสนอนี้เป็นเพียงรายละเอียดเบื้องต้น และอาจมีการเปลี่ยนแปลงภายหลังจากวันที่ออกเอกสาร',
  OFFER_SALE_PERIOD:
    'โปรแกรมใบข้อเสนอนี้ใช้ประกอบการเสนอขายตั้งแต่ {{ startOffer }} ถึง {{ endOffer }} หรือ ตามประกาศยกเลิกการใช้จากบริษัทฯ (แล้วแต่ว่าระยะเวลาใดสั้นกว่า)',
  DISCLAIMER_RIDER_PREMIUM:
    'สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปี สามารถต่อสัญญาได้ตามระยะเวลาชำระเบี้ยประกันภัยที่ระบุข้างต้น โดยเบี้ยประกันภัยปีต่ออายุของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  DISCLAIMER_MEK_RIDER_PREMIUM:
    'สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปี จนถึงรอบปีกรมธรรม์ที่ผู้เอาประกันภัยมีอายุ 10 ปี โดยเบี้ยประกันภัยปีต่ออายุของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  DISCLAIMER_OCCUPATION_PREMIUM:
    'เบี้ยประกันภัยในเอกสารนี้ คำนวณตามขั้นอาชีพของผู้เอาประกันภัย ซึ่งอาจเปลี่ยนแปลงได้ หลังจากผ่านขั้นตอนการพิจารณารับประกันภัยของบริษัทฯ',
  DISCLAIMER_AGE_PREMIUM: 'อัตราเบี้ยประกันภัยเปลี่ยนแปลงได้ตามอายุที่เพิ่มขึ้น',
  DISCLAIMER_SPECIAL_OCCUPATION_PREMIUM:
    'สำหรับพ่อบ้าน, แม่บ้าน, นักบวช, พระ จำนวนเงินเอาประกันภัยของสัญญาเพิ่มเติมขึ้นอยู่กับกฎเกณฑ์การรับประกันของบริษัทฯ ในขณะนั้น',
  DISCLAIMER_OVER_56_MUST_HAVE_MEDICAL_EXAM:
    'ผู้เอาประกันที่อายุ 56 ปีขึ้นไป ต้องตรวจสุขภาพโดยแพทย์แต่งตั้งของบริษัททุกราย',
  DISCLAIMER_UNLIMITED_CLAIM_UNDER_100: 'สามารถเคลมได้ไม่จํากัดจํานวนครั้ง แต่ไม่เกิน 100% ของจํานวนเงินเอาประกันภัย',
  DISCLAIMER_ORGAN_DEFINITION:
    'อวัยวะเดียวกัน หมายถึง อวัยวะที่มีข้างซ้ายและข้างขวา หรืออวัยวะที่มีลักษณะคล้ายกัน และทํางานคล้ายกัน เช่นอวัยวะดังต่อไปนี้ ถือเป็นอวัยวะที่มีการทํางานคล้ายกันและให้ถือเป็นอวัยวะเดียวกัน',
  DISCLAIMER_ORGAN_OVARY: 'รังไข่ (Ovary) และท่อนําไข่ (Fallopian tube)',
  DISCLAIMER_ORGAN_VAGINA: 'ช่องคลอด (Vagina) และปากช่องคลอด (Vulva)',
  DISCLAIMER_ORGAN_COLON: 'ลําไส้ใหญ่ (Colon) และลําไส้ตรงหรือลําไส้ใหญ่ส่วนปลาย (Rectum)',
  DISCLAIMER_ORGAN_STOMACH: 'กระเพาะอาหาร (Stomach) และหลอดอาหาร (Esophagus)',
  DISCLAIMER_ORGAN_SKIN: 'ผิวหนังทั่วร่างกาย (Skin)',
  DISCLAIMER_INFORCE_OR_REINSTATEMENT:
    'นับจากวันเริ่มมีผลคุ้มครองสัญญาเพิ่มเติมนี้ หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้ายแล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
  DISCLAIMER_RIDER_BENEFIT:
    'ผลประโยชน์ต่อวันของสัญญาเพิ่มเติม {{ riderCode }} ไม่สามารถเกิน 1 เท่าของรายได้ต่อวัน ทางบริษัทอาจจะขอสลิปเงินเดือนของผู้เอาประกันเพื่อตรวจสอบภายหลัง',
  DISCLAIMER_AGENT_PROTECTION:
    'สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปี โดยเบี้ยประกันภัยปีต่่ออายุของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  DISCLAIMER_ADDITIONAL_AGENT_PROTECTION:
    'สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปี โดยเบี้ยประกันภัยปีต่่ออายุของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์ (เฉพาะสัญญาเพิ่มเติมโรคร้ายแรงคุ้มครองเริ่มต้น)',
  DISCLAIMER_ADDITIONAL_AGENT_ESCI:
    'สัญญาเพิ่มเติมโรคร้ายแรงคุ้มครองเริ่มต้น สามารถต่ออายุได้ถึงอายุ 84 ปี ทั้งนี้ต้องไม่เกินระยะเวลาเอาประกันภัยของกรมธรรม์ประกันชีวิตที่สัญญาเพิ่มเติมนี้แนบท้ายอยู่',
  DISCLAIMER_ADDITIONAL_MHP_RIDER:
    'หมายเหตุ : สัญญาเพิ่มเติม{{&title}} สามารถต่ออายุได้ถึงอายุ {{coveragePeriod}} ปี ทั้งนี้ ต้องไม่เกินระยะเวลาเอาประกันภัยของกรมธรรม์ประกันชีวิตที่สัญญาเพิ่มเติมนี้แนบท้ายอยู่',
  DISCLAIMER_ADDITIONAL_MCI_RIDER:
    'หมายเหตุ : สัญญาเพิ่มเติม{{&title}} สามารถต่ออายุได้ถึงอายุ 98 ปี ทั้งนี้ ต้องไม่เกินระยะเวลาเอาประกันภัยของกรมธรรม์ประกันชีวิตที่สัญญาเพิ่มเติมนี้แนบท้ายอยู่',
  DISCLAIMER_ADDITIONAL_RIDER:
    'สัญญาเพิ่มเติม{{&title}} สามารถต่ออายุได้ถึงอายุ {{coveragePeriod}} ปี ทั้งนี้ต้องไม่เกินระยะเวลาเอาประกันภัยของกรมธรรม์ประกันชีวิตที่สัญญาเพิ่มเติมนี้แนบท้ายอยู่',
  DISCLAIMER_MAX_HOSPITAL_BENEFIT:
    'ผลประโยชน์ค่าชดเชยรายวันกรณีเข้ารักษาตัวในโรงพยาบาล จำนวนสูงสุด (1+2+3) ไม่เกิน 365 วัน',
  DISCLAIMER_FORCE_MAJEURE:
    'หมายเหตุ ทั้งนี้ความคุ้มครองการจลาจล ฆาตกรรม ลอบทำร้าย และสงครามกลางเมือง จะเป็นไปตามกฎเกณฑ์การรับประกันของบริษัทฯ',
  DISCLAIMER_SAVING_LEGAL_SUMMARY: 'เบี้ยประกันภัยข้างต้นอาจมีการเปลี่ยนแปลงเนื่องจาก สุขภาพหรือขั้นอาชีพ',

  PRELIMINARY_SAVING_OFFER_MAY_CHANGE:
    'บริษัทฯ ขอสงวนสิทธิ์การรับประกันภัยและลูกค้ารับทราบว่ารายละเอียดตามใบข้อเสนอนี้เป็นเพียงรายละเอียดเบื้องต้น และอาจมีการเปลี่ยนแปลงภายหลังจากวันที่ออกเอกสาร',
  // rider specific benefits
  WP_BENEFIT:
    'กรณีทุพพลภาพสิ้นเชิงก่อนอายุ {{riderCoveragePeriod}} ปี บริบูรณ์ จะได้รับการยกเว้นเบี้ยประกันภัยของสัญญาหลัก โดยผลประโยชน์จากสัญญาหลักยังเหมือนเดิม',
  WPD_BENEFIT:
    'กรณีผู้ชำระเบี้ยประกันภัยเสียชีวิต บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักในอนาคต จนกว่าจะครบกำหนดระยะเวลาคุ้มครองของสัญญาเพิ่มเติมนี้',
  WPDD_BENEFIT_DEATH_PERMANENTLY_DISABLED: 'กรณีผู้ชำระเบี้ยประกันภัยเสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง',
  WPDD_BENEFIT_PREMIUM_WAIVER:
    'บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักในอนาคต จนกว่าจะครบกำหนดระยะเวลาคุ้มครองของสัญญาเพิ่มเติม หรือการทุพพลภาพสิ้นสุดลง แล้วแต่เหตุการณ์ใดจะเกิดขึ้นก่อน',
  WPDD_BENEFIT_AGE_CLAUSE: 'การทุพพลภาพถาวรสิ้นเชิง จะต้องเกิดขึ้นก่อนอายุ {{riderCoveragePeriod}} ปีบริบูรณ์',
  PLR_PLS_BENEFIT: 'คุ้มครองการเสียชีวิตทุกกรณีจาก {{ riderCode }} ภายในระยะเวลา {{ riderYearsOfCoverage }} ปี',
  WPC_BENEFIT:
    'การจ่ายผลประโยชน์ดังกล่าวจะเกิดขึ้นก็ต่อเมื่อวันที่เก็บตัวอย่างชิ้นเนื้อเพื่อนำไปตรวจทางพยาธิวิทยาได้พ้นระยะเวลารอคอย 60 วัน',
  WPTPD_BENEFIT:
    'กรณีผู้เอาประกันภัยตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก',
  WPTPDCI_BENEFIT:
    'กรณีผู้เอาประกันภัยตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง หรือเจ็บป่วยจาก 50 โรคร้ายแรงระยะรุนแรงที่คุ้มครอง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก',
  WPTPDCI_BENEFIT_BI:
    'กรณีผู้เอาประกันภัยตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง หรือเจ็บป่วยจาก 50 โรคร้ายแรงระยะรุนแรงที่คุ้มครอง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก\nทั้งนี้ จะไม่คุ้มครองการป่วยด้วยโรคร้ายแรงระยะรุนแรงดังกล่าว ที่เกิดขึ้นภายในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 60 วัน นับแต่วันเริ่ม\nมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันเริ่มมีผลคุ้มครองตามการต่ออายุครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยของ\nสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง',

  // -- SUMMARY FOOTER -- //
  LIFE_TREASURE_FOOTER:
    'ไลฟ์เทรเชอร์ เป็นชื่อทางการตลาด ชื่อของแบบประกันภัยที่ปรากฎในกรมธรรม์ คือ ไลฟ์เรดดี้ (ไม่มีเงินปันผล)',
  PLEASE_READ_NOTICE:
    'เอกสารประกอบการเสนอขายนี้เป็นข้อมูลเบื้องต้นของแบบประกันภัย ผลประโยชน์ ความคุ้มครองและข้อยกเว้น เป็นไปตามที่กำหนดในกรมธรรม์ ผู้ซื้อควรทำความเข้าใจรายละเอียด ความคุ้มครองและเงื่อนไขก่อนตัดสินใจทำประกันภัยทุกครั้ง',
  COMPANY_NAME: 'บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)',
  COMPANY_ADDRESS_1: '9 อาคาร จี ทาวเวอร์ แกรนด์ รามา 9 ชั้น 1, 22-27 ถนนพระราม 9',
  COMPANY_ADDRESS_2: 'แขวงห้วยขวาง เขตห้วยขวาง กรุงเทพมหานคร 10310',
  COMPANY_TELEPHONE_NUMBER: 'โทร 02-044-4000  โทรสาร 02-044-4032',
  CALL_CENTER: 'ศูนย์ลูกค้าสัมพันธ์ 1159',
  COMPANY_WEB_SITE: 'www.krungthai-axa.co.th',
  REGISTRATION_NUMBER: 'ทะเบียนเลขที่ 0107555000376',
  BRANCH_NAME_AGENT: 'สำนักงาน',
  BRANCH_NAME_BANC: 'ชื่อสาขา',
  BRANCH_UNIT_AGENT: 'หน่วย / ภาค',
  BRANCH_UNIT_BANC: 'เขต',
  TELEPHONE_NUMBER: 'โทรศัพท์',
  EMAIL: 'อีเมล',
  PRESENT_BY: 'นำเสนอโดย',
  PAGE_NUMBER: 'หน้า',
  DATE_INFORMATION_FOOTER: 'AdvisorZone Version {{appVersion}} วันที่ {{datetime}} น.',
  DATE_DISCLAIMER_FOOTER:
    'โปรแกรมใบข้อเสนอนี้ใช้ประกอบการเสนอขายตั้งแต่ {{startDate}} ถึง {{endDate}} หรือ ตามประกาศยกเลิกการใช้จากบริษัทฯ (แล้วแต่ระยะเวลาใดจะเกิดขึ้นก่อน)',
  DISCLAIMER_FOOTER: 'เอกสารฉบับนี้เป็นเพียงตัวอย่างการคำนวณเบี้ยประกันภัย ไม่ใช่เอกสารประกอบการขาย',

  // payment channels page
  PAYMENT_CHANNELS: 'ช่องทางการชำระเงิน',
  PAY_CHANNELS: 'ช่องทางชำระเงิน',
  PAYMENT_CHANNELS_FOR_PREMIUM: 'ช่องทางรับชำระเบี้ยประกันภัย',
  PAYMENT_TERMS:
    'เพื่อให้กรมธรรม์ประกันชีวิตมีผลคุ้มครองโดยสมบูรณ์และผู้เอาประกันภัยได้รับประโยชน์สูงสุด ผู้เอาประกันภัยมีหน้าที่ในการนำส่งเบี้ยประกันภัย ซึ่งตัวแทนหรือนายหน้าประกันชีวิตมาเก็บเบี้ยประกันภัยเป็นการให้บริการเท่านั้น โดยบริษัทฯ ได้อำนวยความสะดวกในการชำระเบี้ยประกันภัย ผ่านทางช่องทางต่างๆ ดังนี้',
  PAYMENT_BANK_COUNTER: 'ชำระผ่านเคาน์เตอร์ธนาคาร',
  PAYMENT_BANK_COUNTER_TERMS:
    'ผู้เอาประกันภัยสามารถชำระเบี้ยประกันภัยเพื่อเข้าบัญชี บริษัทกรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) ผ่านเคาน์เตอร์ของทางธนาคาร ดังนี้',
  PAYMENT_COMPANY: 'ชำระที่บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)',
  PAYMENT_COMPANY_TERMS:
    'สำนักงานใหญ่, สาขาขอนแก่น, สาขาเชียงใหม่, สาขาพัทยา, สาขาสุราษฎร์ธานี และสาขาหาดใหญ่ โดยเงินสด',
  PAYMENT_AGENT: 'ชำระผ่านตัวแทน',
  PAYMENT_BANC: 'ชำระที่สำนักงานตัวแทน',
  PAYMENT_AGENT_OR_BANK_TERMS: 'โดยเงินสด ซึ่งผู้เอาประกันภัยจะได้รับใบรับเงินชั่วคราว ณ วันที่ชำระเงินทันที',
  PAYMENT_AGENT_OR_BANK: 'ชำระผ่านตัวแทน หรือ ชำระที่สำนักงานตัวแทน',
  PAYMENT_TYPES: 'ประเภทการชำระเบี้ยประกันภัย',
  PAYMENT_TYPES_CASH: 'ชำระเงินสด',
  PAYMENT_TYPES_ATM: 'ชำระผ่านบัตร ATM',
  PAYMENT_TYPES_ATM_TERMS:
    'ของธนาคารกรุงไทย, ธนาคารกสิกรไทย (Comp.Code 33528 : รหัสบริษัท 33528), ธนาคารกรุงเทพ (Comp. Code: 24556), ธนาคารไทยพาณิชย์, ธนาคารกรุงศรีอยุธยา และธนาคารทหารไทยธนชาต โดยผ่านเครื่อง ATM ของธนาคารเจ้าของบัตรทุกสาขาทั่วประเทศ',
  PAYMENT_TYPES_INTERNET_BANK: 'ชำระผ่าน Internet Banking',
  PAYMENT_TYPES_INTERNET_BANK_TERMS:
    'ของธนาคารกรุงไทย (KTB Online), ธนาคารกสิกรไทย, ธนาคารกรุงเทพ, ธนาคารไทยพาณิชย์, ธนาคารกรุงศรีอยุธยา และธนาคารทหารไทยธนชาต โดยทำรายการชำระค่าสินค้าและบริการ โดยเลือกหน่วยงานที่รับชำระเป็น บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)',
  PAYMENT_FEE: 'ค่าธรรมเนียมการชำระเงิน',
  PAYMENT_FREE_OF_CHARGE: 'ทุกช่องทางการชำระเงินไม่เสียค่าธรรมเนียม',

  BANKS: {
    KRUNGTHAI: 'ธ. กรุงไทย : Comp. Code 6056 (TRC.TSTDCA)',
    KRUNGSRI: 'ธ. กรุงศรีอยุธยา : เลขที่บัญชี 001-0-15133-6 (Payment Sys.)',
    SCB: 'ธ. ไทยพาณิชย์ : Comp. Code 0622 (049, ถนนวิทยุ)',
    TMB: 'ธ. ทหารไทย : Comp. Code : 668 / Service Code : 0154',
    TTB: 'ธ. ทหารไทยธนชาต : Comp. Code : 668 / Service Code : 0154',
    KASIKORN: 'ธ. กสิกรไทย : เลขที่บัญชี 709-1-03217-6',
    THANACHART: 'ธ. ธนชาต : SERVICE CODE : 0618',
    BANGKOK: 'ธ. กรุงเทพ : (Branch Code 205) Service Code: AXA',
    BAAC: 'ธ. เพื่อการเกษตรและสหกรณ์การเกษตร : Service Code: AXA1',
    KRUNGTHAI_NAME: 'ธนาคารกรุงไทย',
    KRUNGSRI_NAME: 'ธนาคารกรุงศรีอยุธยา',
    TMB_NAME: 'ธนาคารทหารไทย',
    TTB_NAME: 'ธนาคารทหารไทยธนชาต',
    KASIKORN_NAME: 'ธนาคารกสิกรไทย',
    THANACHART_NAME: 'ธนาคารธนชาต',
    BANGKOK_NAME: 'ธนาคารกรุงเทพ',
    BAAC_NAME: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
    KRUNGTHAI_CHANNEL: 'Comp. Code : 6056',
    KRUNGSRI_CHANNEL: 'เลขที่บัญชี 001-0-15133-6',
    SCB_CHANNEL: 'Comp. Code : 0622',
    TMB_CHANNEL: 'Comp. Code : 0668',
    TTB_CHANNEL: 'Comp. Code : 0668',
    KASIKORN_CHANNEL: 'เลขที่บัญชี 709-1-03217-6',
    THANACHART_CHANNEL: 'Service Code : 0618',
    BANGKOK_CHANNEL: 'Service Code : AXA',
    BAAC_CHANNEL: 'Comp. Code : AXA1',
  },

  BANK_BYBILL: {
    KRUNGTHAI: 'ธนาคารกรุงไทย',
    KRUNGTHAI_CHANNEL: 'Comp. Code 6056',
    TMB: 'ธนาคารทหารไทย',
    TMB_CHANNEL: 'Comp. Code : 0668',
    KRUNGSRI: 'ธนาคารกรุงศรีอยุธยา',
    KRUNGSRI_CHANNEL: 'เลขที่บัญชี 001-0-15133-6',
    THANACHART: 'ธนาคารธนชาต',
    THANACHART_CHANNEL: 'Service Code : 0618',
    KASIKORN: 'ธนาคารกสิกรไทย',
    KASIKORN_CHANNEL: 'เลขที่บัญชี 709-1-03217-6',
    BAAC: 'ธนาคารเพื่อการเกษตรและสหกรณ์',
    BAAC_CHANNEL: 'Comp. code : AXA1',
    BANGKOK: 'ธนาคารกรุงเทพ',
    BANGKOK_CHANNEL: 'Service Code : AXA',
    TTB: 'ธนาคารทหารไทยธนชาต',
    TTB_CHANNEL: 'Comp. Code : 0668',
  },

  BANK_BYATM: {
    KRUNGTHAI: 'ธนาคารกรุงไทย',
    KRUNGTHAI_CHANNEL: 'Comp. Code 6056',
    SCB: 'ธนาคารไทยพาณิชย์',
    SCB_CHANNEL: 'Comp. Code : 0622',
    KRUNGSRI: 'ธนาคารกรุงศรีอยุธยา',
    KRUNGSRI_CHANNEL: 'Comp. code 41336',
    TMB: 'ธนาคารทหารไทย',
    TMB_CHANNEL: 'Comp. Code : 0668',
    KASIKORN: 'ธนาคารกสิกรไทย',
    KASIKORN_CHANNEL: 'รหัสบริษัท 33528',
    THANACHART: 'ธนาคารธนชาต',
    THANACHART_CHANNEL: 'Service Code : 0618',
    BANGKOK: 'ธนาคารกรุงเทพ',
    BANGKOK_CHANNEL: 'Comp. Code : 24556',
    TTB: 'ธนาคารทหารไทยธนชาต',
    TTB_CHANNEL: 'Comp. Code : 0668',
  },
  PAYMENT_TERM_ORDINARY:
    'เพื่อให้กรมธรรม์ประกันชีวิตมีผลคุ้มครองโดยสมบูรณ์และผู้เอาประกันภัยได้รับประโยชน์สูงสุด ผู้เอาประกันภัยมีหน้าที่ในการนำส่งเบี้ยประกันภัย ซึ่งตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท มาเก็บเบี้ยประกันภัยเป็นการให้บริการเท่านั้น โดยบริษัทฯ ได้อำนวยความสะดวกในการชำระเบี้ยประกันภัย ผ่านช่องทางต่าง ๆ ดังนี้',
  PAYMENT_CHANNEL_ORDINARY_1:
    'ชำระผ่านตัวแทนหรือเคาน์เตอร์ธนาคารกรุงไทย (สำหรับเงินสดเฉพาะที่เคาน์เตอร์ธนาคารกรุงไทย) หรือตั๋วแลกเงิน หรือแคชเชียร์เช็ค หรือเช็คสั่งจ่าย “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)” โดยผู้เอาประกันภัยจะได้รับใบรับเงินชั่วคราวงวดแรกทันที หลังจากชำระเงินค่าเบี้ยประกันภัย และใบรับเงินชั่วคราวดังกล่าวจะต้องไม่หมดอายุ',
  PAYMENT_CHANNEL_ORDINARY_2:
    'ชำระผ่านแผนกรับชำระเบี้ย ณ ที่ทำการสาขา หรือที่สำนักงานใหญ่ของบริษัทฯ เป็นเงินสด โดยกรณีชำระเป็นเงินสดชำระได้ไม่เกิน \n100,000 บาท หรือตั๋วแลกเงิน หรือแคชเชียร์เช็ค หรือเช็คสั่งจ่าย “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)” หรือบัตรเครดิต',
  PAYMENT_CHANNEL_ORDINARY_2_WITHOUT_CREDIT:
    'ชำระผ่านแผนกรับชำระเบี้ย ณ ที่ทำการสาขา หรือที่สำนักงานใหญ่ของบริษัทฯ เป็นเงินสด หรือตั๋วแลกเงิน หรือแคชเชียร์เช็ค หรือเช็คสั่งจ่าย “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)”',
  PAYMENT_CHANNEL_ORDINARY_3:
    'ชำระผ่านเคาน์เตอร์ของธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารกสิกรไทย ธนาคารทหารไทยธนชาต ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร ทุกสาขาทั่วประเทศไทย ผ่านระบบ Bill payment โดยระบุชื่อบัญชี “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)” และแจ้ง Comp.code หรือ Service code  โดยใช้แบบฟอร์มใบนำฝากของธนาคาร, “ใบรับชำระค่าสาธารณูปโภคและ\nค่าบริการ”, หรือแบบฟอร์มใบนำฝากแบบพิเศษของบริษัทฯ เท่านั้น',
  PAYMENT_CHANNEL_ORDINARY_3_SUB_TITLE: 'ชำระผ่านระบบ Bill payment',
  PAYMENT_CHANNEL_ORDINARY_4:
    'ชำระโดยการโอนเงินผ่านตู้ ATM ของธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารไทยพาณิชย์ ธนาคารกสิกรไทย ธนาคารทหารไทยธนชาต ทั่วประเทศ',
  PAYMENT_CHANNEL_ORDINARY_5:
    'ชำระโดยการโอนเงินผ่านโมบายแอปพลิเคชันของธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารไทยพาณิชย์ ธนาคารกสิกรไทย ธนาคารทหารไทยธนชาต อ้างอิง Comp. code หรือ รหัสบริษัท ตามข้อ 4',
  PAYMENT_CHANNEL_ORDINARY_6:
    'ชำระโดยการโอนเงินผ่านอินเตอร์เน็ตแบงกิ้งของธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา และ ธนาคารกสิกรไทย อ้างอิง Comp. code หรือ รหัสบริษัท ตามข้อ 3 และ 4',
  PAYMENT_CHANNEL_ORDINARY_7:
    'ชำระทางไปรษณีย์เป็นธนาณัติ ระบุชื่อผู้รับในนาม “บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)” และสั่งจ่าย ปณ.นานาเหนือ กรุงเทพฯ',
  PAYMENT_CHANNEL_ORDINARY_8:
    'บริการพิเศษ สำหรับการชำระเบี้ยประกันภัยในงวดถัดไป สามารถชำระโดยหักบัญชีเงินฝากธนาคารประเภทออมทรัพย์หรือกระแสรายวัน ผ่านธนาคารกรุงไทย ธนาคารกรุงเทพ ธนาคารกรุงศรีอยุธยา ธนาคารกสิกรไทย ธนาคารไทยพาณิชย์ ทุกสาขาทั่วประเทศ โดยกรอกหนังสือยินยอมหักบัญชีธนาคาร และแนบสำเนาสมุดบัญชีเงินฝากธนาคารหน้าแรก พร้อมสำเนาบัตรประจำตัวประชาชนของเจ้าของบัญชีมาด้วยในการสมัคร\nทุกครั้ง ทั้งนี้เบี้ยประกันภัยงวดแรกจะไม่สามารถชำระโดยการหักบัญชีธนาคารได้',
  PAYMENT_CHANNEL_ORDINARY_9:
    'บริการพิเศษ สำหรับการชำระเบี้ยประกันภัยในงวดถัดไป สามารถชำระโดยหักบัตรเครดิตอัตโนมัติ ประเภท VISA หรือ MASTER หรือ JCB \nโดยลูกค้าสามารถขอลิงก์เพื่อสมัครบริการหักค่าเบี้ยประกันภัยอัตโนมัติได้ทาง ศูนย์ลูกค้าสัมพันธ์ โทร 1159 ศูนย์บริการครบวงจร \n(One Stop Service) สำนักงานใหญ่ สำนักงานสาขาของบริษัทฯ หรือขอลิงก์ผ่านระบบ Advisor Zone ในขั้นตอนสมัครกรมธรรม์ โดยลูกค้าจะได้รับลิงก์ผ่านช่องทางอีเมลที่ท่านให้ไว้กับทางบริษัทฯ ทั้งนี้เบี้ยประกันภัยงวดแรกจะไม่สามารถชำระโดยการหักบัตรเครดิต\nอัตโนมัติได้',
  // sign page 2022
  SIGN_NOTES_ORDINARY: {
    title: 'การยืนยันการขอทำประกันและรับทราบรายละเอียดผลิตภัณฑ์',
    remark:
      'เพื่อประโยชน์ของท่าน กรุณาศึกษาและทำความเข้าใจในเงื่อนไขความคุ้มครองผลประโยชน์และข้อยกเว้นตามกรมธรรม์ประกันภัย จากเอกสารประกอบการเสนอขายนี้ก่อนการตัดสินใจ',
    notes: [
      'โดยข้าพเจ้าได้รับทราบรายละเอียดดังต่อไปนี้ แล้ว',
      [
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้แนะนำตัวพร้อมกับมีการแสดงเอกสารใบอนุญาตตัวแทน/นายหน้าประกันชีวิต ',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายสิทธิประโยชน์และเงื่อนไขความคุ้มครองตามกรมธรรม์อย่างครบถ้วน',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายว่าการชำระเงินในแต่ละงวดคือการชำระเบี้ยประกันภัย ไม่ได้เป็นการฝากเงินหรือออมเงินกับธนาคาร',
        'ในกรณีที่ข้าพเจ้าต้องการเวนคืนกรมธรรม์ข้าพเจ้าจะได้รับเงินค่าเวนคืนกรมธรรม์ประกันภัยตามที่ได้ระบุไว้ในเอกสารนี้ ซึ่งอาจน้อยกว่า\nเบี้ยประกันภัยที่ข้าพเจ้าได้ชำระมาแล้ว',
        'ข้าพเจ้ารับทราบและเข้าใจว่า ข้าพเจ้ามีความสามารถในการชำระเบี้ยประกันภัยได้ตรงตามกำหนดทุกงวด ตลอดระยะเวลาชำระเบี้ยประกันภัย\nที่ระบุในเอกสารนี้ เพื่อให้กรมธรรม์ประกันชีวิตมีผลคุ้มครองโดยสมบูรณ์และผู้เอาประกันภัยได้รับประโยชน์สูงสุด',
        'การยื่นขอทำประกันฉบับนี้เป็นไปตามความประสงค์และความสมัครใจของข้าพเจ้า',
      ],
    ],
  },
  // sign page
  SIGN_NOTES: {
    title: 'การยืนยันการขอทำประกันและรับทราบรายละเอียดผลิตภัณฑ์',
    remark:
      'เพื่อประโยชน์ของท่าน กรุณาศึกษาและทำความเข้าใจในเงื่อนไขความคุ้มครองผลประโยชน์และข้อยกเว้นตามกรมธรรม์ประกันภัย จากเอกสารประกอบการเสนอขายนี้ก่อนการตัดสินใจ',
    notes: [
      'โดยข้าพเจ้าได้รับทราบรายละเอียดดังต่อไปนี้ แล้ว',
      [
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้แนะนำตัวพร้อมกับมีการแสดงเอกสารใบอนุญาตตัวแทน/นายหน้าประกันชีวิต ',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายสิทธิประโยชน์และเงื่อนไขความคุ้มครองตามกรมธรรม์อย่างครบถ้วน',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายว่าการชำระเงินในแต่ละงวดคือการชำระเบี้ยประกัน ไม่ได้เป็นการฝากเงินหรือออมเงินกับธนาคาร',
        'ในกรณีที่ข้าพเจ้าต้องการเวนคืนกรมธรรม์ข้าพเจ้าจะได้รับมูลค่าเงินเวนคืนเงินสดตามสัดส่วนที่ได้ระบุไว้ในเอกสารนี้ ซึ่งอาจน้อยกว่าเบี้ยประกันภัยที่ข้าพเจ้าได้ชำระมาแล้ว',
        'ข้าพเจ้ารับทราบและเข้าใจว่า ข้าพเจ้ามีความสามารถในการชำระเบี้ยภัยได้ตรงตามกำหนดทุกงวด ตลอดระยะเวลาชำระเบี้ยประกันภัย\nที่ระบุในเอกสารนี้ เพื่อให้กรมธรรม์ประกันชีวิตมีผลคุ้มครองโดยสมบูรณ์และผู้เอาประกันภัยได้รับประโยชน์สูงสุด',
        'การยื่นขอทำประกันฉบับนี้เป็นไปตามความประสงค์และความสมัครใจของข้าพเจ้า',
      ],
    ],
  },
  // sign page S7
  SIGN_NOTES_S7: {
    title: 'การยืนยันการขอทำประกันและรับทราบรายละเอียดผลิตภัณฑ์',
    remark:
      'เพื่อประโยชน์ของท่าน กรุณาศึกษาและทำความเข้าใจในเงื่อนไขความคุ้มครอง ผลประโยชน์และข้อยกเว้นตามกรมธรรม์ประกันภัย จากเอกสารประกอบการเสนอขายนี้ก่อนการตัดสินใจ',
    notes: [
      'โดยข้าพเจ้าได้รับทราบรายละเอียดดังต่อไปนี้ แล้ว',
      [
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้แนะนำตัวพร้อมกับมีการแสดงเอกสารใบอนุญาตตัวแทน/นายหน้าประกันชีวิต ',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายสิทธิประโยชน์และเงื่อนไขความคุ้มครองตามกรมธรรม์อย่างครบถ้วน',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายว่าการชำระเงินในแต่ละงวดคือการชำระเบี้ยประกัน ไม่ได้เป็นการฝากเงินหรือออมเงินกับธนาคาร',
        'ในกรณีที่ข้าพเจ้าต้องการเวนคืนกรมธรรม์ ข้าพเจ้าจะได้รับเงินค่าเวนคืนกรมธรรม์ตามจำนวนที่กำหนดไว้ในตารางมูลค่ากรมธรรม์กับ\nผลประโยชน์อื่นๆ อันพึงจะได้รับ (ถ้ามี) หักด้วยจำนวนหนี้สินใดๆ ที่ค้างชำระอยู่ (ถ้ามี) ซึ่งอาจจะน้อยกว่าเบี้ยประกันภัยที่ข้าพเจ้า\nได้ชำระมาแล้วทั้งหมด',
        'ข้าพเจ้ารับทราบและเข้าใจว่า ข้าพเจ้ามีความสามารถในการชำระเบี้ยภัยได้ตรงตามกำหนดทุกงวด ตลอดระยะเวลาชำระเบี้ยประกันภัย\nที่ระบุในเอกสารนี้ เพื่อให้กรมธรรม์ประกันชีวิตมีผลคุ้มครองโดยสมบูรณ์และผู้เอาประกันภัยได้รับประโยชน์สูงสุด',
        'การยื่นขอทำประกันฉบับนี้เป็นไปตามความประสงค์และความสมัครใจของข้าพเจ้า',
      ],
    ],
  },

  BANC_SIGN_NOTES: {
    title: 'หมายเหตุและข้อโปรดทราบ',
    remark: ['ผู้เอาประกันภัยควรศึกษาและทำความเข้าใจเงื่อนไขความคุ้มครองผลประโยชน์และข้อยกเว้นตามกรมธรรม์ประกันภัย'],
    note: [
      'ผู้เอาประกันภัยได้รับสิทธิในการศึกษาข้อความเงื่อนไขและผลประโยชน์ในกรมธรรม์ประกันชีวิตเป็นระยะเวลา 15 วัน นับจากวันที่ได้รับกรมธรรม์',
      'หากผู้เอาประกันภัยประสงค์จะยกเลิกกรมธรรม์นี้ด้วยเหตุผลใดก็ตาม ผู้เอาประกันภัยสามารถยกเลิกกรมธรรม์ประกันชีวิต โดยการส่งคืนกรมธรรม์มายังบริษัทภายใน 15 วัน นับตั้งแต่วันที่ได้รับกรมธรรม์จากบริษัท และบริษัทจะคืนเบี้ยประกันภัยที่เหลือจากการหักค่าตรวจสุขภาพตามที่จ่ายจริงและค่าใช้จ่ายของบริษัทฉบับละ 500 บาท',
      'เพื่อผลประโยชน์สูงสุดตามเงื่อนไขกรมธรรม์ ผู้เอาประกันภัยควรถือกรมธรรม์จนครบสัญญาประกันภัย',
    ],
  },

  SIGN_DISCLAIMER: {
    RPUL: [
      'เอกสารฉบับนี้เป็นส่วนหนึ่งของเอกสารประกอบการเสนอขายกรมธรรม์ประกันชีวิตแบบไอเวลท์ตี้ (ยูนิตลิงค์) ซึ่งตัวแทนประกันชีวิตที่ได้รับอนุญาตจากบริษัทฯ ที่ได้ขึ้นทะเบียนเป็นตัวแทนประกันชีวิต ขายกรมธรรม์ประกันชีวิตควบการลงทุนแล้ว ได้นำเสนอกรมธรรม์ประกันชีวิตควบการลงทุน (ยูนิต ลิงค์) ได้อธิบายถึงลักษณะ รูปแบบ และ/หรือรายละเอียดของกรมธรรม์ประกันชีวิต รวมถึงเงื่อนไขต่างๆ ภายใต้กรมธรรม์ซึ่งต้องระบุเป็นจำนวนหน่วยที่ต้องการถอนให้แก่ผู้ขอเอาประกันภัยทราบและผู้ขอเอาประกันภัยได้มีความเข้าใจถึงรายละเอียด ข้อกำหนด และเงื่อนไขของกรมธรรม์ประกันชีวิตแบบดังกล่าวเรียบร้อยแล้ว โดยผู้เอาประกันภัยได้ทราบถึงสิทธิในการศึกษาสัญญาของกรมธรรม์เป็นเวลา 15 วัน นับจากวันที่ได้รับกรมธรรม์วันแรกและสามารถเลือกที่จะใช้สิทธิตามที่ระบุไว้ในเอกสารประกอบการขายนี้',
      {
        marginTop: 4,
        fontSize: 13.5,
        text:
          'ผู้เอาประกันภัยควรเลือกชำระเบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวดเท่าที่จำเป็นตามความคุ้มครองการเสียชีวิตที่ต้องการ ทั้งนี้ หากต้องการลงทุนควรชำระเบี้ยประกันภัยเพื่อการลงทุนรายงวด เนื่องจากมีค่าใช้จ่ายที่น้อยกว่า',
        bold: true,
      },
    ],
    SPUL: [
      {
        marginBottom: 57,
        text:
          'ผู้เอาประกันภัยได้ศึกษา และได้รับคำแนะนำจาก ตัวแทน / นายหน้าของ กรุงไทย-แอกซ่าประกันชีวิต โดยได้เข้าใจถึง รายละเอียด ข้อกำหนด และเงื่อนไขของกรมธรรม์ประกันชีวิตนี้เรียบร้อยแล้ว โดยผู้เอาประกันภัยได้ทราบถึงสิทธิในการศึกษาสัญญา ของกรมธรรม์เป็นเวลา 15 วัน นับจากวันที่ได้รับกรมธรรม์วันแรก และสามารถเลือกที่จะใช้สิทธิตามที่ระบุไว้ในเอกสารประกอบการขายนี้',
      },
    ],
    RPUDR: [
      'เอกสารฉบับนี้เป็นส่วนหนึ่งของกรมธรรม์ประกันชีวิตควบการลงทุน แบบไอลิงค์ (ยูนิตลิงค์) จัดทำขึ้นเพื่อแสดงให้ผู้ขอเอาประกันภัยได้รับทราบและเข้าใจถึงการคำนวณค่าธรรมเนียมกรมธรรม์ต่างๆ รวมถึงผลตอบแทนและเงื่อนไขที่ กำหนดภายใต้กรมธรรม์ดังกล่าว',
      {
        marginTop: 4,
        fontSize: 13.5,
        text: 'คำยืนยันของผู้ขอเอาประกันภัย',
        bold: true,
      },
      'ข้าพเจ้าขอรับรองว่าแทนประกันชีวิต หรือ นายหน้าประกันชีวิตที่ได้รับอนุญาตจากกรุงไทย-แอกซ่าที่ได้ขึ้นทะเบียนเป็นตัวแทนประกันชีวิต นายหน้าประกันชีวิตขายกรมธรรม์ประกันชีวิตควบการลงทุนแล้ว ',
      'ได้นำเสนอกรมธรรม์ประกันชีวิตควบการลงทุน (ยูนิต ลิงค์) และอธิบายถึงลักษณะ รูปแบบ รายละเอียดของกรมธรรม์ รวมถึงเงื่อนไขต่างๆ ภายใต้กรมธรรม์ให้แก่ข้าพเจ้า',
      'และข้าพเจ้าได้มีความเข้าใจถึงรายละเอียด ข้อกำหนด และเงื่อนไขของกรมธรรม์ดังกล่าวเรียบร้อยแล้ว รวมถึงได้ทราบถึงสิทธิของผู้เอาประกันภัยตามที่ระบุไว้ในในเอกสารประกอบการเสนอขายนี้',
    ],
  },

  CUSTOMER_SIGN: 'ลงนาม',
  SIGNATURE_NAME: '( {{name}} )',

  DISTRIBUTOR_SIGN: 'ลงนาม (ตัวแทน)',
  DISTRIBUTOR_SIGNATURE_AGENT_ID: 'รหัสตัวแทน',
  LICENSE_NO: 'เลขที่ใบอนุญาต',
  BANC_AGREEMENT: 'โดยข้าพเจ้าได้รับทราบรายละเอียดดังต่อไปนี้ แล้ว',
  BANC_AGREEMENT_TERMS: [
    'เจ้าหน้าที่ธนาคารได้แนะนำตัวพร้อมกับมีการแสดงเอกสารใบอนุญาตตัวแทนขาย',
    'เจ้าหน้าที่ธนาคารได้อธิบายสิทธิประโยชน์และเงื่อนไขความคุ้มครองตามกรมธรรม์อย่างครบถ้วน',
    'เจ้าหน้าที่ธนาคารได้อธิบายว่าการชำระเงินในแต่ละงวดคือการชำระเบี้ยประกัน ไม่ได้เป็นการฝากเงินหรือออมเงินกับธนาคาร',
    'การยื่นขอทำประกันฉบับนี้เป็นไปตามความประสงค์และความสมัครใจของข้าพเจ้า',
    'ข้าพเจ้ารับทราบและเข้าใจว่า ข้าพเจ้ามีความสามารถในการชำระเบี้ยประกันภัยได้ตรงตามกำหนดทุกงวด ตลอดระยะเวลาชำระเบี้ยประกันภัยที่ระบุในเอกสารนี้ ',
    'การยื่นขอทำประกันฉบับนี้เป็นไปตามความประสงค์และความสมัครใจของข้าพเจ้า',
  ],

  DISTRICT_OFFICE: 'สำนักงานเขต',
  OFFICE_CODE: 'รหัส',

  caseLabelMapping: {
    DEATH: 'กรณีเสียชีวิต (ขั้นต่ำ)',
    CRITICAL_ILLNESS: 'กรณีเจ็บป่วยด้วยโรคร้ายแรง (เป็นไปตามเงื่อนไขในกรมธรรม์)',
    DISABILITY: 'กรณีทุพพลภาพสิ้นเชิงถาวร',
    BENEFIT_OF_MATURITY: 'ผลประโยชน์เงินจ่ายคืน ณ วันครบกำหนดสัญญา',
  },
  causeLabelMapping: {
    ILLNESS: 'จากการเจ็บป่วย',
    ACCIDENT: 'จากอุบัติเหตุทั่วไป',
    DISASTER: 'จากอุบัติเหตุสาธารณภัย',
    RIOT: 'จากการจลาจล สงครามกลางเมือง',
    MATURITY: 'ครบกำหนดสัญญา',
  },
  guaranteeMapping: {
    CASH_DROP: '',
    MATURITY: '',
    TOTAL: '',
    NonMATURITY: '',
    NonTOTAL: '',
  },
  iCareMessages: {
    ADDITIONAL_NOTE_HEADER: 'ข้อควรรู้',
    PROTECT_WHEN: 'กรมธรรม์ iCare จะคุ้มครองเมื่อ',
    PASS_60_DAYS: '1. ผ่าน 60 วันแรก',
    PASS_60_DAYS_DETAIL:
      'โดยนับจากวันที่กรมธรรม์ iCare มีผลบังคับสำหรับโรคร้ายแรงระยะรุนแรง และจะต้องไม่มีอาการหรือการรักษาที่เกี่ยวเนื่องกันในช่วงระยะเวลาที่ไม่คุ้มครองดังกล่าวนี้',
    PASS_90_DAYS: '2. ผ่าน 90 วันแรก',
    PASS_90_DAYS_DETAIL:
      'โดยนับจากวันที่กรมธรรม์ iCare มีผลบังคับสำหรับโรคร้ายแรงระยะเริ่มต้น และโรคร้ายแรงระยะปานกลาง และจะต้องไม่มีอาการหรือการรักษาที่เกี่ยวเนื่องกันในช่วงระยะเวลาที่ไม่คุ้มครองดังกล่าวนี้',
    CRITICAL_ILLNESS_CLIAM_NOTE: 'สำหรับการเคลมระหว่างโรคร้ายแรงระยะรุนแรงต่างกลุ่มโรค แผนประกัน iCare ',
    PASS_ONE_YEAR: 'จะคุ้มครองเมื่อพ้นระยะเวลา 1 ปี',
    START_FROM: ' โดยนับจาก',
    FIRST_CRITICAL_ILLNESS: '1. การวินิจฉัยโรคร้ายแรงระยะรุนแรงครั้งล่าสุดในกลุ่มโรคที่ 2,3,4,5 หรือ',
    SECOND_CRITICAL_ILLNESS: '2. หลังจากวันที่รักษาหายขาดของโรคมะเร็ง (กลุ่มโรคที่ 1)',
    SECOND_CRITICAL_ILLNESS_NEW: '2. เมื่อพ้นระยะเวลาปลอดการรักษาโรคมะเร็ง 1 ปี สำหรับ กลุ่มโรคที่ 1',
  },

  // iWealthy
  // Policy Summary
  INSURANCE_COUPLED_INVESTMENT_TITLE: 'เอกสารประกอบการเสนอขายกรมธรรม์ประกันชีวิตแบบควบการลงทุน',
  INSURANCE_COUPLED_INVESTMENT_RPUDR_TITLE: 'เอกสารประกอบการเสนอขายกรมธรรม์ประกันชีวิตควบการลงทุน',
  IWEALTHY_UNIT_LINKED: 'iWealthy (Unit Linked)',
  IWEALTHY_UNIT_LINKED_TH: 'แบบประกันชีวิตควบการลงทุน แบบไอเวลท์ตี้ (ยูนิตลิงค์)',
  IWEALTHY_FOOTER:
    'ใบนำเสนอการขายผลิตภัณฑ์ประกันชีวิตควบการลงทุน iWealthy โดย บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)',
  RPUDR_FOOTER:
    'ใบนำเสนอการขายผลิตภัณฑ์ประกันชีวิตควบการลงทุน iLink โดย บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)',
  IINVEST_UNIT_LINKED: 'iInvest (Unit Linked)',
  IINVEST_UNIT_LINKED_TH: 'แบบประกันชีวิตควบการลงทุน แบบไออินเวสท์ (ยูนิตลิงค์)',
  IINVEST_FOOTER:
    'ใบนำเสนอการขายผลิตภัณฑ์ประกันชีวิตควบการลงทุน iInvest โดย บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)',
  RPUDR_UNIT_LINKED: 'iLink (Unit Linked)',
  RPUDR_UNIT_LINKED_TH: 'กรมธรรม์ประกันชีวิตควบการลงทุน แบบไอลิงค์ (ยูนิตลิงค์)',
  POLICY_TYPE: 'แบบกรมธรรม์',
  INSURED_FULLNAME: 'ชื่อ-สกุล ผู้เอาประกันภัย',
  INSURED_AGE: 'อายุผู้เอาประกันภัย',

  //BI page
  PREMIUM_PAYMENT_PERIOD: 'ระยะเวลาชำระเบี้ยประกันภัย',
  RPUL_REGULAR_PREMIUM_MINI: 'เบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวด (RPP)',
  REGULAR_COVERAGE_BASIC_PREMIUM: 'เบี้ยประกันภัยหลักเพื่อความคุ้มครองรายงวด',
  REGULAR_INVESTMENT_PREMIUM: 'เบี้ยประกันภัยเพื่อการลงทุนรายงวด',
  PREMIUM_RPP: 'เบี้ยประกันภัยหลักเพื่อความคุ้มครอง\nรวมสัญญาเพิ่มเติม (ถ้ามี)',
  PREMIUM_LSTU: 'เบี้ยประกันภัยเพื่อการลงทุนเพิ่มเติมพิเศษ (LSTU) ตอนออกกรมธรรม์',
  REGULAR_TOPUP_BI: 'เบี้ยประกันภัยเพื่อการลงทุนรายงวด (RTU)',
  PAYMENT_PERIOD_BI: 'ชำระเบี้ยจนครบอายุ',

  DISTRIBUTOR_OR_AGENT_SIGN: ['ตัวแทน / นายหน้าที่ได้', 'รับอนุญาต'],
  DISTRIBUTOR_OR_AGENT_SIGNATURE_AGENT_ID: 'รหัสตัวแทน / นายหน้า',
  INVESTOR_ID: ['รหัสผู้ติดต่อกับผู้ลงทุนที่', 'ได้รับความเห็นชอบ'],
  DATE: 'วันที่',
  DATE_TIME: 'วันที่/เวลา',
  RELATIONSHIP: 'ความสัมพันธ์',
  SIGNATURE_OWNER: 'ลายมือชื่อผู้แทนและผู้ใช้อำนาจปกครองหรือผู้แทนโดยชอบธรรม',

  STANDARD_RISK: 'ภัยมาตรฐาน',
  LOWER_STANDARD_RISK: 'ภัยต่ำกว่ามาตรฐาน___%',
  //Cash Flow Page
  CASHFLOW_CHART_HEADER: 'สรุปย่อ ข้อกำหนดและเงื่อนไขทั่วไป รวมทั้งสิทธิประโยชน์ตามกรมธรรม์',
  RIGHTS_INSURED_HEADER: 'สิทธิของผู้เอาประกันภัย',
  RIGHTS_INSURED_TITLE: 'ผู้ถือกรมธรรม์มีสิทธิตามกรมธรรม์ดังนี้',

  //Example of Benefit Table Page
  EXAMPLE_BENEFIT_TABLE_HEADER: 'ตัวอย่างตารางคำนวณผลประโยชน์ กรณีที่ {{ number }}',
  EXAMPLE_BENEFIT_EXPLANATION_HEADER: 'กรณีที่ {{ caseNumber }}: อัตราผลตอบแทนในส่วนของการลงทุน {{ percentNumber }}%',
  EXAMPLE_BENEFIT_EXPLANATION_HEADER_WITH_INFLATION:
    'กรณีที่ {{ caseNumber }}: อัตราผลตอบแทนในส่วนของการลงทุน {{ expectedReturnPercentage }}%, อัตราเงินเฟ้อทางการแพทย์และค่ารักษาพยาบาล {{ inflationPercentage }}%*',
  EXAMPLE_BENEFIT_EXPLANATION: [
    'มูลค่าที่แสดงในเอกสารฉบับนี้เป็นเพียงตัวเลขประมาณการตามสมมติฐานที่ตั้งขึ้น ณ วันที่ทำเอกสารนี้ เพื่อที่จะให้ผู้ขอเอาประกันภัยได้ศึกษาเป็นตัวอย่างเท่านั้น ไม่ได้เป็นการรับรองผลประโยชน์และ',
    'ไม่ได้อ้างอิงตามผลการดำเนินงานย้อนหลังของผลิตภัณฑ์',
    ' บริษัทฯไม่สามารถรับประกันและไม่สามารถรับรองว่า',
    'ท่านจะได้รับ',
    'ผลประโยชน์ประมาณการตามตัวอย่างนี้ในอนาคต ดังนั้นผลประโยชน์ที่ได้รับจริงอาจแตกต่างจากตัวเลขประมาณการข้างต้นนี้ โดยอาจมีความแตกต่าง อย่างมีนัยสำคัญ ผู้ขอเอาประกันภัยควรจะศึกษาตัวอย่างที่แสดงอย่างละเอียดถี่ถ้วน โดยวิเคราะห์ถึงผลประกอบการในอนาคตและความคาดหวังในผลิตภัณฑ์นี้',
    ' ด้วยตัวท่านเอง เพื่อที่จะสามารถประเมินแนวโน้ม',
    'ของผลการดำเนินงาน ของผลิตภัณฑ์ในอนาคตได้อย่างชัดเจน',
  ],
  EXAMPLE_BENEFIT_EXPLANATION_NOTE_HEADER: 'ข้อรับรู้ที่สำคัญ -',
  IWEALTHY_EXAMPLE_BENEFIT_EXPLANATION_NOTE:
    'มูลค่าบัญชีของกรมธรรม์ที่แสดงอยู่ในแบบเสนอขายนี้ เกิดจากการใช้สมมติฐาน เพื่อที่จะแสดงให้เห็นถึงผลกระทบของมูลค่าบัญชีกรมธรรม์ ที่เกิดจากการจ่ายค่าธรรมเนียมต่าง ๆ รวมถึงผลตอบแทนการลงทุนโดยสมมติฐานเหล่านี้ จะไม่มีส่วนเกี่ยวข้อง กับเงื่อนไขต่างๆ ที่ถูกระบุไว้ในสัญญากรมธรรม์',
  IINVEST_EXAMPLE_BENEFIT_EXPLANATION_NOTE:
    'มูลค่าบัญชีของกรมธรรม์ที่แสดงอยู่ในแบบเสนอขายนี้ เกิดจากการใช้สมมติฐาน เพื่อที่จะแสดงให้เห็นถึงผลกระทบของมูลค่าบัญชีกรมธรรม์ ที่เกิดจากการจ่ายค่าธรรมเนียมต่าง ๆ รวมถึงผลตอบแทนการลงทุนโดยสมมติฐานเหล่านี้ จะไม่มีส่วนเกี่ยวข้อง กับเงื่อนไขต่างๆ ที่ถูกระบุไว้ในสัญญากรมธรรม์',
  ILINK_EXAMPLE_BENEFIT_EXPLANATION_NOTE:
    'มูลค่ารับซื้อคืนหน่วยลงทุนที่แสดงอยู่ในเอกสารประกอบการเสนอขายกรมธรรม์ประกันชีวิตควบการลงทุนนี้ เกิดจากการใช้สมมติฐาน เพื่อที่จะแสดงให้้เห็นถึงผลกระทบของมูลค่ารับซื้้อคืนหน่วยลงทุนที่เกิดจากการจ่ายค่าธรรมเนียมกรมธรรม์ต่างๆ รวมถึงผลตอบแทนการลงทุน โดยสมมติฐานเหล่านี้จะไม่มีส่วนเกี่ยวข้องกับเงื่อนไขต่างๆ ที่ถูกระบุไว้ในกรมธรรม์',
  IWEALTHY_EXAMPLE_BENEFIT_EXPLANATION_DISCLAIMER:
    'ค่าการประกันภัยอาจเพิ่มขึ้นเนื่องจากสุขภาพของผู้เอาประกันภัยและเพื่อป้องกันการขาดผลของกรมธรรม์เนื่องจากมูลค่าหน่วยลงทุนที่ลดลงอันเนื่องจากค่าการประกันภัยที่เพิ่มขึ้นบริษัทขอเรียกเก็บเบี้ยประกันภัยหลัก เพื่อความคุ้มครองเพิ่มตามสัดส่วนของภัยต่ำกว่ามาตรฐานเนื่องจากสุขภาพของผู้เอาประกันภัย',
  IINVEST_EXAMPLE_BENEFIT_EXPLANATION_DISCLAIMER: 'ค่าการประกันภัยอาจเพิ่มขึ้นเนื่องจากสุขภาพของผู้เอาประกันภัย',
  RPUDR_EXAMPLE_BENEFIT_EXPLANATION_DISCLAIMER:
    'ตามสมมติฐานที่ตั้งขึ้นของตัวอย่างนี้ กรมธรรม์จะสิ้นผลบังคับ ณ ปีกรมธรรม์ที่ {{ year }} เดือนที่ {{ month }} โดยผู้เอาประกันภัยมีอายุ {{ age }} ปี\nเบี้ยประกันภัยเพื่อการลงทุนเพิ่มเติมพิเศษ สามารถชำระเพิ่มเติมนอกเหนือจากเบี้ยประกันภัยหลักเพื่อความคุ้มครองในเวลาใด ๆ ในขณะที่กรมธรรม์ยังมีผลบังคับและไม่อยู่ระหว่างการหยุดพักชำระเบี้ยประกันภัย\n*สมมติฐานเรื่องอัตราเงินเฟ้อทางการแพทย์และค่ารักษาพยาบาลจะใช้สำหรับสัญญาเพิ่มเติมประกันภัยที่เกี่ยวข้องกับการเบิกค่ารักษาพยาบาลสุขภาพ เท่านั้น',
  EXAMPLE_BENEFIT_NOTE: 'หมายเหตุ: -',

  MUTUAL_FUND_PORTFOLIO: 'สรุปสัดส่วนการลงทุน ของกองทุนรวมภายใต้กรมธรรม์ {{policyType}} ณ วันที่ {{dateInThai}}',

  BASIC_PREMIUM_FOR_COVERAGE: 'เบี้ยประกันภัยหลักเพื่อความคุ้มครอง',
  PREMIUM_FOR_SPECIAL_INVESTMENT: 'เบี้ยประกันภัยเพื่อการลงทุนเพิ่มเติมพิเศษ',

  CASHFLOW_TABLE_PREMIUM_LUMPSUM: 'เบี้ยประกันภัยเพิ่มเติมพิเศษ',
  CASHFLOW_TABLE_PREMIUM_REGULAR_LUMPSUM: ['เบี้ยประกันภัยเพื่อการลงทุน', 'เพิ่มเติมพิเศษ'],
  CASHFLOW_TABLE_PREMIUM_TOTAL_PREMIUM: 'รวมเบี้ยประกันภัยทั้งหมด',

  PREMIUM_ALLOCATION_FEE: 'ค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัย',

  CASHFLOW_TABLE_POLICY_CHARGE: 'ค่าธรรมเนียมกรมธรรม์ประกันภัย',
  CASHFLOW_TABLE_POLICY_CHARGE_GROUP: 'ค่าการประกันภัย',
  CASHFLOW_TABLE_POLICY_CHARGE_TYPE_COI: 'สำหรับความคุ้มครองชีวิต',
  CASHFLOW_TABLE_POLICY_CHARGE_TYPE_CI: 'สัญญาเพิ่มเติมคริติคอลลิงค์ UDR',
  CASHFLOW_TABLE_POLICY_CHARGE_TYPE_TPD: 'สัญญาเพิ่มเติมทีพีดีลิงค์ UDR',
  CASHFLOW_TABLE_POLICY_CHARGE_TYPE_HS: 'สัญญาเพิ่มเติมเฮลธ์ลิงค์ UDR',
  CASHFLOW_TABLE_POLICY_CHARGE_TYPE_HB: 'สัญญาเพิ่มเติมแคชลิงค์ UDR',
  CASHFLOW_TABLE_POLICY_CHARGE_SUM: 'รวมค่าการประกันภัย',
  CASHFLOW_TABLE_POLICY_CHARGE_LUMPSUM_TOPUP: 'ค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัยเพิ่มเติมพิเศษ',
  CASHFLOW_TABLE_POLICY_CHARGE_COI: 'ค่าการประกันภัยสัญญาหลัก',
  CASHFLOW_TABLE_POLICY_CHARGE_AMC: 'ค่าธรรมเนียมการบริหารกรมธรรม์',
  RPUDR_CASHFLOW_TABLE_POLICY_CHARGE_PREMIUM_CHARGE: 'ค่าธรรมเนียมกรมธรรม์',

  CASHFLOW_TABLE_INVESTMENT: 'ส่วนของการลงทุน',
  CASHFLOW_TABLE_INVESTMENT_ACCOUNT_VALUE_ACCOUNT_VALUE_AFTER_DEDUCTION: 'มูลค่าบัญชีกรมธรรม์ ณ ต้นเดือน',
  CASHFLOW_TABLE_INVESTMENT_FUND_RETURN: 'ผลประโยชน์ในส่วนของการลงทุนด้วยอัตราผลตอบแทน {{expectedReturn}}%',
  RPUDR_CASHFLOW_TABLE_INVESTMENT_FUND_RETURN: 'ผลตอบแทนในส่วนของการลงทุนด้วยอัตราผลตอบแทน {{expectedReturn}}%',
  CASHFLOW_TABLE_INVESTMENT_ACCOUNT_VALUE_BEFORE_BONUS: 'มูลค่าบัญชีกรมธรรม์ ณ สิ้นเดือน',
  CASHFLOW_TABLE_INVESTMENT_BONUS: 'โบนัสสำหรับการถือกรมธรรม์',
  CASHFLOW_TABLE_INVESTMENT_ACCOUNT_VALUE_AFTER_BONUS: 'มูลค่าบัญชีกรมธรรม์ ณ สิ้นเดือน รวมโบนัส',
  CASHFLOW_TABLE_INVESTMENT_REDEMPTION_VALUE_BEGINNING_MONTH:
    'มูลค่ารับซื้อคืนหน่วยลงทุน ณ ต้นเดือน (หลังหักค่าธรรมเนียมกรมธรรม์รายเดือน)',
  CASHFLOW_TABLE_INVESTMENT_REDEMPTION_VALUE_MONTH_END: 'มูลค่ารับซื้อคืนหน่วยลงทุน ณ สิ้นเดือน',
  CASHFLOW_TABLE_INVESTMENT_BONUS_GROUP: 'โบนัสสำหรับการชำระเบี้ยประกันภัยหลัก เพื่อความคุ้มครอง',
  RPDUR_CASHFLOW_TABLE_INVESTMENT_BONUS_GROUP: 'โบนัสสำหรับการชำระเบี้ยประกันภัยหลักเพื่อความคุ้มครอง',
  CASHFLOW_TABLE_INVESTMENT_REDEMPTION_VALUE_MONTH_END_PLUS_BONUS: 'มูลค่ารับซื้อคืนหน่วยลงทุน ณ สิ้นเดือนรวมโบนัส',

  CASHFLOW_TABLE_SURRENDER_CASH_MONTH_END: 'มูลค่าเวนคืนกรมธรรม์ ณ สิ้นเดือน',
  CASHFLOW_TABLE_DEATH_BENEFIT_MONTH_END: 'ผลประโยชน์กรณีเสียชีวิตของกรมธรรม์ ณ สิ้นเดือน',

  //processing timeline
  PROCESSING_TIMELINE_HEADER: 'สรุปย่อ ขั้นตอนการดำเนินงานที่สำคัญ',
  EXTENED_PROCESSING_TIMELINE_HEADER: 'สรุปย่อ ขั้นตอนการดำเนินงานที่สำคัญ (ต่อ)',
  PROCESSING_TIMELINE_DISCLAIMER_1: '* วันที่ T+2 สำหรับกองทุนในประเทศ และ T+3 สำหรับกองทุนต่างประเทศ หรือ',
  PROCESSING_TIMELINE_SECOND_DISCLAIMER_1:
    '** ภายในวันที่ T+3 สำหรับกองทุนในประเทศ และ T+4 สำหรับกองทุนต่างประเทศ ในกรณีชำระเบี้ยประกันภัยเพิ่มเติมพิเศษ',
  PROCESSING_TIMELINE_DISCLAIMER_2: '* วันที่ T+2 สำหรับกองทุนในประเทศ และ T+3 สำหรับกองทุนต่างประเทศ',
  PROCESSING_TIMELINE_SECOND_DISCLAIMER_2: '** วันที่ T+X+2 สำหรับกองทุนในประเทศ และ T+X+3 สำหรับกองทุนต่างประเทศ',
  TOPIC_TABLE_HEADER: 'หัวข้อ',

  STEP_HEADER: 'ขั้นตอนการดำเนินงาน',
  INFORM_PRICE_DATE_HEADER: 'วันที่ได้รับราคาหน่วยลงทุน',

  FUND_RISK_TABLE_HEADER: 'รายละเอียดของกองทุนรวมภายใต้กรมธรรม์ และระดับความเสี่ยงของท่าน',
  FUND_RISK_CHART_HEADER: 'สัดส่วนการลงทุนของท่าน',
  FUND_RISK_CHART_HEADER_RPP: 'สัดส่วนการลงทุนเบี้ยประกันภัยหลักเพื่อความคุ้มครอง',
  FUND_RISK_CHART_HEADER_LSTU: 'สัดส่วนการลงทุนเบี้ยประกันภัยเพื่อการลงทุนเพิ่มเติมพิเศษ*',
  FUND_RISK_CHART_FOOTER:
    'สัดส่วนการลงทุนที่ได้แสดงไว้ข้างต้น เป็นสัดส่วนการลงทุนของเบี้ยรับหลังจากหักค่าใช้จ่ายต่าง ๆ โดยสัดส่วนการลงทุนนี้อาจแตกต่างจากสัดส่วนการลงทุนที่มีอยู่ในมูลค่าบัญชีกรมธรรม์ เนื่องจากมูลค่ากองทุนที่เปลี่ยนแปลง โดยผู้เอาประกันภัยมีสิทธิ์ที่จะโยกย้ายหรือสับเปลี่ยนกองทุน ตามสิทธิ์ที่ระบุไว้ในกรมธรรม์',
  FUND_RISK_TABLE_ALLOCATIONS_HEADER: 'ข้อมูลของกองทุนรวม',
  FUND_RISK_TABLE_FUND_NAME: 'ชื่อกองทุน',
  FUND_RISK_TABLE_FUND_TYPE: 'ประเภทของกองทุนรวม',
  FUND_RISK_TABLE_FUND_HOUSE: 'บลจ.',
  FUND_RISK_TABLE_FUND_ALLOCATION: 'สัดส่วนการลงทุน',
  FUND_RISK_TABLE_FUND_ALLOCATION_LSTU: 'เบี้ยประกันภัยเพื่อการลงทุนเพิ่มเติมพิเศษ*',
  FUND_RISK_TABLE_FUND_RISK: 'ระดับความเสี่ยงของกองทุนรวม',
  FUND_RISK_TABLE_INSURED_RISK: 'ระดับความเสี่ยงที่รับได้ของลูกค้า',
  FUND_RISK_TABLE_RISK_LIMIT: 'กองทุนอยู่ในระดับความเสี่ยงที่รับได้',
  FUND_RISK_TABLE_RISK_HEADER: 'ระดับความเสี่ยง',
  FUND_RISK_SIGN_MESSAGE:
    'ข้าพเจ้าขอยืนยันว่าในการตัดสินใจลงทุนของข้าพเจ้า ข้าพเจ้าได้มีการใตร่ตรองถึงระดับความเสี่ยงของกองทุน และระดับความเสี่ยงที่ข้าพเจ้ารับได้ มาเป็นส่วนพิจารณาในการลงทุน',
  FUND_RISK_SIGNED_BY: 'ผู้ขอเอาประกันภัย',
  FUND_RISK_TOTAL: 'รวมทั้งสิ้น',
  RPUDR_FUND_RISK_CHART_FOOTER:
    'สัดส่วนการลงทุนที่ได้แสดงไว้ข้างต้น เป็นสัดส่วนการลงทุนของเบี้ยประกันภัยหลังจากการหักค่าธรรมเนียมในการจัดสรรเบี้ยประกันภัย และค่าธรรมเนียมกรมธรรม์รายเดือนแล้ว',

  // Loan benefit illustration
  HEALTH_CHECK_RULE: 'กฏเกณฑ์การตรวจสุขภาพและเอกสารทางการเงิน',
  HEALTH_CHECK_LIST: 'รายการตรวจสุขภาพ',
  LOAN_SUM_ASSURE: 'จำนวนเงินเอาประกันภัยตามสัญญาประกันชีวิต',

  BENEFIT_NO_RETURN_VALUE: 'ไม่มีเงินปันผล',

  //tax deduction benefit
  TAX_DEDUCTION_BENEFIT_TITLE: 'ผลประโยชน์ภาษีเงินได้บุคคลธรรมดา',
  TAX_DEDUCTION_BENEFIT_SUB_TITLE: 'พิเศษ!!! ผลประโยชน์เพิ่มเติมจากการหักลดหย่อนภาษี',
  TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION: 'ท่านสามารถนำเบี้ยประกันภัยมาหักลดหย่อนภาษีได้ตามที่จ่ายจริง',
  TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG: 'แต่ไม่เกินจำนวนสูงสุดตามที่กรมสรรพากรกำหนด',
  GIO_TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG: 'แต่ไม่เกินจำนวนสูงสุดที่กรมสรรพากรกำหนด',
  TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_CONDITION: 'และเป็นไปตามเงื่อนไขสรรพากร',
  TAX_DEDUCTION_BENEFIT_SUB_LIST: [{ description: 'เบี้ยประกันชีวิต', benefit: '{{value}} บาท' }],
  TAX_GIO_DEDUCTION_BENEFIT_SUB_LIST: [{ description: 'เบี้ยประกันชีวิต ปีละ', benefit: '{{value}} บาท' }],
  TAX_DEDUCTION_BENEFIT_SUB_ADDITIONAL:
    'เพื่อสิทธิประโยชน์สูงสุดของท่าน ควรถือกรมธรรม์จนครบกำหนดสัญญา และผลประโยชน์ที่ได้รับจากกรมธรรม์ประกันชีวิตจะไม่มีการหักภาษีใด ๆ ทั้งสิ้น และเป็นเงิน\nปลอดหนี้ เจ้าหนี้ไม่มีสิทธิ์ยึดได้ เว้นแต่ตกอยู่ภายใต้บังคับของกฎหมายอื่นที่เกี่ยวข้อง',
  TAX_DEDUCTION_BENEFIT_SUB_ADDITIONAL_HTML:
    'เพื่อสิทธิประโยชน์สูงสุดของท่าน ควรถือกรมธรรม์จนครบกำหนดสัญญา และผลประโยชน์ที่ได้รับจากกรมธรรม์ประกันชีวิตจะไม่มีการหักภาษีใด ๆ ทั้งสิ้น และเป็นเงินปลอดหนี้ เจ้าหนี้ไม่มีสิทธิ์ยึดได้ เว้นแต่ตกอยู่ภายใต้บังคับของกฎหมายอื่นที่เกี่ยวข้อง',
  TAX_DEDUCTION_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันชีวิต',
      ` สำหรับอ้างอิงการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาตามกฎหมาย (กรมธรรม์ประกันชีวิตทำหลังปี พ.ศ.2551) แบบสิบปีขึ้นไป
และเงินคืนตามเงื่อนไขของกรมธรรม์ประกันชีวิต (ถ้ามี) เป็นไปตามประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 ข้อ 2 (2) ในส่วนของเบี้ยประกันชีวิต ได้สูงสุดไม่เกิน 100,000 บาท`,
    ],
    [
      'โปรแกรมข้อเสนอขายนี้ ยังไม่ได้ระบุสิทธิในการลดหย่อนภาษีสำหรับเบี้ยประกันสุขภาพ กรุณาติดต่อบริษัทฯ เพื่อรับข้อมูลเพิ่มเติม',
    ],
  ],
  //TAX GIO DEDUCTION BENEFIT
  TAX_GIO_DEDUCTION_BENEFIT_SUB_ADDITIONAL:
    'เบี้ยประกันภัยซึ่งหมายถึงเบี้ยประกันชีวิต ขึ้นอยู่กับความคุ้มครองของผู้เอาประกันภัย สามารถนำไปใช้สิทธิลดหย่อนภาษีเงินได้ตามกฎเกณฑ์ของกรมสรรพากร ทั้งนี้ หากผู้เอาประกันภัยไม่ปฎิบัติตามกฎเกณฑ์ของกรมสรรพากร ผู้เอาประกันภัยอาจถูกเรียกคืนภาษี',
  TAX_GIO_DEDUCTION_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันชีวิต',
      ' เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไป ให้เป็นไปตามที่\nประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
  ],

  // Mini BI iHealthy
  BENEFIT_TITLE: 'ผลประโยชน์',
  BENEFIT_TITLE_IGROW: 'ความคุ้มครองแผน',
  BENEFIT_HEADER_IGROW: 'ไอโกรว์ (ไม่มีเงินปันผล)',
  BENEFIT_MEH_DISCLAIMER_LINE_01: '(*) 12 MWP คือ ระยะเวลารอคอย 12 เดือน',
  BENEFIT_MEH_DISCLAIMER_LINE_02:
    '(**) บริษัทฯ จะชดเชยเป็นจำนวน 80% ของค่ารักษาพยาบาล แต่ไม่เกินผลประโยชน์รวมสูงสุดที่กำหนดไว้ในตาราง',
  BENEFIT_MEH_DISCLAIMER_LINE_03: '(***) ผลประโยชน์นี้จำกัดใช้ได้ 1 ครั้งในช่วงชีวิตของผู้เอาประกันภัย',
  BENEFIT_MEH_DISCLAIMER_LINE_04: '(****) และไม่เกินผลประโยชน์รวมสูงสุดต่อปี',
  MHP_BI_CO_PAYMENT: 'แบบมีค่าใช้จ่ายร่วม',
  MHP_BI_DEDUCTIBLE: 'แบบมีความรับผิดส่วนแรก',
  // Tax Consent
  TAX_CONSENT_DEDUCTION_BENEFIT_SUB_LIST: [
    { description: 'เบี้ยประกันชีวิต ปีละ', benefit: '{{value}} บาท' },
    { description: 'เบี้ยประกันสุขภาพ ปีแรก', benefit: '{{value}} บาท' },
    { description: 'เบี้ยประกันสุขภาพ ปีละ', benefit: '{{value}} บาท' },
    { description: 'เบี้ยประกันอุบัติเหตุ ปีละ', benefit: '{{value}} บาท' },
  ],
  TAX_CONSENT_DEDUCTION_BENEFIT_SUB_ADDITIONAL:
    'เบี้ยประกันภัยซึ่งหมายถึงเบี้ยประกันชีวิตหรือเบี้ยประกันสุขภาพขึ้นอยู่กับความคุ้มครองของผู้เอาประกันภัย สามารถนำไปใช้สิทธิลดหย่อนภาษีเงินได้ตามกฎเกณฑ์ของกรมสรรพากร ทั้งนี้ หากผู้เอาประกันภัยไม่ปฎิบัติตามกฎเกณฑ์ของกรมสรรพากร ผู้เอาประกันภัยอาจถูกเรียกคืนภาษี',
  TAX_CONSENT_DEDUCTION_BENEFIT_SUB_ADDITIONAL_PA:
    'เบี้ยประกันภัยซึ่งหมายถึงเบี้ยประกันอุบัติเหตุหรือเบี้ยประกันสุขภาพขึ้นอยู่กับความคุ้มครองของผู้เอาประกันภัย สามารถนำไปใช้สิทธิลดหย่อนภาษีเงินได้ตามกฎเกณฑ์ของกรมสรรพากร ทั้งนี้ หากผู้เอาประกันภัยไม่ปฎิบัติตามกฎเกณฑ์ของกรมสรรพากร ผู้เอาประกันภัยอาจถูกเรียกคืนภาษี',
  TAX_CONSENT_DEDUCTION_BENEFIT_SUB_ADDITIONAL_PDF:
    'เบี้ยประกันภัยซึ่งหมายถึงเบี้ยประกันชีวิตหรือเบี้ยประกันสุขภาพขึ้นอยู่กับความคุ้มครองของผู้เอาประกันภัย สามารถนำไปใช้สิทธิลดหย่อนภาษีเงินได้ตามกฎเกณฑ์\nของกรมสรรพากร ทั้งนี้ หากผู้เอาประกันภัยไม่ปฎิบัติตามกฎเกณฑ์ของกรมสรรพากร ผู้เอาประกันภัยอาจถูกเรียกคืนภาษี',
  TAX_CONSENT_DEDUCTION_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันชีวิต',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไปให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'เบี้ยประกันสุขภาพ',
      'ตามประกาศอธิบดีกรมสรรพากร สำหรับอ้างอิงการใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดา โดยเป็นไปตามเงื่อนไขข้อกำหนดของกรมสรรพากร',
    ],
  ],
  TAX_CONSENT_DEDUCTION_BENEFIT_SUB_NOTES_PDF: [
    [
      'เบี้ยประกันชีวิต',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไป\nให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'เบี้ยประกันสุขภาพ',
      'ตามประกาศอธิบดีกรมสรรพากร สำหรับอ้างอิงการใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดา โดยเป็นไปตามเงื่อนไขข้อกำหนดของกรมสรรพากร',
    ],
  ],

  // Mini BI SukhapabDekDee
  SUKHAPABDEKDEE_PLAN: {
    MEK1: 'แผนประกันสุขภาพเด็กดี 2500',
    MEK2: 'แผนประกันสุขภาพเด็กดี 3500',
    MEK1_RIDER_SUMMARY_TITLE_PREFIX: 'ค่ารักษาพยาบาล (พิเศษ) สำหรับเด็ก(MEK 2500)',
    MEK2_RIDER_SUMMARY_TITLE_PREFIX: 'ค่ารักษาพยาบาล (พิเศษ) สำหรับเด็ก(MEK 3500)',
  },
  SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_LIST: [
    { description: 'เบี้ยประกันชีวิต ปีละ', benefit: '{{value}} บาท' },
    { description: 'เบี้ยประกันสุขภาพ ปีแรก', benefit: '{{value}} บาท' },
  ],
  SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันชีวิต',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไปให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'เบี้ยประกันสุขภาพ',
      'ภายใต้เบี้ยประกันภัยตามสัญญาเพิ่มเติมสำหรับอ้างอิงการใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดา โดยเป็นไปตามเงื่อนไขข้อกำหนดของกรมสรรพากร',
    ],
  ],
  SUKHAPABDEKDEE_TAX_DEDUCTION_BENEFIT_SUB_NOTES_PDF: [
    [
      'เบี้ยประกันชีวิต',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไป\nให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'เบี้ยประกันสุขภาพ',
      'ภายใต้เบี้ยประกันภัยตามสัญญาเพิ่มเติมสำหรับอ้างอิงการใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดา โดยเป็นไปตามเงื่อนไขข้อกำหนดของกรมสรรพากร',
    ],
  ],

  //Mini BI FlexiHealth
  FLEXI_HEALTH_DEATH_BENEFIT: 'ความคุ้มครอง \n การเสียชีวิต',
  FLEXI_HEALTH_BASIC_DEATH_BENEFIT: 'ความคุ้มครองการเสียชีวิต \n ของสัญญาหลัก',
  FLEXI_HEALTH_CASH_SURRENDER_VALUE: 'มูลค่า \n เวนคืนเงินสด',
  FLEXI_HEALTH_CUMULATIVE_PREMIUM: 'เบี้ยประกันภัย\nสัญญาหลักสะสม',
  FLEXI_HEALTH_PLAN_THAI: {
    smartkids: 'สมาร์ท คิดส์',
    goldkids: 'โกลด์ คิดส์',
    platinum: 'แพลทินั่ม',
    diamond: 'ไดมอนด์',
    gold: 'โกลด์',
    silver: 'ซิลเวอร์',
    smart: 'สมาร์ท',
  },
  FLEXI_HEALTH_INCREASE_IN_PREMIUM_ADDITIONAL_CONTRACT:
    'เบี้ยประกันภัยสัญญาเพิ่มเติมในปีต่ออายุที่มีผลบังคับใช้ในปัจจุบันสามารถขอรายละเอียดได้จาก{{{ agentName }}} โดยเบี้ยประกันภัยของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจากอายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้',
  FLEXI_HEALTH_OFFER_SALE_PERIOD:
    'โปรแกรมใบข้อเสนอนี้ใช้ประกอบการเสนอขายตั้งแต่ {{ startOffer }} ถึง {{ endOffer }} หรือ ตามประกาศยกเลิกการใช้จากบริษัทฯ (แล้วแต่ระยะเวลาใดจะเกิดขึ้นก่อน)',
  FLEXI_HEALTH_BASIC_PLAN_DETAILS: '{{& basicplan }}{{& name }}',
  FLEXI_HEALTH_POLICY_VALUE_TABLE_NOTE_1: '1. เงินค่าเวนคืนกรมธรรม์ประกันภัยข้างต้นเป็นจํานวนเงินก่อนหักหนี้สินใด ๆ ',
  FLEXI_HEALTH_POLICY_VALUE_TABLE_NOTE_2:
    '2. เงินค่าเวนคืนกรมธรรม์ประกันภัยที่แสดงไว้ในตารางเป็นจํานวนเงินที่หักเงินจ่ายคืน (ถ้ามี) ออกแล้ว',
  FLEXI_HEALTH_POLICY_VALUE_TABLE_NOTE_3:
    '3. เบี้ยประกันภัยของสัญญาเพิ่มเติมที่แสดงในเอกสารเสนอขายนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  FLEXI_SUMMARY_TABLE_DISCLAIMER_2:
    '** บริษัทฯ ขอสงวนสิทธิ์ไม่ต่ออายุสัญญาเพิ่มเติมนี้ในวันครบรอบปีกรมธรรม์ โดยแจ้งให้ผู้เอาประกันภัยทราบล่วงหน้าเป็นลายลักษณ์อักษรไม่น้อยกว่า 30 วัน',
  FLEXI_SUMMARY_TABLE_DISCLAIMER_3:
    'เบี้ยประกันภัยสัญญาเพิ่มเติมในปีต่ออายุที่มีผลบังคับใช้ในปัจจุบันสามารถขอรายละเอียดได้จาก ตัวแทน/นายหน้าประกันชีวิต หรือ เจ้าหน้าที่ธนาคาร',
  FLEXI_SUMMARY_TABLE_DISCLAIMER_4:
    'ผู้เอาประกันภัยอาจบอกเลิกสัญญาเพิ่มเติมนี้เมื่อใดก็ได้ โดยแจ้งบริษัทฯ เป็นลายลักษณ์อักษรล่วงหน้า 30 วันก่อนวันครบรอบปีกรมธรรม์',
  FLEXI_HEALTH_TAX_BENEFIT_SUB_LIST: [
    { description: 'เบี้ยประกันชีวิต', benefit: '{{value}} บาท' },
    { description: 'เบี้ยประกันภัยตามสัญญาเพิ่มเติมสุขภาพ', benefit: '{{value}} บาท' },
  ],
  FLEXI_HEALTH_TAX_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันชีวิต',
      ` สำหรับอ้างอิงการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาตามกฎหมาย (กรมธรรม์ประกันชีวิตทำหลังปี พ.ศ.2551) แบบสิบปีขึ้นไป และเงินคืนตามเงื่อนไขของกรมธรรม์ประกันชีวิต (ถ้ามี) เป็นไปตามประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 ข้อ 2 (2)
    ในส่วนของเบี้ยประกันชีวิต ได้สูงสุดไม่เกิน 100,000 บาท`,
    ],
    [
      'เบี้ยประกันสุขภาพ',
      ` ภายใต้เบี้ยประกันภัยตามสัญญาเพิ่มเติมสำหรับอ้างอิงการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาได้ไม่เกิน 15,000 บาท
    และเมื่อรวมกับเบี้ยประกันชีวิตที่มีสิทธิลดหย่อนภาษีแล้ว ไม่เกิน 100,000 บาท ตามเงื่อนไข กฎกระทรวง ฉบับที่ 334 (พ.ศ.2560) ว่าด้วยการยกเว้นรัษฎากร
    และประกาศอธิบดีกรมสรรพากรเกี่ยวกับภาษีเงินได้ (ฉบับที่ 315)`,
    ],
    [
      'โปรแกรมข้อเสนอขายนี้ ยังไม่ได้ระบุสิทธิในการลดหย่อนภาษีสำหรับเบี้ยประกันสุขภาพ กรุณาติดต่อบริษัทฯ เพื่อรับข้อมูลเพิ่มเติม',
    ],
  ],

  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_TITLE:
    'เงื่อนไขและข้อยกเว้นที่สำคัญสำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล เฟลคซี่ เฮลท์',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_SUB_TITLE: 'เงื่อนไขทั่วไป',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_FIRST:
    'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติมนี้ สำหรับการเจ็บป่วยใด ๆ ที่เกิดขึ้นในระยะเวลา 30 วัน นับจากวันเริ่มมีผลคุ้มครองของสัญญาเพิ่มเติมนี้ หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด หรือ',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_SECOND:
    'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติม ที่เกิดขึ้นในระยะเวลา 60 วัน นับจากวันเริ่มมีผลคุ้มครองของสัญญาเพิ่มเติมนี้  หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด  สำหรับค่าศัลยกรรมในช่องปากตามความจำเป็นทางการแพทย์',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_SECOND_PDF:
    'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติม ที่เกิดขึ้นในระยะเวลา 60 วัน นับจากวันเริ่มมีผลคุ้มครองของสัญญาเพิ่มเติมนี้  หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด  สำหรับค่าศัลยกรรมในช่องปากตามความจำเป็นทาง\nการแพทย์',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_THIRD:
    'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติมนี้ สำหรับการเจ็บป่วยดังต่อไปนี้ ที่เกิดขึ้นในระยะเวลา 120 วัน นับจากวันเริ่มมีผลคุ้มครองของสัญญาเพิ่มเติมนี้ หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้ายแล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_THIRD_DISEASES: [
    'เนื้องอก ถุงน้ำ หรือมะเร็งทุกชนิด',
    'ไส้เลื่อนทุกชนิด',
    'การตัดทอนซิล หรืออดีนอยด์',
    'เส้นเลือดขอดที่ขา',
    'ริดสีดวงทวาร',
    'ต้อเนื้อ หรือต้อกระจก',
    'นิ่วทุกชนิด',
    'เยื่อบุโพรงมดลูกเจริญผิดที่',
  ],
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_FOURTH:
    'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติม (สำหรับแผนแพลทินั่มเท่านั้น) ที่เกิดขึ้นในระยะเวลา 12 เดือน ดังต่อไปนี้ นับจากวันทำสัญญาเพิ่มเติมนี้ หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_FOURTH_PDF:
    'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติม (สำหรับแผนแพลทินั่มเท่านั้น) ที่เกิดขึ้นในระยะเวลา 12 เดือน ดังต่อไปนี้ นับจากวันทำสัญญา\nเพิ่มเติมนี้ หรือวันต่ออายุสัญญาเพิ่มเติมนี้ (Reinstatement) ครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_CONDITION_LIST_FOURTH_DISEASES: [
    'ค่ารักษาพยาบาลสำหรับภาวะแทรกซ้อนก่อนและหลังการคลอดบุตร',
    'ค่ารักษาพยาบาลสำหรับการตั้งครรภ์ และคลอดบุตร',
    'ค่าตรวจสุขภาพประจำปี',
    'ค่ารักษาพยาบาล และการดูแลแบบประคับประคองระยะสุดท้าย',
  ],
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_TITLE: 'ข้อยกเว้น*  มีทั้งหมด 32 ข้อ เช่น',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_SUB_TITLE:
    'การประกันภัยตามสัญญาเพิ่มเติมนี้ ไม่คุ้มครองค่าใช้จ่ายการรักษาพยาบาลหรือความเสียหายที่เกิดจากการบาดเจ็บหรือเจ็บป่วย (รวมทั้งโรคแทรกซ้อน) อาการ หรือ ภาวะความผิดปกติที่เกิดจาก',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_LIST_FIRST:
    'โรคเรื้อรัง การเจ็บป่วยหรือการบาดเจ็บที่ยังมิได้รักษาให้หายก่อนวันทำสัญญาประกันภัย การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด (Congenital) หรือปัญหาด้านพัฒนาการ หรือโรคทางพันธุกรรม',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_LIST_SECOND:
    'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระรังแค ผมร่วง หรือการควบคุมน้ำหนักตัว หรือการผ่าตัดอันมีลักษณะเลือกได้ เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจากอุบัติเหตุที่ได้รับความคุ้มครอง',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_LIST_THIRD: 'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_LIST_FORTH: 'การรักษาพยาบาลเชิงป้องกันโรค',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_LIST_FIFTH:
    'การตรวจรักษา หรือการป้องกัน การใช้ยา หรือสารต่าง ๆ เพื่อการชะลอความเสื่อมของวัย หรือการให้ฮอร์โมนทดแทนในวัยใกล้หมดหรือหมดระดู การเสื่อมสมรรถสภาพทางเพศในหญิง หรือชาย  การรักษาความผิดปกติทางเพศ  และการแปลงเพศ',
  FLEXI_HEALTH_LEGAL_DISCLAIMER_EXEMPTION_LIST_NOTE:
    'หมายเหตุ * เฉพาะข้อยกเว้นบางรายการ ท่านสามารถศึกษารายละเอียดข้อยกเว้นทั้งหมดได้ในกรมธรรม์',

  FLEXI_HEALTH_AGENT: 'ตัวแทนประกันชีวิต/นายหน้าประกันชีวิต',
  FLEXI_HEALTH_BANC: 'เจ้าหน้าที่ธนาคาร',
  FLEXI_HEALTH_SUMMARY_PREFIX_FH: 'สัญญาเพิ่มเติมค่ารักษาพยาบาล เฟลคซี่ เฮลท์ \nแผน{{plan}}\n {{description}}',
  FLEXI_HEALTH_SUMMARY_PREFIX_MODULE_ONE:
    'บันทึกสลักหลังค่ารักษาพยาบาล เฟลคซี่ เฮลท์\n แผน{{plan}}\n แผนเพิ่มเติมผู้ป่วยในแบบเติมเต็ม',
  FLEXI_HEALTH_SUMMARY_PREFIX_MODULE_TWO:
    'บันทึกสลักหลังค่ารักษาพยาบาล เฟลคซี่ เฮลท์\n แผน{{plan}}\n แผนเพิ่มเติมผู้ป่วยนอก',
  FLEXI_HEALTH_SUMMARY_BENEFIT_MESSAGE: 'ตามที่ระบุในสรุปผลประโยชน์สำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล เฟลคซี่ เฮลท์',

  FLEXI_HEALTH_RIDER_SUMMARY_TITLE_DEFAULT:
    'รายละเอียดของสัญญาเพิ่มเติม ค่ารักษาพยาบาล {{riderDescription}} ({{riderName}})',

  FLEXI_HEALTH_BENEFIT_AREA_COVERAGE_TITLE: 'อาณาเขตความคุ้มครอง',
  FLEXI_HEALTH_BENEFIT_OUT_AREA_COVERAGES: [
    'นอกอาณาเขตความคุ้มครอง',
    'บริษัทจะให้ความคุ้มครองการรักษาพยาบาล \nนอกอาณาเขตความคุ้มครองที่ผู้เอาประกันภัยได้เลือกไว้ \nสำหรับการรักษาพยาบาลกรณีฉุกเฉิน หรือกรณีบาดเจ็บหรือเจ็บป่วยที่เกิดขึ้นกะทันหัน \n(สูงสุด 45 วันต่อการเดินทางครั้งใดครั้งหนึ่งที่อยู่นอกอาณาเขต\nความคุ้มครอง)',
  ],
  FLEXI_HEALTH_BENEFIT_COMPENSATIONS: [
    'ระดับการชดเชยผลประโยชน์ทั้งในและนอกอาณาเขต',
    [
      '1. 100% ของค่าใช้จ่ายตามจริงแต่ไม่เกินวงเงินสูงสุด \nสำหรับการรักษาพยาบาลในโรงพยาบาลในกลุ่มเครือข่าย',
      '2. 100% ของการประเมินค่าชดเชยแบบเปรียบเทียบค่าใช้จ่ายปรกติวิสัย สำหรับการรักษาพยาบาลในโรงพยาบาลนอกกลุ่มเครือข่าย',
    ],
  ],
  // Mini BI iGrow
  BENEFIT_GENERAL_CASE: 'จากสาเหตุทั่วไป',
  BENEFIT_DEATH_ACCIDENT: 'ผลประโยชน์เพิ่มเติมกรณีเสียชีวิตจากอุบัติเหตุทั่วไป',
  BENEFIT_CASH_DROP: 'เงินจ่ายคืนตามกรมธรรม์ประกันภัย/เงินครบกำหนดสัญญา',
  BENEFIT_IGROW_DISCLAIMER: 'มูลค่าเวนคืนเงินสดเป็นมูลค่าที่มิได้รวม "เงินจ่ายคืนตามกรมธรรม์ประกันภัย"',

  LIFE_SAVE_PRO_CUMULATIVE_DEATH_BENEFIT: 'ผลประโยชน์กรณีเสียชีวิตรวมเงินจ่ายคืนระหว่างสัญญาที่จ่ายไปแล้ว',
  LIFE_SAVE_PRO_INCASE_WITH_COMPANY: 'กรณีสะสมไว้กับบริษัทฯ ด้วยอัตราดอกเบี้ยขั้นต่ำ',
  LIFE_SAVE_PRO_CASH_DROP_VALUE_1: 'เงินจ่ายคืนตามกรมธรรม์ประกันภัย',
  LIFE_SAVE_PRO_CASH_DROP_VALUE_2: 'และเงินครบกำหนดสัญญา',
  INCASE_OF_CASH_BACK: 'กรณีรับเงินจ่ายคืน',
  LIFE_SAVE_PRO_DISCLAIMER_REMARK_INVESTMENT_BENEFIT:
    'โปรแกรมใบข้อเสนอนี้ใช้สำหรับ {{& productName }} ที่เสนอขายตั้งแต่ {{ startOffer }} ถึง {{ endOffer }} หรือตามประกาศจากบริษัทฯ (แล้วแต่ระยะเวลาใดสั้นกว่า)',
  LIFE_SAVE_PRO_DISCLAIMER_INFORM_INVESTMENT_BENEFIT: `* หมายเหตุ
  การแสดงเงินปันผลที่ไม่รับรองการจ่าย ในเอกสารฉบับนี้เป็นการประมาณโดยใช้สมมติฐานของอัตราผลตอบแทนการลงทุน 3 อัตรา ได้แก่ 2%, 3% และ 4.5% ด้วยอัตราคงที่ทุกปี และปัจจัยอื่นที่เกี่ยวข้องไม่มีการเปลี่ยนแปลง โดยการประมาณการดังกล่าวข้างต้นมีวัตถุประสงค์ที่แสดงให้เห็นถึงความแตกต่างของเงินปันผลที่ไม่รับรองการจ่ายตามอัตราผลตอบแทนการลงทุนที่แตกต่างกัน ซึ่งมูลค่าที่แสดงนี้ไม่ได้หมายความถึงอัตราผลตอบแทนขั้นต่ำหรือขั้นสูงที่พึงจะได้จากเงินปันผลของผลิตภัณฑ์นี้ เนื่องจากบริษัทฯ ไม่สามารถรับรองได้ว่าอัตราผลตอบแทนในอนาคตจะเป็นไปตามที่ประมาณการไว้ รวมถึงมูลค่าเงินปันผลนี้อาจมีผลกระทบจากปัจจัยอื่นที่ไม่สามารถคาดการณ์ได้ หรืออยู่นอกเหนือความควบคุมของบริษัทฯ ดังนั้นเงินปันผลที่แสดงนี้จึงเป็นส่วนที่ไม่รับรองการจ่าย  ทั้งนี้เงินปันผลที่จะจ่ายจริงอาจมีการ “ปรับปรุง” ตามนโยบายของบริษัทฯ กล่าวคือบริษัทมีความพยายามที่จะจ่ายผลตอบแทนให้กับผู้ถือกรมธรรม์ทุกท่านอย่างสมดุลและใกล้เคียงกันในแต่ละปี ดังนั้นผลตอบแทนจากการลงทุนที่แท้จริงนี้ อาจไม่มีความสัมพันธ์โดยตรงกับรายได้จากการลงทุนของบริษัทฯ เพื่อการจ่ายเงินปันผลนี้
  `,
  LIFE_SAVE_PRO_POLICY_VALUE_TABLE_NOTE_1:
    '*  มูลค่าเวนคืนกรมธรรม์เป็นมูลค่าที่มิได้รวม "เงินจ่ายคืนตามกรมธรรม์ประกันภัย" ยกเว้นปีที่ครบกำหนดสัญญา',
  LIFE_SAVE_PRO_POLICY_VALUE_TABLE_NOTE_2:
    'กรณีที่มีการกู้เงินตามกรมธรรม์ มูลค่าเวนคืนกรมธรรม์จะลดลงตามจำนวนเงินกู้และอัตราดอกเบี้ยเงินกู้',
  LIFE_SAVE_PRO_POLICY_VALUE_TABLE_NOTE_3:
    '** สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปี โดยเบี้ยประกันภัยของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก',
  LIFE_SAVE_PRO_POLICY_VALUE_TABLE_NOTE_4:
    'อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้',
  LIFE_SAVE_PRO_POLICY_VALUE_TABLE_NOTE_5: 'แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  LIFE_SAVE_PRO_INVESTMENT_VALUE_TABLE_NOTE_1:
    '*** การแสดงเงินปันผลที่ไม่รับรองการจ่าย ในข้อ 3) เป็นการประมาณโดยใช้สมมติฐานของอัตราผลตอบแทนการลงทุนที่แตกต่างกัน ด้วยอัตราคงที่ทุกปี โดยการประมาณการดังกล่าวข้างต้นมีวัตถุประสงค์ที่แสดงให้เห็นถึงความแตกต่างของเงินปันผลที่ไม่รับรองการจ่ายตามอัตราผลตอบแทนการลงทุนที่แตกต่างกัน ซึ่งมูลค่าที่แสดงนี้ไม่ได้หมายความถึงอัตราผลตอบแทนขั้นต่ำหรือขั้นสูงที่พึงจะได้จากเงินปันผลของผลิตภัณฑ์นี้',
  LIFE_SAVE_PRO_CASH_SURRENDER_VALUE: 'มูลค่าเวนคืน\nกรมธรรม์*',

  //iHealthy Ultra
  IHEALTHY_ULTRA_POLICY_VALUE_TABLE_NOTE_1:
    '*  มูลค่าเวนคืนกรมธรรม์เป็นมูลค่าที่มิได้รวม "เงินจ่ายคืนตามกรมธรรม์ประกันภัย" ยกเว้นปีที่ครบกำหนดสัญญา',
  IHEALTHY_ULTRA_POLICY_VALUE_TABLE_NOTE_2:
    'กรณีที่มีการกู้เงินตามกรมธรรม์ มูลค่าเวนคืนกรมธรรม์จะลดลงตามจำนวนงินกู้และอัตราดอกเบี้ยเงินกู้',
  IHEALTHY_ULTRA_POLICY_VALUE_TABLE_NOTE_3:
    '** สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปี โดยเบี้ยประกันภัยของสัญญาเพิ่มเติมนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก',
  IHEALTHY_ULTRA_POLICY_VALUE_TABLE_NOTE_4:
    'อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้',
  IHEALTHY_ULTRA_POLICY_VALUE_TABLE_NOTE_5: 'แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',

  //iSmart 80/6
  ISMART_80_6_POLICY_VALUE_TABLE_NOTE_1: '1. เงินค่าเวนคืนกรมธรรม์ประกันภัยข้างต้นเป็นจำนวนเงินก่อนหักหนี้สินใดๆ',
  ISMART_80_6_POLICY_VALUE_TABLE_NOTE_2:
    '2. เงินค่าเวนคืนกรมธรรม์ประกันภัยที่แสดงไว้ในตารางเป็นจำนวนเงินที่หักเงินจ่ายคืน (ถ้ามี) ออกแล้ว',
  ISMART_80_6_POLICY_VALUE_TABLE_NOTE_3:
    '3. กรณีเสียชีวิต บริษัทจะจ่ายร้อยละ 200 ของจำนวนเงินเอาประกันภัย หรือมูลค่าเวนคืนกรมธรรม์หรือร้อยละ 101 ของเบี้ยประกันภัยของกรมธรรม์หลักที่ชำระมาแล้วทั้งหมด แล้วแต่จำนวนใดจะมากกว่า',

  //Life Protech 18
  POLICY_VALUE_TABLE_DISCLAIMER_ONE: '1. เงินค่าเวนคืนกรมธรรม์ประกันภัยข้างต้นเป็นจำนวนเงินก่อนหักหนี้สินใด ๆ',
  POLICY_VALUE_TABLE_DISCLAIMER_TWO:
    '2. เงินค่าเวนคืนกรมธรรม์ประกันภัยที่แสดงไว้ในตารางเป็นจำนวนเงินที่หักเงินจ่ายคืน (ถ้ามี) ออกแล้ว',
  POLICY_VALUE_TABLE_DISCLAIMER_THREE:
    '3. กรณีเสียชีวิต บริษัทจะจ่ายจำนวนเงินเอาประกันภัย หรือมูลค่าเวนคืนกรมธรรม์ หรือร้อยละ 101 ของเบี้ยประกันภัยของกรมธรรม์หลักที่ชำระมาแล้วทั้งหมดแล้วแต่จำนวนใดจะมากกว่า',
  POLICY_VALUE_TABLE_DISCLAIMER_FOUR:
    '4. เบี้ยประกันภัยของสัญญาเพิ่มเติมที่แสดงในเอกสารเสนอขายนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  LIFE_PROTECT_18_NAMETHAI: 'ไลฟ์โพรเทค 18',

  //Super7
  POLICY_VALUE_TABLE_S7_DISCLAIMER_ONE:
    '1. ผลประโยชน์ กรณีเสียชีวิต, ความคุ้มครองโรคร้ายแรง, เงินครบกำหนดสัญญา, เงินค่าเวนคืนกรมธรรม์ประกันภัยข้างต้นเป็นจำนวนเงินก่อนหักหนี้สินใด ๆ',
  POLICY_VALUE_TABLE_S7_DISCLAIMER_TWO:
    '2. กรณีเสียชีวิต บริษัทจะจ่าย 100%ของจำนวนเงินเอาประกันภัย หรือมูลค่าเวนคืนกรมธรรม์ หรือ101%ของเบี้ยประกันภัยของกรมธรรม์หลักที่ชำระมาแล้วทั้งหมด แล้วแต่จำนวนใดจะมากกว่า',
  POLICY_VALUE_TABLE_S7_DISCLAIMER_THREE:
    '3. หากผู้เอาประกันภัยได้รับผลประโยชน์ความคุ้มครองโรคร้ายแรงแล้ว กรมธรรม์จะสิ้นสุดลงทันที ',

  //ICARE AND SUKHAPABDEKDEE
  POLICY_VALUE_TABLE_ICARE_DISCLAIMER_THREE:
    '3. กรณีเสียชีวิต บริษัทจะจ่ายจำนวนเงินเอาประกันภัย หรือเบี้ยประกันภัยของกรมธรรม์หลักที่ชำระมาแล้วทั้งหมดแล้วแต่จำนวนใดจะมากกว่า',

  //PLB
  PLB_POLICY_VALUE_TABLE_DISCLAIMER_ONE:
    'เบี้ยประกันภัยของสัญญาเพิ่มเติมที่แสดงในเอกสารเสนอขายนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  //Retirement
  RETIREMENT_POLICY_VALUE_TABLE: 'ตารางมูลค่ากรมธรรม์ {{pensionType}}',
  RETIREMENT_BUMNAN_READY_POLICY_VALUE_TABLE: 'ตารางผลประโยชน์ตามกรมธรรม์ {{pensionType}}',
  RETIREMENT_POLICY_VALUE_PENSION: 'เงินบำนาญ จ่าย ณ ต้นปีกรมธรรม์',
  RETIREMENT_POLICY_VALUE_PENSION_MONTHLY: 'เงินบำนาญ จ่าย ณ วันต้นเดือนของปีกรมธรรม์',
  RETIREMENT_POLICY_VALUE_PENSION_PDF: 'เงินบำนาญ จ่าย \n ณ ต้นปีกรมธรรม์',
  RETIREMENT_POLICY_VALUE_PENSION_MONTHLY_PDF: 'เงินบำนาญ จ่าย \n ณ วันต้นเดือน \n ของปีกรมธรรม์',
  RETIREMENT_POLICY_VALUE_CUMULATIVE_PENSION_AMOUNT: 'เงินบำนาญสะสม',
  RETIREMENT_POLICY_VALUE_BEFORE_PENSION_WITH_NOTE: 'ผลประโยชน์ก่อนรับเงินบำนาญ**',
  RETIREMENT_POLICY_VALUE_ALLOW_PENSION_NOTE_2: 'ผลประโยชน์ช่วงรับเงินบำนาญ**',
  RETIREMENT_POLICY_VALUE_ALLOW_PENSION_WITHOUT_NOTE: 'ผลประโยชน์ช่วงรับเงินบำนาญ',
  RETIREMENT_POLICY_VALUE_ANNUAL_TOTAL_PENSION: 'มูลค่าปัจจุบันของเงินบำนาญรับรองการจ่ายที่ยังไม่ครบ 15 งวด',
  RETIREMENT_POLICY_VALUE_MONTHLY_TOTAL_PENSION: 'มูลค่าปัจจุบันของเงินบำนาญรับรองการจ่ายที่ยังไม่ครบ 180 งวด',
  RETIREMENT_POLICY_VALUE_MONTHLY: 'เดือนที่',
  RETIREMENT_POLICY_VALUE_NOTE_1:
    '* เบี้ยประกันภัยของสัญญาเพิ่มเติมที่แสดงในเอกสารเสนอขายนี้ อาจมีการเปลี่ยนแปลงอันเนื่องมาจาก อายุ ขั้นอาชีพ ค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของสัญญาเพิ่มเติมนี้ แต่ทั้งนี้ขึ้นอยู่กับเงื่อนไขในกรมธรรม์',
  RETIREMENT_POLICY_VALUE_NOTE_2: '** เงินค่าเวนคืนกรมธรรม์ประกันภัยข้างต้นเป็นจำนวนเงินก่อนหักหนี้สินใด ๆ',
  RETIREMENT_POLICY_VALUE_NUMBER_NOTE_1:
    '1. ผลประโยชน์กรณีเสียชีวิตและมูลค่ากรมธรรม์ประกันภัยข้างต้นเป็นมูลค่าก่อนหักหนี้สินใด ๆ (ถ้ามี)',
  RETIREMENT_POLICY_VALUE_NUMBER_NOTE_2:
    '2. เงินค่าเวนคืนกรมธรรม์ประกันภัยที่แสดงไว้ในตารางเป็นจำนวนเงินก่อนหักเงินจ่ายคืน (ถ้ามี)',
  LIFE_RETIREMENT_POLICY_VALUE_NOTE_2:
    '** ผลประโยชน์กรณีเสียชีวิตและมูลค่ากรมธรรม์ประกันภัยข้างต้นเป็นมูลค่าก่อนหักหนี้สินใด ๆ (ถ้ามี)',
  LIFE_RETIREMENT_POLICY_VALUE_NOTE_3:
    '*** เงินค่าเวนคืนกรมธรรม์ประกันภัยที่แสดงไว้ในตารางเป็นจำนวนเงินก่อนหักเงินจ่ายคืน (ถ้ามี)',
  RETIREMENT_POLICY_VALUE_NOTE_3:
    '   เงินค่าเวนคืนกรมธรรม์ประกันภัยที่แสดงไว้ในตารางเป็นจำนวนเงินที่หักเงินจ่ายคืน (ถ้ามี) ออกแล้ว',
  RETIREMENT_POLICY_VALUE_NOTE_4_ANNUALLY:
    '*** มูลค่าปัจจุบันของเงินบำนาญรับรองการจ่ายที่ยังไม่ครบ 15 งวด หรือเบี้ยหลักสะสมหักเงินบำนาญที่จ่ายแล้ว',
  RETIREMENT_POLICY_VALUE_NOTE_4_MONTHLY:
    '*** มูลค่าปัจจุบันของเงินบำนาญรับรองการจ่ายที่ยังไม่ครบ 180 งวด หรือเบี้ยหลักสะสมหักเงินบำนาญที่จ่ายแล้ว',
  RETIREMENT_POLICY_VALUE_NOTE_5:
    '**** ผู้เอาประกันภัยสามารถเปลี่ยนรูปแบบการรับเงินบำนาญได้ ทั้งนี้จะต้องแจ้งเปลี่ยนก่อนการจ่ายเงินบำนาญงวดแรก',
  RETIREMENT_SURRENDER_VALUE_END_OF_YEAR_NOTE: 'เงินค่าเวนคืนกรมธรรม์ประกันภัย*** (ณ สิ้นปีกรมธรรม์)',
  RETIREMENT_SURRENDER_VALUE_END_OF_YEAR_NOTE_PDF: 'เงินค่าเวนคืน \n กรมธรรม์ \n ประกันภัย*** \n (ณ สิ้นปีกรมธรรม์)',
  RETIREMENT_POLICY_VALUE_ANNUAL_TOTAL_PENSION_PDF:
    'มูลค่าปัจจุบันของ \n เงินบำนาญรับรองการ \n จ่ายที่ยังไม่ครบ \n 15 งวด***',
  RETIREMENT_POLICY_VALUE_MONTHLY_TOTAL_PENSION_PDF:
    'มูลค่าปัจจุบันของ \n เงินบำนาญรับรองการ \n จ่ายที่ยังไม่ครบ \n 180 งวด***',
  TOTAL_BENEFIT_PENSION_AGE_60_85_PDF: 'รวมรับผลประโยชน์เงินบำนาญ \n (ตั้งแต่อายุ 60 ปี ถึงอายุ 85 ปี)',
  TOTAL_BENEFIT_PENSION_AGE_60_88_PDF: 'รวมรับผลประโยชน์เงินบำนาญ \n (ตั้งแต่อายุ 60 ปี ถึงอายุ 88 ปี)',

  //MINI BI Retirement
  RETIREMENT_BENEFITS: 'ตารางสรุปผลประโยชน์ตามกรมธรรม์ {{pensionType}}',
  PENSION_AGE: '1. รับเงินบำนาญตามช่วงอายุ',
  PERIOD_AGE: 'ช่วงอายุ',
  PENSION_TYPE: 'กรณีเลือกรับเป็น{{pensionType}}',
  PENSION_AMOUNT: 'เป็นเงิน(บาท)',
  BENEFIT_PENSION_AGE_60_74: 'อายุ 60-74 รับผลประโยชน์งวดละ',
  PENSION_PERCENT: '{{pensionPercent}}% ของจำนวนเงินเอาประกันภัย',
  BENEFIT_PENSION_AGE_75_85: 'อายุ 75-85 รับผลประโยชน์งวดละ',
  BENEFIT_PENSION_AGE_60_85: 'อายุ 60-85 รับผลประโยชน์งวดละ',
  TOTAL_BENEFIT_PENSION_AGE_60_85: 'รวมรับผลประโยชน์เงินบำนาญ (ตั้งแต่อายุ 60 ปี ถึงอายุ 85 ปี)',
  BENEFIT_PENSION_AGE_60_88: 'อายุ 60-88 ปี รับผลประโยชน์งวดละ',
  BENEFIT_PENSION_AGE_60_70: 'อายุ 60-70 ปี รับผลประโยชน์งวดละ',
  BENEFIT_PENSION_AGE_71_80: 'อายุ 71-80 ปี รับผลประโยชน์งวดละ',
  BENEFIT_PENSION_AGE_81_88: 'อายุ 81-88 ปี รับผลประโยชน์งวดละ',
  TOTAL_BENEFIT_PENSION_AGE_60_88: 'รวมรับผลประโยชน์เงินบำนาญ (ตั้งแต่อายุ 60 ปี ถึงอายุ 88 ปี)',
  MAXIMUM_PENSION_PERIOD: 'สูงสุด {{totalPensionPeriod}} งวดรวมเป็นเงิน',
  BUMNAN_READY_MAXIMUM_PENSION_PERIOD: 'สูงสุด {{totalPensionPeriod}} งวด รวมเป็นเงิน',
  RETIREMENT_DEATH_BENEFIT: '2. ผลประโยชน์กรณีเสียชีวิต',
  RETIREMENT_DEATH_BENEFIT_1:
    '2.1 ช่วงก่อนอายุ 60 ปี รับ {{deadCoverageSurrender}}% ของจำนวนเงินเอาประกันภัย หรือมูลค่าเวนคืนกรมธรรม์ หรือ {{deadCoverageStandard}}% ของเบี้ยประกันภัยมาตรฐานของกรมธรรม์หลักที่ชำระมาแล้วทั้งหมด แล้วแต่จำนวนใดที่มากกว่า',
  MINIMUN_DEATH_COVERAGE: 'ขั้นต่ำ {{minimunDeathCoverage}} บาท',
  BENEFIT_BEFORE_GET_PENSION: 'ผลประโยชน์ก่อนรับเงินบำนาญ',
  BENEFIT_DURING_GET_PENSION: 'ผลประโยชน์ช่วงรับเงินบำนาญ****',
  RETIREMENT_CASH_SURRENDER_VALUE: 'มูลค่าเวนคืน \n กรมธรรม์** \n (ณ สิ้นปีกรมธรรม์)',
  RETIREMENT_SURRENDER_VALUE_END_OF_YEAR: 'เงินค่าเวนคืน \n กรมธรรม์ประกันภัย \n (ณ สิ้นปีกรมธรรม์)',
  CURRENT_PENSION_AMOUNT:
    'มูลค่าปัจจุบันของเงินบำนาญรับรองการจ่ายที่ยังไม่ครบ {{pensionPeriod}} งวดหรือเบี้ยหลักสะสมหักบำนาญที่จ่ายแล้ว',

  //Life Retire Death Benefit
  LIFE_RETIRE_DEATH_BENEFIT_1:
    '2.1 ช่วงก่อนอายุ 60 ปี รับ {{deadCoverageSurrender}}% ของจำนวนเงินเอาประกันภัย หรือ {{deadCoverageStandard}}% ของมูลค่าเวนคืนกรมธรรม์ หรือ {{deadCoverageStandard}}% ของเบี้ยประกันภัยที่ชำระมาแล้วทั้งหมด (ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่น ๆ) แล้วแต่จำนวนใดจะมากกว่า',
  RETIREMENT_DEATH_BENEFIT_2: '2.2 ช่วงอายุ 60-74 ปี รับเป็นเงินก้อน',
  DEATH_COVERAGE_AGE_60_74:
    'ตามมูลค่าปัจจุบันของเงินบำนาญที่รองรับการจ่ายงวดที่เหลือที่ยังไม่ครบ {{pensionPeriod}} งวด หรือ 100% ของเบี้ยประกันภัยมาตรฐานของกรมธรรม์หลักที่ชำระมาแล้วทั้งหมดหักด้วยเงินบำนาญที่จ่ายไปแล้ว แล้วแต่จำนวนใดจะมากกว่า',
  LIFE_RETIRE_DEATH_COVERAGE_AGE_60_74:
    'รับเงินบำนาญที่ยังไม่ได้จ่าย ตามตารางมูลค่าปัจจุบันของเงินบำนาญหรือ 100% ของเบี้ยประกันภัยที่ชำระมาแล้วทั้งหมด (ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่น ๆ) หักด้วยเงินบำนาญที่จ่ายไปแล้วทั้งหมด แล้วแต่จำนวนใดจะมากกว่า',
  RETIREMENT_DEATH_BENEFIT_3: '2.3 หลังจากอายุ 74 ปี เมื่อรับเงินบำนาญงวดที่ {{pensionPeriod}} แล้ว',
  DEATH_COVERAGE_AGE_AFTER_75:
    'ลูกค้าจะได้รับเงินบำนาญตามการมีชีวิตอยู่ กรณีเลือกรับรายเดือนแล้วเสียชีวิตในระหว่างปีกรมธรรม์ บริษัทจะจ่ายเงินบำนาญของเดือนที่เหลืออยู่ของปีกรมธรรม์ที่ผู้เอาประกันภัยเสียชีวิตจนครบรอบปี',
  LIFE_RETIRE_DEATH_BENEFIT_3:
    '2.3 หลังจากอายุ 74 ปี เมื่อรับเงินบำนาญงวดที่ 15 กรณีเลือกรับบำนาญรายปีหรืองวดที่ 180 กรณีเลือกรับบำนาญรายเดือนแล้ว',
  LIFE_RETIRE_DEATH_COVERAGE_AGE_AFTER_75:
    '100% ของเบี้ยประกันภัยที่ชำระมาแล้วทั้งหมด (ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่น ๆ) หักด้วยเงินบำนาญที่จ่ายไปแล้วทั้งหมด',

  //Bumnan Ready Death Benefit
  BUMNAN_READY_DEATH_BENEFIT_1: '2.1 ช่วงก่อนอายุ 60 ปี',
  BUMNAN_READY_DEATH_BENEFIT_1_1: '- กรณีเสียชีวิตระหว่างปีกรมธรรม์ที่ 1-4 \nรับ 100% ของจำนวนเงินเอาประกันภัย *',
  BUMNAN_READY_DEATH_BENEFIT_1_2:
    '- กรณีเสียชีวิตระหว่างปีกรมธรรม์ที่ 5 \nเป็นต้นไป รับ 180% ของจำนวนเงินเอาประกันภัย *',
  BUMNAN_READY_DEATH_BENEFIT_1_DISCLAIMER:
    '* หรือ 100% ของมูลค่าเวนคืนกรมธรรม์ หรือ 101% \nของเบี้ยประกันภัยของกรมธรรม์ประกันภัยหลัก (ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่นๆ \n(ถ้ามี)) ที่ชำระมาแล้วทั้งหมด แล้วแต่จำนวนใดจะมากกว่า',
  BUMNAN_READY_DEATH_BENEFIT_2: '2.2 ช่วงอายุ 60-74 ปี',
  BUMNAN_READY_DEATH_COVERAGE_AGE_60_74:
    'มูลค่าปัจจุบันของเงินบำนาญสำหรับงวดที่ยังไม่ได้จ่าย \nตามตารางมูลค่าปัจจุบันของเงินบำนาญแบบรับรองการจ่าย \nหรือ [100% ของเบี้ยประกันภัยของกรมธรรม์ประกันภัยหลัก \n(ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่นๆ (ถ้ามี) ) \nที่ชำระมาแล้วทั้งหมด หักด้วยเงินบำนาญที่จ่ายไปแล้วทั้งหมด] \nแล้วแต่จำนวนใดจะมากกว่า',
  BUMNAN_READY_DEATH_BENEFIT_3:
    '2.3 หลังจากอายุ 74 ปี (เมื่อรับเงินบำนาญงวดที่ 15 \nกรณีเลือกรับบำนาญรายปี หรืองวดที่ 180 \nกรณีเลือกรับบำนาญรายเดือนแล้ว)',
  BUMNAN_READY_DEATH_COVERAGE_AGE_AFTER_75:
    '100% ของเบี้ยประกันภัยของกรมธรรม์ประกันภัยหลัก \n(ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่นๆ (ถ้ามี) ) \nที่ชำระมาแล้วทั้งหมด หักด้วยเงินบำนาญที่จ่ายไปแล้วทั้งหมด \nทั้งนี้ จะไม่มีการจ่ายผลประโยชน์กรณีเสียชีวิต \nหากเงินบำนาญที่จ่ายไปแล้วทั้งหมดมากกว่าเบี้ยประกันภัยของกรมธรรม์ประกันภัยหลัก \n(ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่นๆ (ถ้ามี) ) ที่ชำระมาแล้ว',
  BUMNAN_READY_DEATH_COVERAGE_AGE_AFTER_75_PDF:
    '100% ของเบี้ยประกันภัยของกรมธรรม์ประกันภัยหลัก \n(ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่นๆ (ถ้ามี) ) \nที่ชำระมาแล้วทั้งหมด หักด้วยเงินบำนาญที่จ่ายไปแล้วทั้งหมด \nทั้งนี้ จะไม่มีการจ่ายผลประโยชน์กรณีเสียชีวิต \nหากเงินบำนาญที่จ่ายไปแล้วทั้งหมดมากกว่าเบี้ยประกันภัย\nของกรมธรรม์ประกันภัยหลัก \n(ไม่รวมเบี้ยประกันภัยของสัญญาเพิ่มเติมอื่นๆ (ถ้ามี) ) ที่ชำระมาแล้ว',

  //Tax Benefit
  RETIREMENT_TAX_BENEFIT_SUB_LIST: [
    { description: 'เบี้ยประกันชีวิตแบบบำนาญ ปีละ', benefit: '{{value}} บาท' },
    {
      description: 'เบี้ยประกันชีวิต(สัญญาเพิ่มเติมแบบชั่วระยะเวลา ที่ระยะคุ้มครองตั้งแต่ 10 ปีเป็นต้นไป) ปีละ',
      benefit: '{{value}} บาท',
    },
  ],
  RETIREMENT_TAX_BENEFIT_SUB_ADDITIONAL:
    'เบี้ยประกันภัยสำหรับการประกันชีวิต สามารถนำไปใช้สิทธิลดหย่อนภาษีเงินได้ตามกฎเกณฑ์ของกรมสรรพากร ทั้งนี้ หากผู้เอาประกันภัยไม่ปฎิบัติตามกฎเกณฑ์ของกรมสรรพากร ผู้เอาประกันภัยอาจถูกเรียกคืนภาษี',
  RETIREMENT_TAX_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันของประกันชีวิตแบบบำนาญ',
      'สามารถนำไปใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดาตามประกาศอธิบดีกรมสรรพากรเกี่ยวกับภาษีเงินได้ฉบับที่ 172 (ลดหย่อนภาษีสูงสุด 100,000 บาท) และฉบับที่ 194 (ลดหย่อนภาษีสูงสุด 200,000 บาท)',
    ],
    [
      'เบี้ยประกันชีวิต(สัญญาเพิ่มเติมแบบชั่วระยะเวลา ที่ระยะคุ้มครองตั้งแต่ 10 ปีเป็นต้นไป)',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไปให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'โปรแกรมข้อเสนอขายนี้ ยังไม่ได้ระบุสิทธิในการลดหย่อนภาษีสำหรับเบี้ยประกันสุขภาพ กรุณาติดต่อบริษัทฯ เพื่อรับข้อมูลเพิ่มเติม',
    ],
  ],
  RETIREMENT_TAX_CONSENT_BENEFIT_SUB_LIST: [
    { description: 'เบี้ยประกันชีวิตแบบบำนาญ ปีละ', benefit: '{{value}} บาท' },
    {
      description: 'เบี้ยประกันชีวิต(สัญญาเพิ่มเติมแบบชั่วระยะเวลา ที่ระยะคุ้มครองตั้งแต่ 10 ปีเป็นต้นไป) ปีละ',
      benefit: '{{value}} บาท',
    },
    {
      description: 'เบี้ยประกันสุขภาพ ปีแรก',
      benefit: '{{value}} บาท',
    },
  ],
  RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันของประกันชีวิตแบบบำนาญ',
      'สามารถนำไปใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดาตามประกาศอธิบดีกรมสรรพากรเกี่ยวกับภาษีเงินได้ฉบับที่ 172 (ลดหย่อนภาษีสูงสุด 100,000 บาท) และฉบับที่ 194 (ลดหย่อนภาษีสูงสุด 200,000 บาท)',
    ],
    [
      'เบี้ยประกันชีวิต(สัญญาเพิ่มเติมแบบชั่วระยะเวลา ที่ระยะคุ้มครองตั้งแต่ 10 ปีเป็นต้นไป)',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไปให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'เบี้ยประกันสุขภาพ',
      'ตามประกาศอธิบดีกรมสรรพากร สำหรับอ้างอิงการใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดา โดยเป็นไปตามเงื่อนไขข้อกำหนดของกรมสรรพากร',
    ],
  ],
  BI_RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันของประกันชีวิตแบบบำนาญ',
      'สามารถนำไปใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดาตามประกาศอธิบดีกรมสรรพากรเกี่ยวกับภาษีเงินได้ฉบับที่ 172 (ลดหย่อนภาษีสูงสุด 100,000 บาท) และฉบับที่ 194 (ลดหย่อนภาษีสูงสุด 200,000 บาท)',
    ],
    [
      'เบี้ยประกันชีวิต(สัญญาเพิ่มเติมแบบชั่วระยะเวลา ที่ระยะคุ้มครองตั้งแต่ 10 ปีเป็นต้นไป)',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดา\nสำหรับกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไปให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'เบี้ยประกันสุขภาพ',
      'ตามประกาศอธิบดีกรมสรรพากร สำหรับอ้างอิงการใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดา โดยเป็นไปตามเงื่อนไขข้อกำหนดของกรมสรรพากร',
    ],
  ],
  BI_RETIREMENT_TAX_BENEFIT_SUB_ADDITIONAL:
    'เบี้ยประกันภัยสำหรับการประกันชีวิต สามารถนำไปใช้สิทธิลดหย่อนภาษีเงินได้ตามกฎเกณฑ์ของกรมสรรพากร ทั้งนี้ หากผู้เอาประกันภัยไม่ปฎิบัติตามกฎเกณฑ์ของ\nกรมสรรพากร ผู้เอาประกันภัยอาจถูกเรียกคืนภาษี',
  BI_RETIREMENT_TAX_BENEFIT_SUB_NOTES: [
    [
      'เบี้ยประกันของประกันชีวิตแบบบำนาญ',
      'สามารถนำไปใช้สิทธิหักลดหย่อนภาษีเงินได้บุคคลธรรมดาตามประกาศอธิบดีกรมสรรพากรเกี่ยวกับภาษีเงินได้\nฉบับที่ 172 (ลดหย่อนภาษีสูงสุด 100,000 บาท) และฉบับที่ 194 (ลดหย่อนภาษีสูงสุด 200,000 บาท)',
    ],
    [
      'เบี้ยประกันชีวิต(สัญญาเพิ่มเติมแบบชั่วระยะเวลา ที่ระยะคุ้มครองตั้งแต่ 10 ปีเป็นต้นไป)',
      'เงื่อนไขในการใช้สิทธิลดหย่อนภาษีเงินได้บุคคลธรรมดาสำหรับ\nกรมธรรม์ประกันชีวิตที่ทำหลังปี พ.ศ. 2551 เป็นต้นไปให้เป็นไปตามที่ประกาศอธิบดีกรมสรรพากร ฉบับที่ 172 กำหนด',
    ],
    [
      'โปรแกรมข้อเสนอขายนี้ ยังไม่ได้ระบุสิทธิในการลดหย่อนภาษีสำหรับเบี้ยประกันสุขภาพ กรุณาติดต่อบริษัทฯ เพื่อรับข้อมูลเพิ่มเติม',
    ],
  ],

  //MINI BI 12PL
  TWELVE_PL_GUARANTEE_CASHDROP: 'เงินจ่ายคืนตามกรมธรรม์ประกันภัย และเงินครบกำหนดสัญญา (ณ สิ้นปีกรมธรรม์)',
  TWELVE_PL_INCASE_OF_CUMULATIVE: 'กรณีสะสมไว้กับบริษัทฯ ด้วยอัตราดอกเบี้ยขั้นต่ำ 0.5% ต่อปี***',
  TWELVE_PL_DIVIDEND: 'เงินปันผล** (ณ สิ้นปีกรมธรรม์)',
  TWELVE_PL_GUARANTEE_CASHDROP_WITH_DIVIDEND:
    'รวมเงินจ่ายคืนตามกรมธรรม์ประกันภัยและเงินปันผล (กรณีสะสมไว้กับบริษัทฯ ด้วยอัตราดอกเบี้ยขั้นต่ำ 0.5% ต่อปี***) และเงินครบกำหนดสัญญา (ณ สิ้นปีกรมธรรม์)',
  TWELVE_PL_DEATH_BENEFIT_COVERAGE: 'ผลประโยชน์กรณีเสียชีวิต รวมเงินจ่ายคืนระหว่างสัญญาที่จ่ายไปแล้ว',
  TWELVE_PL_SURRENDER_CASH: 'มูลค่าเวนคืน กรมธรรม์ * (ณ สิ้นปีกรมธรรม์)',

  TWELVE_PL_BENEFIT_SUMMARY_SCENARIO:
    'ตัวอย่างผลประโยชน์ตามกรมธรรม์ เมื่อรวมเงินปันผลไม่รับรองการจ่าย โดยเทียบกับอัตราผลตอบแทนจากการลงทุนที่แตกต่างกัน**',
  TWELVE_PL_BENEFIT_NONGUARANTEE_MATURITY: '3) เงินปันผล** ไม่รับรองการจ่าย รวมตลอดสัญญา',
  TWELVE_PL_BENEFIT_NONGUARANTEE_TOTAL: 'รวมผลประโยชน์ตามกรมธรรม์ทั้งสิ้นตลอดสัญญา (รวมเงินปันผล**)',
  TWELVE_PL_BENEFIT_DISCLAIMER:
    '** การแสดงเงินปันผลที่ไม่รับรองการจ่าย เป็นการประมาณโดยใช้สมมติฐานของอัตราผลตอบแทนการลงทุนที่แตกต่างกัน โดยการประมาณการดังกล่าวข้างต้นมีวัตถุประสงค์ที่แสดงให้เห็นถึงความแตกต่างของเงินปันผลที่ไม่รับรองการจ่ายตามอัตราผลตอบแทนการลงทุนที่แตกต่างกัน ซึ่งมูลค่าที่แสดงนี้ไม่ได้หมายความถึงอัตราผลตอบแทนขั้นต่ำหรือขั้นสูงที่พึงจะได้จากเงินปันผลของผลิตภัณฑ์นี้',
  TWELVE_PL_POLICY_VALUE_NOTE_1:
    '* มูลค่าเวนคืนกรมธรรม์เป็นมูลค่าที่มิได้รวม "เงินจ่ายคืนตามกรมธรรม์ประกันภัย" ยกเว้นปีที่ครบกำหนดสัญญา กรณีที่มีการกู้เงินตามกรมธรรม์ มูลค่าเวนคืนกรมธรรม์จะลดลงตามจำนวนเงินกู้และอัตราดอกเบี้ยเงินกู้',
  TWELVE_PL_POLICY_VALUE_NOTE_3: '*** อัตราดอกเบี้ยกรณีสะสมเงินจ่ายคืนรายงวดขั้นต่ำ ณ ปัจจุบัน',

  CI_UDR_RIDER_SUMMARY_TITLE: 'สรุปผลประโยชน์สัญญาเพิ่มเติมคริติคอลลิงค์ แบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุน',
  TPD_UDR_RIDER_SUMMARY_TITLE: 'สรุปผลประโยชน์สัญญาเพิ่มเติมทีพีดีลิงค์ แบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุน',
  HB_UDR_RIDER_SUMMARY_TITLE: 'สรุปผลประโยชน์สัญญาเพิ่มเติมแคชลิงค์ แบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุน',
  HS_UDR_RIDER_SUMMARY_TITLE:
    'สรุปผลประโยชน์สัญญาเพิ่มเติมค่ารักษาพยาบาล เฮลธ์ลิงค์ แบบชำระค่าการประกันภัยโดยการขายคืนหน่วยลงทุน',

  // Mini BI GIO Product
  MAIN_CONTRACT_BENEFIT_SUMMARY_LIST: [
    { description: 'ผลประโยชน์กรณีเสียชีวิต (ขั้นต่ำ)', benefit: '{{value}} บาท' },
    {
      description: 'ผลประโยชน์เงินจ่ายคืน ณ วันครบกำหนดสัญญา',
      benefit: '{{value}} บาท',
    },
  ],

  //BI COMMOND
  IMPACT_INSURED_TITLE: 'ผลกระทบกรณีผู้เอาประกันภัยไม่ชำระเบี้ยประกันภัยภายในระยะเวลาผ่อนผัน',
  IMPACT_INSURED_MESSAGE:
    'ในกรณีที่ผู้เอาประกันภัยไม่ชำระเบี้ยประกันภัยภายในระยะเวลาผ่อนผัน จะถือว่ากรมธรรม์ขาดอายุนับแต่วันถึงกำหนดชำระเบี้ยประกันภัย  เว้นแต่ กรณีที่กรมธรรม์ได้มีการใช้สิทธิเกี่ยวกับมูลค่ากรมธรรม์ เพื่อให้กรมธรรม์มีผลบังคับตามที่ระบุในเงื่อนไขทั่วไปแห่งกรมธรรม์',

  //BI GIO
  GIO_VALUE_TABLE_NOTE_1:
    '*  บริษัทจะจ่ายสัดส่วนของจำนวนเงินเอาประกันภัย หรือมูลค่าเวนคืนกรมธรรม์แล้วแต่จำนวนใดจะมากกว่า',
  GIO_VALUE_TABLE_NOTE_2_S14G5T1:
    'สัดส่วน ปีกรมธรรม์ที่ 1 = 101% , ปีกรมธรรม์ที่ 2 = 202% , ปีกรมธรรม์ที่ 3 = 315% , ปีกรมธรรม์ที่ 4 = 420% และปีกรมธรรม์ที่ 5 เป็นต้นไป = 525%',
  GIO_VALUE_TABLE_NOTE_2_E10G3A:
    'สัดส่วน ปีกรมธรรม์ที่ 1 = 101% , ปีกรมธรรม์ที่ 2 = 202% , ปีกรมธรรม์ที่ 3 เป็นต้นไป = 315%',
  GIO_VALUE_TABLE_NOTE_3:
    '** มูลค่าเวนคืนกรมธรรม์เป็นมูลค่าที่มิได้รวม "เงินจ่ายคืนตามกรมธรรม์ประกันภัย" ยกเว้นปีที่ครบกำหนดสัญญา',
  GIO_VALUE_TABLE_NOTE_4:
    '*** ผลประโยชน์กรณีเสียชีวิต (ณ สิ้นปีกรมธรรม์) รวมเงินจ่ายคืนตามกรมธรรม์ประกันภัยระหว่างสัญญาในปีก่อนหน้า',

  //BI Common basicplan
  CONDITION_TITLE: 'เงื่อนไขทั่วไปของสัญญาหลัก',
  COMPLETED_TITLE: 'ความสมบูรณ์ของสัญญาประกันภัย',
  COMPLETED_MESSAGE:
    'ในกรณีที่ผู้เอาประกันภัยรู้อยู่แล้วและแถลงข้อความอันเป็นเท็จตามวรรคหนึ่ง หรือรู้อยู่แล้วในข้อความจริงใด แต่ไม่เปิดเผยข้อความจริงนั้นให้บริษัททราบ ซึ่งถ้าบริษัททราบข้อความจริงนั้น ๆ แล้วอาจจูงใจบริษัทให้เรียกเก็บเบี้ยประกันภัยสูงขึ้น หรือไม่ยอมทำสัญญา สัญญาประกันภัยนี้จะตกเป็น โมฆียะตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 865 ซึ่งบริษัทอาจบอกล้างสัญญาได้และไม่จ่ายเงินตามกรมธรรม์',
  NO_COVER_TITLE: 'กรณีที่บริษัทฯ จะไม่คุ้มครอง',
  NO_COVER_MESSAGE_ONE:
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 2 ปี นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ หรือตามการต่ออายุ หรือตามการกลับคืนสู่สถานะเดิม หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยในเฉพาะส่วนที่เพิ่ม เว้นแต่ ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่เอาประกันภัยนั้น หรือการแถลงอายุคลาดเคลื่อนจนอายุจริงอยู่นอกจำกัดอัตราเบี้ยประกันภัยตามทางค้าปกติ',
  NO_COVER_MESSAGE_TWO:
    'ฆ่าตัวตายภายใน 1 ปี นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ หรือตามการต่ออายุ หรือตามการกลับคืนสู่สถานะเดิม หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยในเฉพาะส่วนที่เพิ่ม หรือถูกผู้รับประโยชน์ฆ่าตาย',
  CLAIM_TITLE: 'สิทธิในการเรียกร้องสินไหม',
  CLAIM_MESSAGE:
    'ผู้เอาประกันภัยสามารถขอใช้สิทธิในการเรียกร้องสินไหมตามความคุ้มครองในเล่มกรมธรรม์ เช่น การเรียกร้องเงินตามกรมธรรม์ประกันภัย กรณีเสียชีวิตจากโรค, การเรียกร้องเงินตามกรมธรรม์ประกันภัยจากอุบัติเหตุ กรณีไม่เสียชีวิต, การเรียกร้องค่าสินไหมทดแทนกรณีค่ารักษาพยาบาล, การเรียกร้องเงินกรณีกรมธรรม์ประกันภัยครบกำหนดสัญญา เป็นต้น โปรดศึกษารายละเอียดเพิ่มเติมในกรมธรรม์',
  FREELOOK_TITLE: 'สิทธิในการขอยกเลิกกรมธรรม์ (Free Look Period) และค่าใช้จ่าย',
  FREELOOK_MESSAGE:
    'หากผู้เอาประกันภัย ประสงค์จะยกเลิกกรมธรรม์นี้ด้วยเหตุผลใดก็ตาม ผู้เอาประกันภัยสามารถส่งคืนกรมธรรม์มายังบริษัทภายใน 15 วัน นับแต่วันที่ได้รับกรมธรรม์จากบริษัทและบริษัทจะคืนเบี้ยประกันภัยที่เหลือจากการหักค่าตรวจสุขภาพตามที่จ่ายจริงและค่าใช้จ่ายของบริษัทฉบับละ 500 บาท ในกรณีที่ผู้เอาประกันภัยได้ใช้สิทธิเรียกร้องค่าสินไหมทดแทนแล้วผู้เอาประกันภัยไม่มีสิทธิ ยกเลิกกรมธรรม์ฉบับนี้',
  DELIVERY_PERIOD_TITLE: 'ระยะเวลาในการจัดส่งกรมธรรม์',
  DELIVERY_PERIOD_MESSAGE:
    'บริษัทฯ ใช้ระยะเวลาในการออกกรมธรรม์และการส่งมอบถึงผู้ขอเอาประกันภัยภายใน 15 วันทำการ นับจากวันที่อนุมัติกรมธรรม์ (รวมระยะเวลาในการพิมพ์กรมธรรม์ 3 วันทำการนับจากวันที่อนุมัติกรมธรรม์)',
  CHANNEL_TITLE: 'ช่องทางการติดต่อสำหรับการเรียกร้องสินไหม หรือการร้องเรียน',
  CHANNEL_MESSAGE:
    'ผู้เอาประกันภัย ผู้รับประโยชน์ หรือ ทายาทโดยธรรมของผู้เอาประกันภัยที่ประสงค์จะเรียกร้องสินไหมหรือการร้องเรียน ให้ยื่นคำร้องต่อบริษัทได้ ณ สำนักงานใหญ่ หรือ สำนักงานสาขาของบริษัทฯ พร้อมเอกสารหลักฐานที่เกี่ยวข้อง',

  //BI MEX
  MEX_DESCRIPTION: 'ค่ารักษาพยาบาล\nเอ็กซ์ตร้า',

  MEX_RIDER_BENEFIT_BAHT: 'ผลประโยชน์\n(บาท)',
  MEX_RIDER_BENEFIT_DAY_OR_TIME: 'จำนวนสูงสุด\n(วันหรือครั้ง)',
  MEX_RIDER_TOTAL_BENEFIT_BAHT: 'ผลประโยชน์สูงสุด\n(บาท)',

  //BI iHealthy
  IHEALTHY_CONDITION_TITLE: 'เงื่อนไขทั่วไปของ{{basicPlanName}} ({{basicPlanCode}})',

  //BI Ordinary Product
  ORDINARY_CHANNEL_MESSAGE_ADDITIONAL:
    'บริษัทฯขอสงวนสิทธิ์และลูกค้ารับทราบว่ารายละเอียดตามใบข้อเสนอนี้เป็นเพียงรายละเอียดเบื้องต้นจัดทำขึ้นเพื่อเสริมสร้างความเข้าใจเท่านั้น ผู้เอาประกันภัยกรุณาศึกษาและทำความเข้าใจในเอกสารเสนอขายนี้ ข้อกำหนดความคุ้มครองและเงื่อนไขโดยละเอียดจะระบุในกรมธรรม์ประกันภัยที่ออกให้โปรดศึกษารายละเอียดและเงื่อนไขความคุ้มครองจากกรมธรรม์ประกันภัย',

  //BI S7 Product
  S7_COMPLETED_MESSAGE:
    'ในกรณีที่ผู้เอาประกันภัยรู้อยู่แล้วและแถลงข้อความอันเป็นเท็จตามวรรคหนึ่งหรือรู้อยู่แล้วในข้อความจริงใด แต่ไม่เปิดเผยข้อความจริงนั้นให้บริษัททราบ ซึ่งถ้าบริษัททราบข้อความจริงนั้นๆ แล้วอาจจูงใจบริษัทให้เรียกเก็บเบี้ยประกันภัยสูงขึ้นหรือไม่ยอมทำสัญญาประกันภัย สัญญาประกันภัยนี้จะตกเป็นโมฆียะ ตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 865 ซึ่งบริษัทอาจบอกล้างสัญญาประกันภัย และไม่จ่ายเงินตามกรมธรรม์',
  S7_NO_COVER_MESSAGE_ONE:
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 2 ปี นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันภัย หรือตามการต่ออายุ เว้นแต่ ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่เอาประกันภัยนั้น หรือการแถลงอายุคลาดเคลื่อนจนอายุจริงอยู่นอกจำกัดอัตราเบี้ยประกันภัยตามทางค้าปกติ',
  S7_NO_COVER_MESSAGE_TWO:
    'ฆ่าตัวตายภายใน 1 ปี นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันภัย หรือตามการต่ออายุ หรือถูกผู้รับประโยชน์ฆ่าตาย',
  S7_CLAIM_MESSAGE:
    'ผู้เอาประกันภัย ผู้รับประโยชน์ หรือทายาทโดยธรรมของผู้เอาประกันภัย แล้วแต่กรณี สามารถขอใช้สิทธิในการเรียกร้องค่าสินไหมทดแทนตามความคุ้มครองในเล่มกรมธรรม์ เช่น การเรียกร้องเงินตามกรมธรรม์ประกันภัย กรณีเสียชีวิตจากโรค, การเรียกร้องเงินตามกรมธรรม์ประกันภัย กรณีเสียชีวิตจากอุบัติเหตุ หรือเหตุอื่น, การเรียกร้องค่าสินไหมทดแทน กรณีการประกันภัยโรคร้ายแรง, การเรียกร้องเงิน กรณีกรมธรรม์ประกันภัยครบกำหนดสัญญา เป็นต้น โปรดศึกษารายละเอียดเพิ่มเติมในบันทึกสลักหลังแนบท้ายกรมธรรม์ประกันภัย',
  S7_FREELOOK_MESSAGE:
    'หากผู้เอาประกันภัย ประสงค์จะยกเลิกกรมธรรม์นี้ด้วยเหตุผลใดก็ตาม ผู้เอาประกันภัยสามารถส่งคืนกรมธรรม์มายังบริษัทภายใน 15 วัน นับแต่วันที่ได้รับกรมธรรม์จากบริษัทและบริษัทจะคืนเบี้ยประกันภัยที่เหลือจากการหักค่าตรวจสุขภาพตามที่จ่ายจริงและค่าใช้จ่ายของบริษัทฉบับละ 500 บาท ในกรณีที่ผู้เอาประกันภัยได้ใช้สิทธิเรียกร้องค่าสินไหมทดแทนแล้ว ผู้เอาประกันภัยไม่มีสิทธิยกเลิกกรมธรรม์ฉบับนี้',
  S7_SURRENDER_TITLE:
    'สิทธิเวนคืนกรมธรรม์ประกันภัย หรือเปลี่ยนเป็นกรมธรรม์ใช้เงินสำเร็จ(RPU) หรือแปลงเป็นกรมธรรม์แบบขยายเวลา(ETI) หรือกู้เงิน',
  S7_SURRENDER_MESSAGE_ONE:
    'เมื่อมีมูลค่าเวนคืนในปีกรมธรรม์ใด ผู้เอาประกันภัยสามารถใช้สิทธิเวนคืนกรมธรรม์ประกันภัยหรือเปลี่ยนกรมธรรม์เป็นมูลค่าใช้เงินสำเร็จ หรือแปลงเป็นกรมธรรม์แบบขยายเวลา หรือกู้เงินตามเงื่อนไขของกรมธรรม์ประกันภัย',
  S7_SURRENDER_MESSAGE_TWO:
    'โดยหากผู้เอาประกันภัยใช้สิทธิเปลี่ยนเป็นกรมธรรม์ใช้เงินสำเร็จ หรือแปลงเป็นกรมธรรม์แบบขยายเวลา ผลประโยชน์ความคุ้มครองโรคร้ายแรงตามกรมธรรม์ประกันภัยจะสิ้นสุดลง และผู้เอาประกันภัยไม่ต้องชำระเบี้ยประกันภัยอีกต่อไป',

  //LifeReady Ordinary Product
  LIFE_READY_PACKAGE_NAME: 'LifeReady',
  LIFE_READY_PACKAGE_NAME_THAI: 'ไลฟ์เรดดี้',
  COMPLETED_MESSAGE_ONE:
    'สัญญาประกันภัยนี้เกิดจากการที่บริษัทเชื่อถือถ้อยแถลงของผู้เอาประกันภัย ในใบคำขอเอาประกันชีวิต ใบแถลงสุขภาพและข้อแถลงเพิ่มเติมอื่นใดที่ผู้เอาประกันภัยลงลายมือชื่อไว้ และได้มีการชำระเบี้ยประกันภัยงวดแรกแล้ว บริษัทจึงได้ตกลงทำสัญญาและออกกรมธรรม์ให้ไว้',
  COMPLETED_MESSAGE_TWO:
    'ในกรณีที่ผู้เอาประกันภัยรู้อยู่แล้วและแถลงข้อความอันเป็นเท็จตามวรรคหนึ่ง หรือรู้อยู่แล้วในข้อความจริงใด แต่ไม่เปิดเผยข้อความจริงนั้นให้บริษัททราบ ซึ่งถ้าบริษัททราบข้อความจริงนั้นๆ แล้ว อาจจูงใจบริษัทให้เรียกเก็บเบี้ยประกันภัยสูงขึ้น หรือไม่ยอมทำสัญญา สัญญาประกันภัยนี้\nจะตกเป็น โมฆียะตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 865 ซึ่งบริษัทอาจบอกล้างสัญญาได้และไม่จ่ายเงินตามกรมธรรม์',
  COMPLETED_MESSAGE_THREE:
    'บริษัทจะไม่ปฏิเสธความรับผิด โดยอาศัยข้อแถลงนอกเหนือจากที่ผู้เอาประกันภัยได้แถลงไว้ในเอกสารตามวรรคหนึ่ง',

  LIFE_READY_ORDINARY_NO_COVER_MESSAGE_BULLET_ONE_ONE:
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 2 ปี นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันภัย \nหรือตามการต่ออายุ หรือตามการกลับคืนสู่สถานะเดิม หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยในเฉพาะส่วนที่เพิ่ม เว้นแต่ ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่เอาประกันภัยนั้น หรือการแถลงอายุคลาดเคลื่อนจนอายุจริงอยู่นอกจำกัดอัตราเบี้ยประกันภัย\nตามทางค้าปกติ',
  NO_COVER_MESSAGE_BULLET_ONE_TWO:
    'ในกรณีที่บริษัทได้ทราบข้อมูลอันจะบอกล้างสัญญาประกันภัยได้ แต่มิได้ใช้สิทธิบอกล้างสัญญาประกันภัยภายในกำหนด 1 เดือน นับแต่ทราบ\nข้อมูลนั้น บริษัทไม่อาจบอกล้างความสมบูรณ์ของสัญญาประกันภัยในกรณีนี้ได้',
  LIFE_TREASURE_ORDINARY_NO_COVER_MESSAGE_BULLET_ONE_ONE:
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 2 ปี นับตั้งแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ หรือหากมี\nการต่ออายุกรมธรรม์ให้นับตั้งแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุนั้น หรือวันเริ่มมีผลคุ้มครองตามการกลับคืนสู่สถานะเดิมของกรมธรรม์ครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย ทั้งนี้ เฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่่เพิ่มขึ้นเท่านั้น เว้นแต่ ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่เอาประกันภัยนั้น หรือการแถลงอายุคลาดเคลื่อนจนอายุจริงอยู่นอกจำกัดอัตราเบี้ยประกันภัยตามทางค้าปกติ',
  LIFE_TREASURE_ORDINARY_NO_COVER_MESSAGE_BULLET_ONE_TWO:
    'ในกรณีที่บริษัททราบข้อมูลอันจะบอกล้างสัญญาประกันภัยได้ แต่มิได้ใช้สิทธิบอกล้างสัญญาประกันภัยภายในกำหนด 1 เดือน นับแต่ทราบ\nข้อมูลนั้น บริษัทไม่อาจบอกล้างความสมบูรณ์ของสัญญาประกันภัยในกรณีนี้ได้',
  LIFE_READY_ORDINARY_NO_COVER_MESSAGE_BULLET_TWO:
    'กรณีผู้เอาประกันภัยฆ่าตัวตายด้วยใจสมัครภายในหนึ่งปี (1 ปี) นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันชีวิต หรือหากมี\nการต่ออายุกรมธรรม์ประกันชีวิตให้มีผลนับตั้งแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุนั้น หรือวันเริ่มมีผลคุ้มครองตามการกลับคืนสู่\nสถานะเดิมของกรมธรรม์ประกันชีวิตครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย ทั้งนี้ เฉพาะในส่วนของ\nจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น แล้วแต่กรณี',
  LIFE_TREASURE_ORDINARY_NO_COVER_MESSAGE_BULLET_TWO:
    'กรณีผู้เอาประกันภัยฆ่าตัวตายด้วยใจสมัครภายในหนึ่งปี (1 ปี) นับตั้งแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ หรือหากมีการต่ออายุกรมธรรม์\nให้นับตั้งแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุนั้น หรือวันเริ่มมีผลคุ้มครองตามการกลับคืนสู่สถานะเดิมของกรมธรรม์ครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย ทั้งนี้ เฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น แล้วแต่กรณี',
  NO_COVER_MESSAGE_BULLET_THREE: 'กรณีผู้เอาประกันภัยถูกผู้รับประโยชน์ฆ่าตายโดยเจตนา',

  LIFE_TREASURE_NAME_THAI: 'ไลฟ์เทรเชอร์',

  //iSmart Product
  I_SMART_GENERAL_CONDITION_COMPLETED_MESSAGE_ONE:
    'สัญญาประกันภัยนี้เกิดจากการที่บริษัทเชื่อถือข้อแถลงของผู้เอาประกันภัย ในใบคำขอเอาประกันชีวิต ใบแถลงสุขภาพและข้อแถลงเพิ่มเติมอื่นใดที่ผู้เอาประกันภัยลงลายมือชื่อไว้และได้มีการชำระเบี้ยประกันภัยงวดแรกแล้ว บริษัทจึงได้ตกลงทำสัญญาและออกกรมธรรม์ให้ไว้',
  I_SMART_GENERAL_CONDITION_COMPLETED_MESSAGE_TWO:
    'ในกรณีที่ผู้เอาประกันภัยรู้อยู่แล้วและแถลงข้อความอันเป็นเท็จตามวรรคหนึ่ง หรือรู้อยู่แล้วในข้อความจริงใดแต่ไม่เปิดเผยข้อความจริงนั้นให้บริษัททราบ ซึ่งถ้าบริษัททราบข้อความจริงนั้นๆ แล้ว อาจจูงใจบริษัทให้เรียกเก็บเบี้ยประกันภัยสูงขึ้นหรือไม่ยอมทำสัญญา สัญญาประกันภัยนี้จะตกเป็น\nโมฆียะตามประมวลกฎหมายแพ่งและพาณิชย์ มาตรา 865 ซึ่งบริษัทอาจบอกล้างสัญญาได้และไม่จ่ายเงินตามกรมธรรม์',
  I_SMART_GENERAL_CONDITION_COMPLETED_MESSAGE_THREE:
    'บริษัทจะไม่ปฏิเสธความรับผิด โดยอาศัยข้อแถลงนอกเหนือจากที่ผู้เอาประกันภัยได้แถลงไว้ในเอกสารตามวรรคหนึ่ง',

  I_SMART_GENERAL_CONDITION_NO_COVER_MESSAGE_BULLET_ONE_ONE:
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 2 ปี นับตั้งแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ หรือหากมี\nการต่ออายุกรมธรรม์ให้นับตั้งแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุนั้น หรือวันเริ่มมีผลคุ้มครองตามการกลับคืนสู่สถานะเดิมของกรมธรรม์ครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยทั้งนี้ เฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น เว้นแต่ ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่เอาประกันภัยนั้น หรือการแถลงอายุคลาดเคลื่อนจนอายุจริงอยู่นอกจำกัดอัตราเบี้ยประกันภัยตาม\nทางค้าปกติ',
  I_SMART_GENERAL_CONDITION_NO_COVER_MESSAGE_BULLET_ONE_TWO:
    'ในกรณีที่บริษัททราบข้อมูลอันจะบอกล้างสัญญาประกันภัยได้ แต่มิได้ใช้สิทธิบอกล้างสัญญาประกันภัยภายในกำหนด 1 เดือน นับแต่ทราบ\nข้อมูลนั้น บริษัทไม่อาจบอกล้างความสมบูรณ์ของสัญญาประกันภัยในกรณีนี้ได้',
  I_SMART_GENERAL_CONDITION_NO_COVER_MESSAGE_BULLET_TWO:
    'กรณีผู้เอาประกันภัยฆ่าตัวตายด้วยใจสมัครภายในหนึ่งปี (1 ปี) นับตั้งแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ หรือหากมีการต่ออายุกรมธรรม์ให้นับ\nตั้งแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุนั้น หรือวันเริ่มมีผลคุ้มครองตามการกลับคืนสู่สถานะเดิมของกรมธรรม์ครั้งสุดท้าย หรือวันที่บริษัท\nอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย ทั้งนี้ เฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น แล้วแต่กรณี',
  I_SMART_GENERAL_CONDITION_NO_COVER_MESSAGE_BULLET_THREE: 'กรณีผู้เอาประกันภัยถูกผู้รับประโยชน์ฆ่าตายโดยเจตนา',

  //Bumnan Ready Product
  BUMNAN_READY_COMPLETED_MESSAGE_ONE:
    'สัญญาประกันภัยนี้เกิดจากการที่บริษัทเชื่อถือข้อแถลงของผู้เอาประกันภัย ในใบคำขอเอาประกันชีวิต ใบแถลงสุขภาพและข้อแถลงเพิ่มเติมอื่นใดที่ผู้เอาประกันภัยลงลายมือชื่อไว้ และได้มีการชำระเบี้ยประกันภัยงวดแรกแล้ว บริษัทจึงได้ตกลงทำสัญญาและออกกรมธรรม์ให้ไว้',
  BUMNAN_READY_NO_COVER_MESSAGE_BULLET_ONE_ONE:
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 2 ปี นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันภัย \nหรือหากมีการต่ออายุกรมธรรม์ ให้นับตั้งแต่วันต่ออายุกรมธรรม์ หรือวันกลับคืนสู่สถานะเดิมของกรมธรรม์ครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยทั้งนี้ เฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น เว้นแต่ ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่เอาประกันภัยนั้นหรือการแถลงอายุคลาดเคลื่อนจนอายุจริงอยู่นอกจำกัดอัตราเบี้ยประกันภัยตามทางค้าปกติ',
  BUMNAN_READY_NO_COVER_MESSAGE_BULLET_TWO:
    'กรณีผู้เอาประกันภัยฆ่าตัวตายด้วยใจสมัครภายในหนึ่งปี (1 ปี) นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันภัย หรือหากมีการต่ออายุ\nกรมธรรม์ ให้มีผลนับตั้งแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุนั้น หรือวันเริ่มมีผลคุ้มครองตามการกลับคืนสู่สถานะเดิมของกรมธรรม์\nครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย ทั้งนี้ เฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น แล้วแต่กรณี',

  //GIO Product
  GIO_PRODUCT_NO_COVER_MESSAGE_BULLET_ONE_ONE:
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 2 ปี นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันภัย \nหรือตามการต่ออายุ หรือตามการกลับคืนสู่สถานะเดิม หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยในเฉพาะส่วนที่เพิ่ม เว้นแต่ ผู้เอาประกันภัยมิได้มีส่วนได้เสียในเหตุที่เอาประกันภัยนั้น หรือการแถลงอายุคลาดเคลื่อนจนอายุจริงอยู่นอกจำกัดอัตราเบี้ยประกันภัยตาม\nทางค้าปกติ',
  GIO_PRODUCT_NO_COVER_MESSAGE_BULLET_TWO:
    'กรณีผู้เอาประกันภัยฆ่าตัวตายด้วยใจสมัครภายในหนึ่งปี (1 ปี) นับแต่วันเริ่มมีผลคุ้มครองตามกรมธรรม์ประกันชีวิต หรือหากมีการต่ออายุ\nกรมธรรม์ประกันชีวิตให้มีผลนับตั้งแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุนั้น หรือวันเริ่มมีผลคุ้มครองตามการกลับคืนสู่สถานะเดิมของกรมธรรม์\nประกันชีวิตครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย ทั้งนี้ เฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น แล้วแต่กรณี',
  GIO_PRODUCT_POLICY_VALUE_BENEFIT_TITLE: 'สิทธิเกี่ยวกับมูลค่ากรมธรรม์',
  GIO_PRODUCT_POLICY_VALUE_BENEFIT_BULLET_ONE:
    'เมื่อมีมูลค่าเวนคืนในปีกรมธรรม์ใด ผู้เอาประกันภัยสามารถใช้สิทธิเวนคืนกรมธรรม์ประกันภัย หรือเปลี่ยนเป็นกรมธรรม์ใช้เงินสำเร็จ หรือแปลงเป็นกรมธรรม์แบบขยายเวลา หรือกู้เงินตามเงื่อนไขของกรมธรรม์ประกันภัย',
  GIO_PRODUCT_POLICY_VALUE_BENEFIT_BULLET_TWO:
    'โดยหากผู้เอาประกันภัยใช้สิทธิเปลี่ยนเป็นกรมธรรม์ใช้เงินสำเร็จ หรือแปลงเป็นกรมธรรม์แบบขยายเวลา ผลประโยชน์การจ่ายเงินคืนตามกรมธรรม์ประกันภัยจะสิ้นสุดลง และ ผู้เอาประกันภัยไม่ต้องชำระเบี้ยประกันภัยอีกต่อไป',

  // Global Index 16/6
  GLOBAL_INDEX_16_6_NAME_THAI: 'โกลบอล อินเด็กซ์ 16/6 (ชนิดมีเงินปันผล)',
  GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2: 'กรณีดัชนีอ้างอิงมีผลตอบแทน',
  GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3: 'จากการลงทุนเฉลี่ยที่',
  GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_LOW: '-1% ต่อปี',
  GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_MIDDLE: '3% ต่อปี',
  GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH: '5% ต่อปี',
  GLOBAL_INDEX_16_6_BENEFITS_LOW: 'ตัวอย่างที่ 1\nกรณีดัชนีอ้างอิงมีผลตอบแทน\nจากการลงทุนเฉลี่ยที่ -1% ต่อปี',
  GLOBAL_INDEX_16_6_BENEFITS_MIDDLE: 'ตัวอย่างที่ 2\nกรณีดัชนีอ้างอิงมีผลตอบแทน\nจากการลงทุนเฉลี่ยที่ 3% ต่อปี',
  GLOBAL_INDEX_16_6_BENEFITS_HIGH: 'ตัวอย่างที่ 3\nกรณีดัชนีอ้างอิงมีผลตอบแทน\nจากการลงทุนเฉลี่ยที่ 5% ต่อปี',
  GLOBAL_INDEX_16_6_DEATH_BENEFIT_MINIMUM_TITLE: '1) ผลประโยชน์กรณีเสียชีวิต (ขั้นต่ำ)',
  GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_TITLE: '2) ผลประโยชน์เงินคืนตามกรมธรรม์',
  GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_TWO_PERCENT: 'สิ้นปีกรมธรรม์ที่ 2 และ 4 ปีละ',
  GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_SIX_PERCENT: 'สิ้นปีกรมธรรม์ที่ 6, 8, 10, 12 และ 14 ปีละ',
  GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_MATURITY_TITLE: '3) ผลประโยชน์เงินครบกำหนดสัญญา',
  GLOBAL_INDEX_16_6_DIVIDEND_TITLE: '4) เงินปันผล',
  GLOBAL_INDEX_16_6_MESSAGE: {
    BENEFIT_SUMMARY_TABLE_1: {
      REMARK: {
        TITLE: 'หมายเหตุ',
        BULLET_1: `เงินปันผลตามตัวอย่างที่ 1, 2 และ 3 ข้างต้น เป็นเพียงตัวอย่างเงินปันผลที่คำนวณโดยใช้สมมติฐานว่าผลตอบแทนจากดัชนีอ้างอิงเป็น -1%, 3% และ 5% ตามลำดับ และอัตราผลตอบแทนเท่ากันทุกปีตลอดสัญญา
        ทั้งนี้เงินปันผลดังกล่าวเป็นผลประโยชน์ที่ไม่รับรองการจ่าย (จำนวนที่แสดงในตารางข้างต้นเป็นเพียงตัวอย่างการคำนวณที่ได้จากการคำนวณตาม "สูตรการคำนวณเงินปันผล") โดยเงินปันผลที่จ่ายจริงอาจมากกว่าหรือ
        น้อยกว่าตัวอย่าง เงินปันผลที่แสดงไว้ในที่นี้ ซึ่งเงินปันผลดังกล่าวจะขึ้นอยู่กับการเปลี่ยนแปลงของระดับดัชนีอ้างอิง Citi Grandmaster RC 5 Index และอัตราแลกเปลี่ยนสกุลเงินบาทต่อดอลลาร์สหรัฐ
        และอัตราการมีส่วนร่วมในเงินปันผล ทั้งนี้ จะเป็นไปตามเงื่อนไข ข้อกำหนด และวิธีการคำนวณเงินปันผลที่บริษัทฯ พิจารณา โดยบริษัทฯ อาจจะพิจารณาจ่ายให้ในกรณีครบกำหนดสัญญา หรือ กรณีเสียชีวิตตั้งแต่
        ปีกรมธรรม์ที่ 2 เป็นต้นไป หรือ กรณีขอใช้สิทธิเวนคืนกรมธรรม์ ตั้งแต่ปีกรมธรรม์ที่ 7 เป็นต้นไป โดยอัตราการจ่ายเงินปันผลเป็นไปตามที่ระบุในกรมธรรม์`,
        BULLET_2: `ในกรณีที่กรมธรรม์ถูกเปลี่ยนเป็นกรมธรรมใช้เงินสำเร็จ หรือแปลงเป็นการประกันภัยแบบขยายเวลา บริษัทฯ จะไม่จ่ายผลประโยชน์เงินปันผลดังกล่าวข้างต้น`,
        BULLET_3: `ผู้เอาประกันภัยสามารถติดตามรายละเอียดเกี่ยวกับเงินปันผลได้ที่ https://www.krungthai-axa.co.th/th/products/performance/global-index-16-6 โดยบริษัทจะมีการประกาศระดับดัชนีอ้างอิงและอัตราแลกเปลี่ยน
        สกุลเงินเป็นรายสัปดาห์`,
      },
      IMPORTANT_INSTRUMENTS_INVESTED: {
        TITLE: 'สาระสำคัญเกี่ยวกับตราสารที่ลงทุน',
        BULLET_1: `ดัชนี หมายถึง Citi Grandmaster RC 5 Index ศึกษาข้อมูลเพิ่มเติมได้ที่ https://investmentstrategies.citi.com/indice/CIMAGD5U/34/2`,
        BULLET_2: `ดัชนี Citi Grandmaster RC 5 Index มีการเข้าถึงการลงทุนในตลาดที่พัฒนาแล้ว เช่น สหรัฐอเมริกา ยุโรป และญี่ปุ่น เพื่อกระจายความเสี่ยง และเพิ่มโอกาสในการสร้างผลตอบแทนสูงสุดจากการลงทุนด้วยการจัดสรร
        การลงทุนในสัดส่วนที่เหมาะสมทั้งในหุ้น พันธบัตรรัฐบาล ตราสารภาคหนี้เอกชน และสินค้าโภคภัณฑ์ และมีการปรับสัดส่วนการลงทุนอย่างยืดหยุ่นตามภาวะการลงทุนในตลาดโลกเพื่อเพิ่มผลตอบแทน
        และลดความเสี่ยงหรือความผันผวน`,
        BULLET_3: `เนื่องจากดัชนี Citi Grandmaster RC 5 Index มีการคำนวณดัชนีในรูปสกุลเงินดอลลาร์สหรัฐฯ บริษัทฯ จะทำการแปลงผลการดำเนินงานให้เป็นสกุลเงินไทยบาท ตามอัตราแลกเปลี่ยนสกุลเงินต่างประเทศ
        ในวันคำนวณมูลค่าระดับดัชนีอ้างอิงวันแรกกับวันสุดท้าย โดยอ้างอิงข้อมูลจากเว็บไซต์ของธนาคารแห่งประเทศไทย https://www.bot.or.th/t/statistics/exchange-rate.html สำหรับอัตราแลกเปลี่ยน ณ วันคำนวณมูลค่า
        ดัชนีวันแรกจะอ้างอิงจากอัตราขายเงินสกุลดอลลาร์สหรัฐฯ และอัตราแลกเปลี่ยน ณ วันคำนวณมูลค่าดัชนีวันสุดท้ายจะอ้างอิงจากอัตราซื้อเงินสกุลดอลลาร์สหรัฐฯ`,
        BULLET_4: `บริษัทฯ มีนโยบายลงทุนในดัชนีอ้างอิงภายใน 45 วัน นับจากวันออกกรมธรรม์ประกันชีวิต และมีนโยบายที่จะคำนวณมูลค่าของดัชนีอ้างอิงวันสุดท้ายภายใน 45 วัน ก่อนวันครบกำหนดสัญญา`,
        BULLET_5: `กรณีวันคำนวณมูลค่าสุดท้ายของดัชนีอ้างอิงเป็นวันหยุดทำการตามที่ผู้คำนวณดัชนีอ้างอิงประกาศ ให้เลื่อนวันคำนวณมูลค่าสุดท้ายของดัชนีอ้างอิงเป็นวันทำการถัดไป หรือวันอื่นใดตามเงื่อนไขของตราสารที่ลงทุน`,
        BULLET_6: `เงินปันผลที่คำนวณจากดัชนี Citi Grandmaster RC 5 Index มีความเสี่ยง ดังนี้`,
        BULLET_6_1: `ความเสี่ยงจากความผันผวนของระดับราคาดัชนี (Market Risk)`,
        BULLET_6_2: `ความเสี่ยงจากอัตราแลกเปลี่ยน เนื่องจากดัชนีที่ลงทุนอยู่ในเงินสกุลดอลสาร์สหรัฐ จึงมีความเสี่ยงจากความผันผวนของอัตราแลกเปลี่ยนเงินบาทกับเงินสกุลดอลลาร์สหรัฐ`,
        BULLET_6_3: `อย่างไรก็ดี ผู้เอาประกันภัยจะยังคงได้รับเงินจ่ายคืนตามกรมธรรม์และเงินครบกำหนดสัญญาตามเงื่อนไขของกรมธรรม์เต็มจำนวน เนื่องจากเงินจ่ายคืนตามกรมธรรม์และเงินครบกำหนดสัญญาไม่มีความเสี่ยงจากความผันผวน
        ของระดับราคาดัชนี (Market Risk) และความเสี่ยงจากอัตราแลกเปลี่ยน`,
        BULLET_7:
          'ในกรณีที่ผู้คำนวณดัชนีอ้างอิง Citi Grandmaster RC 5 Index ได้ยกเลิกการคำนวณดัชนีระหว่างสัญญา บริษัทฯ ขอสงวนสิทธิในการจัดหาดัชนีใหม่มาทดแทนตามความเหมาะสม หากบริษัทฯไม่สามารถหาดัชนีใหม่มา\nทดแทนได้ บริษัทฯ จะทำการชำระเป็นเงินสดแทนโดยเร็วที่สุดเท่าที่จะกระทำได้ตามมูลค่าที่บริษัทฯได้รับจากการยกเลิกการคำนวณดัชนีอ้างอิงข้างต้น โดยบริษัทฯ จะดำเนินการออกบันทึกสลักหลังแจ้งการเปลี่ยนแปลงดังกล่าวให้ผู้เอาประกันภัยทราบเป็นลายลักษณ์อักษร',
      },
    },
    BENEFIT_SUMMARY_TABLE_2: [
      { description: '{{description}}', benefit: '{{value}} บาท' },
      { description: '2) ผลประโยชน์เงินคืนตามกรมธรรม์', benefit: '' },
      { description: '{{description}}', benefit: '{{value}} บาท' },
      { description: '{{description}}', benefit: '{{value}} บาท' },
      { description: '{{description}}', benefit: '{{value}} บาท' },
      {
        description: '4) เงินปันผล',
        benefit: `เงินปันผลเป็นผลประโยชน์ที่ไม่รับรองการจ่าย ซึ่งเงินปันผลนี้จะขึ้นอยู่กับการเปลี่ยนแปลงของระดับดัชนีอ้างอิง Citi Grandmaster RC 5
          Index และอัตราแลกเปลี่ยนสกุลเงินบาทต่อดอลลาร์สหรัฐ และอัตราการมีส่วนร่วมในเงินปันผล ทั้งนี้ จะเป็นไปตามเงื่อนไข ข้อกำหนด
          และวิธีการคำนวณเงินปันผลที่บริษัทฯ พิจารณา โดยบริษัทฯ อาจจะพิจารณาจ่ายให้ในกรณีครบกำหนดสัญญา หรือ กรณีเสียชีวิต
          ตั้งแต่ปีกรมธรรม์ที่ 2 เป็นต้นไป หรือ กรณีขอใช้สิทธิเวนคืนกรมธรรม์ตั้งแต่ปีกรมธรรม์ที่ 7 เป็นต้นไป โดยอัตราการจ่ายเงินปันผล
          เป็นไปตามที่ระบุในกรมธรรม์`,
      },
    ],
  },
  GLOBAL_INDEX_16_6_GUARANTEE_CASHDROP: 'เงินจ่ายคืนตามกรมธรรม์ประกันภัย และเงินครบกำหนดสัญญา (ณ สิ้นปีกรมธรรม์)',
  GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_1: 'กรณีสะสมไว้กับบริษัทฯ ด้วยอัตรา',
  GLOBAL_INDEX_16_6_INCASE_OF_CUMULATIVE_2: 'ดอกเบี้ยขั้นต่ำ 0.5% ต่อปี',
  GLOBAL_INDEX_16_6_DEATH_BENEFIT_GUARANTEE: 'ความคุ้มครองกรณีเสียชีวิต',
  GLOBAL_INDEX_16_6_DEATH_BENEFIT_NON_GUARANTEE: 'ความคุ้มครอง\nกรณีเสียชีวิต\nรวมเงินปันผล',
  GLOBAL_INDEX_16_6_GUARANTEE: 'รับรองการจ่าย',
  GLOBAL_INDEX_16_6_INVESTMENT_BENEFITS_NONGUARANTEE_MATURITY: '3) เงินปันผล ณ วันครบกำหนดสัญญา (ไม่รับรองการจ่าย)',
  GLOBAL_INDEX_16_6_INVESTMENT_BENEFITS_NONGUARANTEE_TOTAL:
    'รวมผลประโยชน์ตามกรมธรรม์ทั้งสิ้นตลอดสัญญา (รวมเงินปันผล) (1 + 2 + 3)',
  GLOBAL_INDEX_16_6_FORMULA_REMARK: [
    'Max (0, ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันสุดท้าย/ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันแรก - 100%)',
    'คือการเปลี่ยนแปลงของระดับดัชนีอ้างอิงเทียบระหว่างวันคำนวนมูลค่าวันสุดท้ายกับวันแรก โดยการเปลี่ยนแปลงจะมีค่าไม่ต่ำกว่าศูนย์',
    'สมมติฐาน',
    'ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันแรก = 100',
    'ระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันสุดท้าย ที่อยู่บนสมมติฐานว่าได้รับผลตอบแทนจากการลงทุนที่ {{rate}}% ต่อปี = {{dividendIndex}}',
    'อัตราแลกเปลี่ยน ณ วันคำนวณมูลค่าวันแรก = 35 บาท ต่อ 1 ดอลลาร์สหรัฐอเมริกา',
    'อัตราแลกเปลี่ยน ณ วันคำนวณมูลค่าวันสุดท้าย = 35 บาท ต่อ 1 ดอลลาร์สหรัฐอเมริกา',
  ],
  GLOBAL_INDEX_16_6_DISCLAIMER: {
    table_header: ['ปีกรมธรรม์ที่ขอเวนคืนกรมธรรม์', 'อัตราการจ่ายเงินปันผล กรณีเวนคืนกรมธรรม์\n(ร้อยละของเงินปันผล)'],
    note_1: [
      'อัตราการมีส่วนร่วมในเงินปันผล คือ อัตราการมีส่วนร่วมในผลตอบแทนที่เกิดจากการเปลี่ยนแปลงของระดับดัชนีอ้างอิง ณ วันคำนวณมูลค่าวันแรก กับวันคำนวณมูลค่าวันสุดท้าย ซึ่งเท่ากับ 80%',
      'เงินค่าเวนคืนกรมธรรม์ประกันภัยข้างต้นเป็นจำนวนเงินก่อนหักหนี้สินใดๆ',
      'เงินค่าเวนคืนกรมธรรม์ประกันภัยที่แสดงไว้ในตารางเป็นจำนวนเงินที่หักเงินจ่ายคืน (ถ้ามี) ออกแล้ว',
      'เงินปันผลเป็นผลประโยชน์ที่ไม่รับรองการจ่าย บริษัทอาจจะพิจารณาจ่ายเงินปันผลให้อีกจำนวนหนึ่ง ดังต่อไปนี้',
    ],
    note_2: [
      'กรณีที่ผู้เอาประกันภัยมีชีวิตอยู่ ณ วันครบกำหนดสัญญา บริษัทอาจจะจ่ายเงินปันผลให้แก่ผู้เอาประกันภัย ในอัตราร้อยละ 100 ของเงินปันผลที่คำนวณจากวิธีการคำนวณเงินปันผลที่บริษัทพิจารณา',
      'กรณีที่ผู้เอาประกันภัยเสียชีวิตตั้งแต่ปีกรมธรรม์ที่ 2 เป็นต้นไป  บริษัทอาจจะจ่ายเงินปันผลให้แก่ผู้รับประโยชน์ ในอัตราร้อยละ 100 ของเงินปันผลที่คำนวณจากวิธีการคำนวณเงินปันผลที่บริษัทพิจารณา',
      'กรณีที่ผู้เอาประกันภัยขอใช้สิทธิเวนคืนกรมธรรม์ บริษัทอาจจะจ่ายเงินปันผลให้แก่ผู้เอาประกันภัย ในอัตราร้อยละของเงินปันผลที่คำนวณจากวิธีการคำนวณเงินปันผลที่บริษัทพิจารณา โดยจะจ่ายตามอัตราที่ปรากฏในตารางด้านล่าง ดังต่อไปนี้',
    ],
    note_3: [
      'เงินปันผลตามตัวอย่างที่ {{index}} ข้างต้น เป็นเพียงตัวอย่างเงินปันผลที่คำนวณโดยใช้สมมุติฐานว่าผลตอบแทนจากดัชนีอ้างอิงเป็น {{rate}}% และอัตราผลตอบแทนเท่ากันทุกปีตลอดสัญญา ทั้งนี้เงินปันผลดังกล่าวเป็นผลประโยชน์ที่ไม่รับรองการจ่าย (จำนวนที่แสดงในตารางข้างต้นเป็นเพียงตัวอย่างการคำนวณที่ได้จากการคำนวณตาม "สูตรการคำนวณเงินปันผล") โดยเงินปันผลที่จ่ายจริงอาจมากกว่าหรือน้อยกว่า\nตัวอย่างเงินปันผลที่แสดงไว้ในที่นี้ ซึ่งเงินปันผลดังกล่าวจะขึ้นอยู่กับการเปลี่ยนแปลงของระดับดัชนีอ้างอิง Citi Grandmaster RC 5 Index และอัตราแลกเปลี่ยนสกุลเงินบาทต่อดอลลาร์สหรัฐ และอัตราการมีส่วนร่วมในเงินปันผล ทั้งนี้ จะเป็นไปตามเงื่อนไข ข้อกำหนด และวิธีการคำนวณเงินปันผลที่บริษัทฯ พิจารณา โดยบริษัทฯ อาจจะพิจารณาจ่ายให้ในกรณีครบกำหนดสัญญา หรือ กรณีเสียชีวิตตั้งแต่ปีกรมธรรม์ที่ 2 เป็นต้นไป หรือ กรณีขอใช้สิทธิเวนคืนกรมธรรม์ ตั้งแต่ปีกรมธรรม์ที่ 7 เป็นต้นไป โดยอัตราการจ่ายเงินปันผลเป็นไปตามที่ระบุในกรมธรรม์',
      'ในกรณีที่กรมธรรม์ถูกเปลี่ยนเป็นกรมธรรม์ใช้เงินสำเร็จ หรือแปลงเป็นการประกันภัยแบบขยายเวลา บริษัทฯ จะไม่จ่ายผลประโยชน์เงินปันผลดังกล่าวข้างต้น',
      'ผู้เอาประกันภัยสามารถติดตามรายละเอียดเกี่ยวกับเงินปันผลได้ที่ https://www.krungthai-axa.co.th/th/products/performance/global-index-16-6 โดยบริษัทจะมีการประกาศระดับดัชนีอ้างอิงและอัตราแลกเปลี่ยนสกุลเงินเป็นรายสัปดาห์',
    ],
  },

  //PB Rider benefit
  PB_FIT_NAME: 'สัญญาเพิ่มเติมพีบี ฟิต',
  PB_BEYOND_NAME: 'สัญญาเพิ่มเติมพีบี บียอนด์',
  PBPDD_RIDER_DETAIL:
    'กรณีผู้ชำระเบี้ยประกันภัย (ผู้ปกครองของผู้เยาว์) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก หรือ ณ วันครบรอบปีกรมธรรม์ที่ผู้เอาประกันภัย (ผู้เยาว์) มีอายุครบ 25 ปี แล้วแต่กรณีใดจะเกิดขึ้นก่อน',
  PBPDD_RIDER_DETAIL_PDF:
    'กรณีผู้ชำระเบี้ยประกันภัย (ผู้ปกครองของผู้เยาว์) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง บริษัทจะยกเว้นเบี้ยประกันภัย\nของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก หรือ \nณ วันครบรอบปีกรมธรรม์ที่ผู้เอาประกันภัย (ผู้เยาว์) มีอายุครบ 25 ปี แล้วแต่กรณีใดจะเกิดขึ้นก่อน',
  PBPDDCI_RIDER_DETAIL:
    'กรณีผู้ชำระเบี้ยประกันภัย (ผู้ปกครองของผู้เยาว์) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง หรือเจ็บป่วยจาก 50 โรคร้ายแรงระยะรุนแรงที่คุ้มครอง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก หรือ ณ วันครบรอบปีกรมธรรม์ที่ผู้เอาประกันภัย (ผู้เยาว์) มีอายุครบ 25 ปี แล้วแต่กรณีใดจะเกิดขึ้นก่อน',
  PBPDDCI_RIDER_DETAIL_PDF:
    'กรณีผู้ชำระเบี้ยประกันภัย (ผู้ปกครองของผู้เยาว์) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง หรือเจ็บป่วยจาก 50 โรคร้ายแรงระยะรุนแรง\nที่คุ้มครอง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ย\nประกันภัยของสัญญาหลัก หรือ ณ วันครบรอบปีกรมธรรม์ที่ผู้เอาประกันภัย (ผู้เยาว์) มีอายุครบ 25 ปี แล้วแต่กรณีใดจะเกิดขึ้นก่อน',
  PBSDD_RIDER_DETAIL:
    'กรณีผู้ชำระเบี้ยประกันภัย (คู่สมรสของผู้เอาประกันภัย) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก',
  PBSDD_RIDER_DETAIL_PDF:
    'กรณีผู้ชำระเบี้ยประกันภัย (คู่สมรสของผู้เอาประกันภัย) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง บริษัทจะยกเว้นเบี้ยประกันภัย\nของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก',
  PBSDDCI_RIDER_DETAIL:
    'กรณีผู้ชำระเบี้ยประกันภัย (คู่สมรสของผู้เอาประกันภัย) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง หรือเจ็บป่วยจาก 50 โรคร้ายแรงระยะรุนแรงที่คุ้มครอง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ยประกันภัยของสัญญาหลัก',
  PBSDDCI_RIDER_DETAIL_PDF:
    'กรณีผู้ชำระเบี้ยประกันภัย (คู่สมรสของผู้เอาประกันภัย) เสียชีวิต หรือตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง หรือเจ็บป่วยจาก 50 โรคร้ายแรงระยะ\nรุนแรงที่คุ้มครอง บริษัทจะยกเว้นเบี้ยประกันภัยของสัญญาหลักให้ และการยกเว้นเบี้ยประกันภัยดังกล่าวจะสิ้นสุดลงเมื่อสิ้นสุดระยะเวลาชำระเบี้ย\nประกันภัยของสัญญาหลัก',
  PB_RIDER_ADDITIONAL_DETAIL:
    'ทั้งนี้ จะไม่คุ้มครองการป่วยด้วยโรคร้ายแรงระยะรุนแรงดังกล่าว ที่เกิดขึ้นภายในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 60 วัน นับแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันเริ่มมีผลคุ้มครองตามการต่ออายุครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยของสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง',
  PB_RIDER_ADDITIONAL_DETAIL_PDF:
    'ทั้งนี้ จะไม่คุ้มครองการป่วยด้วยโรคร้ายแรงระยะรุนแรงดังกล่าว ที่เกิดขึ้นภายในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 60 วัน นับแต่วันเริ่ม\nมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันเริ่มมีผลคุ้มครองตามการต่ออายุครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยของ\nสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง',
  PB_BENEFIT_REMARK:
    'หมายเหตุ: ในกรณีที่จำนวนเงินเอาประกันภัยสัญญาหลักมากกว่า 30 ล้านบาท เบี้ยประกันภัยสัญญาหลักที่จะได้รับการยกเว้นจะเป็นเบี้ยประกันภัยเฉพาะในส่วนของจำนวนเงินเอาประกันภัย 30 ล้านบาทเท่านั้น ทั้งนี้ เบี้ยประกันภัยสัญญาหลักในส่วนของจำนวนเงินเอาประกันภัยที่เกิน 30 ล้านบาท จะไม่ได้รับการยกเว้น',

  //Term Life
  TERM_LIFE_BENEFITS_SCENARIO_2: 'ผลประโยชน์ตามกรมธรรม์',
  TERM_LIFE_BENEFITS_SCENARIO_3: 'เมื่อรวมเงินปันผลไม่รับรองการจ่าย โดยเทียบกับ',
  TERM_LIFE_BENEFITS_SCENARIO_4: 'อัตราผลตอบแทนจากการลงทุนที่แตกต่างกัน',
  TERM_LIFE_BENEFITS_LOW: '2.0% ต่อปี',
  TERM_LIFE_BENEFITS_MIDDLE: '3.0% ต่อปี',
  TERM_LIFE_BENEFITS_HIGH: '4.5% ต่อปี',
  TERM_LIFE_BENEFITS_NONGUARANTEE_MATURITY_1: 'เงินปันผล** ไม่รับรองการจ่าย ณ ',
  TERM_LIFE_BENEFITS_NONGUARANTEE_MATURITY_2: 'วันครบกำหนดสัญญา',
  TERM_LIFE_BENEFITS_VALUE_TABLE_NOTE_1:
    '** การแสดงเงินปันผลที่ไม่รับรองการจ่ายในข้อ 3) เป็นตัวอย่างการประมาณการเงินปันผล โดยการจำลองสถานการณ์การลงทุนที่แตกต่างกันและใช้สมมติฐานว่าในแต่ละสถานการณ์ มีอัตราผลตอบแทนจากการลงทุนเท่ากันทุกปี และตัวอย่างสถานการณ์เหล่านี้มีวัตถุประสงค์เพื่อแสดงให้เห็นถึงความแตกต่างกันของเงินปันผลที่ไม่รับรองการจ่าย ภายใต้อัตราผลตอบแทนจากการลงทุนที่แตกต่างกันเท่านั้น มิได้แสดงถึงขอบเขตของอัตราผลตอบแทนจากการลงทุนขั้นต่ำ หรือขั้นสูงที่จะใช้ในการคำนวณเงินปันผลของผลิตภัณฑ์นี้',
  TERM_LIFE_BENEFITS_VALUE_TABLE_NOTE_2:
    'ทั้งนี้เงินปันผลดังกล่าวเป็นผลประโยชน์ที่ไม่รับรองการจ่าย ซึ่งขึ้นอยู่กับผลการลงทุนของกองทุนสำหรับผลิตภัณฑ์ที่มีเงินปันผลซึ่งรวมถึงผลิตภัณฑ์นี้ด้วย หลังหักค่าใช้จ่ายในการบริหารจัดการธุรกิจสำหรับผลิตภัณฑ์ที่มีเงินปันผล เงินปันผลจริงที่บริษัทฯจะจ่าย ณ วันที่ครบกำหนดสัญญาอาจมากกว่าหรือน้อยกว่า ตัวอย่างเงินปันผลที่แสดงไว้ในที่นี้ ขึ้นอยู่กับเงื่อนไขและวิธีการคำนวณเงินปันผลที่บริษัทฯ กำหนด โดยบริษัทมีดุลยพินิจในการกำหนดอัตราเงินปันผลที่ไม่รับรองการจ่าย และ/หรือจำนวนเงินปันผล ตามที่เห็นสมควร ผู้เอาประกันภัยสามารถรับทราบรายละเอียดผลการลงทุนของกรมธรรม์ที่มีเงินปันผลรายปีได้ที่เว็บไซต์ของบริษัท www.krungthai-axa.co.th ในหัวข้อ บริการลูกค้า >> การบริการเกี่ยวกับกรมธรรม์ >> ดาวน์โหลดแบบฟอร์มและเอกสารต่างๆ',

  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_1_BI:
    '** การแสดงเงินปันผลที่ไม่รับรองการจ่ายในข้อ 3) เป็นตัวอย่างการประมาณการเงินปันผล โดยการจำลองสถานการณ์การลงทุนที่แตกต่างกันและใช้สมมติฐาน',
  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_2_BI:
    'ว่าในแต่ละสถานการณ์มีอัตราผลตอบแทนจากการลงทุนเท่ากันทุกปี และตัวอย่างสถานการณ์เหล่านี้มีวัตถุประสงค์เพื่อแสดงให้เห็นถึงความแตกต่างกันของ',
  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_3_BI:
    'เงินปันผลที่ไม่รับรองการจ่ายภายใต้อัตราผลตอบแทนจากการลงทุนที่แตกต่างกันเท่านั้น มิได้แสดงถึงขอบเขตของอัตราผลตอบแทนจากการลงทุนขั้นต่ำ หรือขั้นสูงที่จะใช้ในการคำนวณเงินปันผลของผลิตภัณฑ์นี้',
  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_4_BI:
    'ทั้งนี้เงินปันผลดังกล่าวเป็นผลประโยชน์ที่ไม่รับรองการจ่าย ซึ่งขึ้นอยู่กับผลการลงทุนของกองทุนสำหรับผลิตภัณฑ์ที่มีเงินปันผลซึ่งรวมถึงผลิตภัณฑ์นี้ด้วย',
  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_5_BI:
    'หลังหักค่าใช้จ่ายในการบริหารจัดการธุรกิจสำหรับผลิตภัณฑ์ที่มีเงินปันผล เงินปันผลจริงที่บริษัทฯจะจ่าย ณ วันที่ครบกำหนดสัญญาอาจมากกว่าหรือน้อยกว่า',
  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_6_BI:
    'ตัวอย่างเงินปันผลที่แสดงไว้ในที่นี้ ขึ้นอยู่กับเงื่อนไขและวิธีการคำนวณเงินปันผลที่บริษัทฯ กำหนด โดยบริษัทมีดุลยพินิจในการกำหนดอัตราเงินปันผล',
  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_7_BI:
    'ที่ไม่รับรองการจ่าย และ/หรือจำนวนเงินปันผล ตามที่เห็นสมควร ผู้เอาประกันภัยสามารถรับทราบรายละเอียดผลการลงทุนของกรมธรรม์ที่มีเงินปันผลรายปี',
  TERM_LIFE_BENEFITS_VALUE_TABLE_DISCLAIMER_2_LINE_8_BI:
    'ได้ที่เว็บไซต์ของบริษัท www.krungthai-axa.co.th ในหัวข้อ บริการลูกค้า >> การบริการเกี่ยวกับกรมธรรม์ >> ดาวน์โหลดแบบฟอร์มและเอกสารต่างๆ',

  TERM_LIFE_BENEFITS_NONGUARANTEE_TOTAL_1: 'รวมผลประโยชน์ตามกรมธรรม์ทั้งสิ้นตลอดสัญญา ',
  TERM_LIFE_BENEFITS_NONGUARANTEE_TOTAL_2: '(รวมเงินปันผล**)',
  //Term Life PDF
  TERM_LIFE_BENEFITS_GUARANTEE: 'ผลประโยชน์\nรับรองการจ่าย',
  TERM_LIFE_BENEFITS_SCENARIO_PDF_2:
    ' ประโยชน์ตามกรมธรรม์ \n เมื่อรวมเงินปันผลไม่รับรองการจ่าย โดยเทียบกับ\nอัตราผลตอบแทนจากการลงทุนที่แตกต่างกัน**',

  // RPU ETI
  RPU: 'กรมธรรม์ใช้เงินสำเร็จ',
  CASHPAID: 'เงินจ่ายคืนทันที',
  RPU_SA: 'มูลค่าใช้เงินสำเร็จ',
  ETI: 'กรมธรรม์แบบขยายเวลา',
  ETI_VALUE: 'ระยะเวลาที่ขยาย',
  ETI_MATURITY: 'เงินครบกำหนด',

  //BI RPU, ETI
  ETI_RPU_YEAR_END_POLICY: 'สิ้นปี\nกรมธรรม์ที่',
  ETI_RPU_SURRENDER_VALUE: 'เงินค่าเวนคืน\nกรมธรรม์ประกันภัย',

  // MRTA & GLTSP
  MRTA_FULL_EN_NAME: 'MRTA Full',
  MRTA_PLUS_EN_NAME: 'Full MRTA Plus+',
  MRTA_TRUNCATE_EN_NAME: 'MRTA Truncate 10 Plus+',
  GLTSP_EN_NAME: 'GLTSP',

  // -- MRTA Mini BI
  BASIC_PLAN_DETAILS_TITLE: 'รายละเอียดของสัญญาหลัก',
  BASIC_PLAN_AND_RIDER_DETAILS_TITLE: 'รายละเอียดของสัญญาหลักและสัญญาเพิ่มเติม',
  COVERAGE_PERIOD_INSURED: 'ระยะเวลาคุ้มครองตามสัญญาประกันชีวิต',
  LOAN_PERIOD_INSURED: 'ระยะเวลากู้ตามสัญญาประกันชีวิต',
  COVERAGE_BASIC_PLAN: 'ความคุ้มครองสัญญาหลัก',
  COVERAGE_BASIC_PLAN_MESSAGE: 'การเสียชีวิตและทุพพลภาพถาวรสิ้นเชิง',
  COVERAGE_RIDER: 'ความคุ้มครองสัญญาเพิ่มเติม',
  COVERAGE_RIDER_MESSAGE: 'การเสียชีวิต การสูญเสียอวัยวะ สายตา หรือทุพพลภาพถาวรสิ้นเชิงจากอุบัติเหตุ',
  AMOUNT_INSURED_OF_BASIC_PLAN: 'จำนวนเงินเอาประกันภัยของสัญญาหลักตามสัญญาประกันชีวิต',
  AMOUNT_LOAN: 'จำนวนเงินกู้ตามสัญญาธนาคาร',
  AMOUNT_RIDER_ACCIDENT: 'จำนวนเงินเอาประกันภัยสัญญาเพิ่มเติมกลุ่มคุ้มครองอุบัติเหตุ',
  COVERAGE_LOAN_PERIOD_BANK: 'ระยะเวลากู้ตามสัญญาธนาคาร',
  INTEREST_RATE_BORROW_PREMIUM: 'อัตราดอกเบี้ยกรณีกู้จ่ายค่าเบี้ย (%ต่อปี)',
  PREMIUM_MONTHLY: 'เบี้ยประกันภัยต่อเดือน',
  CASH_INCLUDE_LOAN: 'กรณีกู้เบี้ยประกันภัยในวงเงินกู้',
  CASH_EXCLUDE_LOAN: 'กรณีไม่กู้เบี้ยประกันภัยในวงเงินกู้',
  SUM_INSURED_OF_BASIC_PLAN_AT_START_DATE: 'จำนวนเงินเอาประกันภัยของสัญญาหลัก ณ วันเริ่มสัญญา',
  SUM_RIDER_OF_ACCIDENT_PROTECTION: 'จำนวนเงินเอาประกันภัยสัญญาเพิ่มเติมกลุ่มคุ้มครองอุบัติเหตุ',
  RIDER_PREMIUM_COVER_ACCIDENT_PROTECTION: 'เบี้ยประกันภัยสัญญาเพิ่มเติมกลุ่มคุ้มครองอุบัติเหตุ',
  SUMMARY_STANDARD_PREMIUM: 'รวมเบี้ยประกันภัยมาตรฐาน',
  GRAPH_REMARK_MRTA:
    'ใช้สำหรับสินเชื่อทุกประเภท เช่น สินเชื่อที่อยู่อาศัย สินเชื่อธุรกิจและสินเชื่อเอนกประสงค์ โดยความคุ้มครองจะลดหลั่นลงมาตามตารางความคุ้มครอง',
  GRAPH_REMARK_MRTA_COVERAGE:
    'คุ้มครองการเสียชีวิตและทุพพลภาพถาวรสิ้นเชิงตามตารางจำนวนเงินเอาประกันภัยที่ลดลง ณ เดือนที่เสียชีวิต หรือ ทุพพลภาพถาวรสิ้นเชิงตามเงื่อนไขของบริษัทฯ',
  GRAPH_REMARK_MRTA_COVERAGE_PDF:
    'คุ้มครองการเสียชีวิตและทุพพลภาพถาวรสิ้นเชิงตามตารางจำนวนเงินเอาประกันภัยที่ลดลง ณ เดือนที่เสียชีวิต หรือ ทุพพลภาพถาวรสิ้นเชิง\nตามเงื่อนไขของบริษัทฯ',
  GRAPH_REMARK_GLTSP:
    'ใช้สำหรับสินเชื่อทุกประเภท เช่น สินเชื่อที่อยู่อาศัย สินเชื่ออเนกประสงค์ โดยความคุ้มครองจะคงที่ตลอดสัญญา',
  GRAPH_REMARK_ALL:
    'ระยะเวลาความคุ้มครองและจำนวนเงินเอาประกันภัยของตัวอย่างกราฟข้างต้น เป็นเพียงตัวอย่างที่แสดงให้เห็นถึงลักษณะความคุ้มครองเท่านั้น โดยระยะเวลาความคุ้มครองและจำนวนเงินเอาประกันภัยจะแตกต่างกันไปตามความคุ้มครองที่ได้รับอนุมัติ',
  GRAPH_REMARK_ALL_PDF:
    'ระยะเวลาความคุ้มครองและจำนวนเงินเอาประกันภัยของตัวอย่างกราฟข้างต้น เป็นเพียงตัวอย่างที่แสดงให้เห็นถึงลักษณะความคุ้มครองเท่านั้น\nโดยระยะเวลาความคุ้มครองและจำนวนเงินเอาประกันภัยจะแตกต่างกันไปตามความคุ้มครองที่ได้รับอนุมัติ',
  HEADER_BENEFIT_TABLE_DEFAULT: 'ตารางผลประโยชน์',
  HEADER_BENEFIT_TABLE_MRTA_FULL: 'ตารางผลประโยชน์ MRTA Full',
  HEADER_BENEFIT_TABLE_MRTA_PLUS: 'ตารางผลประโยชน์ MRTA Plus+',
  HEADER_BENEFIT_TABLE_MRTA_TRUNCATE: 'ตารางผลประโยชน์ MRTA Truncate',
  TABLE_HEADER_BASIC_PLAN_DETAIL: 'รายละเอียดสัญญาหลัก (1)',

  TABLE_DETAIL_BENEFIT_BASIC_PLAN: [
    [
      '1. ความคุ้มครองชีวิต',
      'บริษัทจะจ่ายผลประโยชน์ 100% ของจำนวนเงินเอาประกันภัย\nตามตารางความคุ้มครองของเดือนที่เกิดเหตุ',
    ],
    ['2. ความคุ้มครองทุพพลภาพถาวรสิ้นเชิง', ''],
    [
      '2.1 กรณีที่แพทย์วินิจฉัยว่า ผู้เอาประกันภัยตกเป็นบุคคลทุพพลภาพ\nถาวรสิ้นเชิงที่สามารถพิสูจน์หรือมีข้อบ่งชี้ทางการแพทย์อย่างชัดเจน',
      'บริษัทจะจ่ายผลประโยชน์ 100% ของจำนวนเงินเอาประกันภัย\nตามตารางความคุ้มครองของเดือนที่เกิดเหตุ',
    ],
    [
      '2.2 กรณีที่ผู้เอาประกันภัยตกเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง\nและการทุพพลภาพ เกิดขึ้นต่อเนื่องอย่างน้อย 180 วัน',
      'บริษัทจะจ่ายผลประโยชน์ 50% ของจำนวนเงินเอาประกันภัย\nตามตารางความคุ้มครองของเดือนที่เกิดเหตุ',
    ],
    [
      '2.3 กรณีที่ผู้เอาประกันภัยยังคงเป็นบุคคลทุพพลภาพถาวรสิ้นเชิง\nและการทุพพลภาพ เกิดขึ้นต่อเนื่องจากข้อ 2.2 ไม่น้อยกว่า 180 วัน',
      'บริษัทจะจ่ายผลประโยชน์ส่วนที่เหลืออีก 50% \nของจำนวนเงินเอาประกันภัยตามข้อ 2.2',
    ],
    [
      '2.4 กรณีที่ผู้เอาประกันภัยเสียชีวิตระหว่างระยะเวลา 180 วัน หลังจาก\nบริษัทจ่าย 50% ของจำนวนเงินเอาประกันภัยตามข้อ 2.2 ไปแล้ว',
      'บริษัทจะจ่ายผลประโยชน์ส่วนที่เหลืออีก 50% \nของจำนวนเงินเอาประกันภัยตามข้อ 2.2',
    ],
  ],
  TABLE_HEADER_RIDER_ACCIDENT: 'รายละเอียดสัญญาเพิ่มเติมกลุ่มคุ้มครองอุบัติเหตุ (2)',
  TABLE_DETAIL_RIDER_ACCIDENT: [
    '1. กรณีเสียชีวิตเนื่องจากอุบัติเหตุ\n' +
      '2. กรณีทุพพลภาพถาวรสิ้นเชิงเนื่องจากอุบัติเหตุ\n' +
      '3. กรณีสูญเสียอวัยวะเนื่องจากอุบัติเหตุ\n' +
      '\t3.1 มือสองข้างตั้งแต่ข้อมือ หรือเท้าสองข้างตั้งแต่ข้อเท้า หรือสายตาสองข้าง\n' +
      '\t3.2 มือหนึ่งข้างตั้งแต่ข้อมือ และเท้าหนึ่งข้างตั้งแต่ข้อเท้า\n' +
      '\t3.3 มือหนึ่งข้างตั้งแต่ข้อมือ และสายตาหนึ่งข้าง\n' +
      '\t3.4 เท้าหนึ่งข้างตั้งแต่ข้อเท้า และสายตาหนึ่งข้าง\n' +
      '\t3.5 มือหนึ่งข้างตั้งแต่ข้อมือ\n' +
      '\t3.6 เท้าหนึ่งข้างตั้งแต่ข้อเท้า\n' +
      '\t3.7 สายตาหนึ่งข้าง',
    'บริษัทจะจ่ายผลประโยชน์ 100% ของจำนวนเงินเอาประกันภัย\nสัญญาเพิ่มเติมกลุ่มคุ้มครองอุบัติเหตุ',
    'กรณีเกิดอุบัติเหตุสาธารณภัยรับความคุ้มครองอุบัติเหตุเป็น 2 เท่า ของความคุ้มครองอุบัติเหตุ',
  ],
  REMARK_BENEFIT_TABLE_MRTA: [
    '(1) ความคุ้มครองจะสิ้นสุดลงเมื่อครบระยะเวลาความคุ้มครอง หรือเมื่อมีการจ่ายผลประโยชน์ครบ 100% ของจำนวนเงินเอาประกันภัย',
    '(2) ความคุ้มครองอุบัติเหตุจะสิ้นสุดลงเมื่อครบระยะเวลาความคุ้มครอง หรือเมื่อมีการจ่ายผลประโยชน์ความคุ้มครองอุบัติเหตุข้อใดข้อหนึ่งแล้ว',
  ],
  TABLE_HEADER_POLICY_COVERAGE: 'ความคุ้มครอง\n(ณ ต้นปีกรมธรรม์)',
  TABLE_HEADER_POLICY_COVERAGE_SUMASSURED: 'จำนวนเงินเอาประกันภัย\n(ณ ต้นปีกรมธรรม์)',
  TABLE_HEADER_POLICY_RIDER_ACCIDENT: 'สัญญาเพิ่มเติมอุบัติเหตุ',
  TABLE_HEADER_POLICY_SURRENDER: 'เงินเวนคืนกรมธรรม์ประกันชีวิต\n(ณ สิ้นปีกรมธรรม์)',
  TABLE_HEADER_POLICY_TOTAL_SURRENDER:
    'รวมมูลค่าเวนคืนกรมธรรม์ประกันชีวิต\nของสัญญาหลักและสัญญาเพิ่มเติม\n(ณ สิ้นปีกรมธรรม์)',
  MRTA_NOT_COVER_MESSAGE: [
    'กรณีไม่เปิดเผยความจริง หรือแถลงข้อความเท็จ บริษัทจะบอกล้างสัญญาภายใน 1 ปี นับจากวันทำสัญญา',
    'ฆ่าตัวตายภายใน 1 ปี หรือถูกผู้รับประโยชน์ฆ่าตาย',
  ],
  GENERAL_EXCEPTION_TITLE: 'ข้อยกเว้นทั่วไป',
  GENERAL_EXCEPTION_CASE_PERMANENT_DISABILITY_SUB_TITLE: 'การจ่ายผลประโยชน์กรณีทุพพลภาพถาวรสิ้นเชิง',
  GENERAL_EXCEPTION_CASE_PERMANENT_DISABILITY_MESSAGE: [
    'ข้อยกเว้นการจ่ายผลประโยชน์กรณีทุพพลภาพถาวรสิ้นเชิง มีทั้งหมด 8 ข้อ เช่น\nไม่คุ้มครองการสูญเสียหรือการทุพพลภาพใด ๆที่เกิดขึ้นโดยทางตรงหรือทางอ้อมทั้งหมดหรือแต่บางส่วน หรือสืบเนื่องจากสาเหตุ\nหรือเกิดขึ้นในเวลาต่อไปนี้',
    'การฆ่าตัวตาย พยายามฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง',
    'ความบกพร่องทางร่างกาย การเจ็บป่วย หรือบาดเจ็บ ที่สมาชิกผู้เอาประกันภัยทราบอยู่แล้วในขณะที่ทำสัญญาประกันภัย แต่มิได้แจ้งให้บริษัททราบ เว้นแต่สมาชิกผู้นั้นได้เอาประกันภัยตามสัญญานี้มาแล้วเป็นเวลาไม่น้อยกว่า 12 เดือน',
    'การบาดเจ็บที่เกิดขึ้นจากการกระทำของสมาชิกผู้เอาประกันภัย ขณะอยู่ภายใต้ฤทธิ์สุรา สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้',
    'การบาดเจ็บขณะที่สมาชิกผู้เอาประกันภัยปฏิบัติหน้าที่เป็นทหาร ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม',
    'ขณะที่สมาชิกผู้เอาประกันภัยขับขี่หรือปฏิบัติหน้าที่เป็นพนักงานประจำอากาศยานใดๆ',
  ],
  GENERAL_EXCEPTION_CASE_RIDER_ACCIDENT_SUB_TITLE: 'สัญญาเพิ่มเติมกลุ่มคุ้มครองอุบัติเหตุ',
  GENERAL_EXCEPTION_CASE_RIDER_ACCIDENT_MESSAGE: [
    'ข้อยกเว้นของสัญญาเพิ่มเติมกลุ่มคุ้มครองอุบัติเหตุ มีทั้งหมด 18 ข้อ เช่น\nไม่คุ้มครองความสูญเสีย การเสียชีวิต การสูญเสียอวัยวะ และการทุพพลภาพ อันเกิดจากสาเหตุต่อไปนี้',
    'การการฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
    'การกระทำขณะอยู่ภายใต้ฤทธิ์สุรา ยาเสพติด หรือสารเสพติดให้โทษจนไม่สามารถครองสติได้ \n\tคำว่า “ขณะอยู่ภายใต้ฤทธิ์สุรา” นั้น ในกรณีที่มีการตรวจเลือดให้ถือเกณฑ์มีระดับแอลกอฮอล์ในเลือดตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์ ขึ้นไป',
    'ขณะที่ผู้เอาประกันภัยเข้าร่วมทะเลาะวิวาท หรือมีส่วนยั่วยุให้เกิดการทะเลาะวิวาท',
    'การแท้งลูก',
    'ขณะขึ้นหรือลง หรือเป็นผู้ขับขี่ หรืออยู่ในอากาศยานใด ๆ ไม่ว่าจะขับเคลื่อนด้วยตัวของมันเองหรือไม่ก็ตามที่มิได้จดทะเบียนประกอบการบินพาณิชย์',
  ],
  REMARK_POLICY_TABLE_MRTA:
    'ผู้เอาประกันภัยรับทราบว่า ผู้เอาประกันภัยหรือผู้รับผลประโยชน์ จะเป็นผู้ชำระส่วนต่างระหว่างจำนวนเงินเอาประกันภัยและยอดเงินกู้คงเหลือ ณ วันที่มีการเรียกร้องสินไหม',
  MRTA_TAX_CONSENT_DEDUCTION_BENEFIT_SUB_LIST: [
    { description: 'เบี้ยประกันชีวิต', benefit: '{{value}} บาท' },
    { description: 'เบี้ยประกันสุขภาพ', benefit: '{{value}} บาท' },
  ],
  SIGN_NOTES_MRTA: {
    title: 'การยืนยันการขอทำประกันและรับทราบรายละเอียดผลิตภัณฑ์',
    sub_title:
      'ผู้เอาประกันภัยจะได้รับใบรับเงินชั่วคราวงวดแรกทันที หลังจากชำระเงินค่าเบี้ยประกันภัย และใบรับเงินชั่วคราวดังกล่าวจะต้องไม่หมดอายุ',
    remark:
      'เพื่อประโยชน์ของท่าน กรุณาศึกษาและทำความเข้าใจในเงื่อนไขความคุ้มครอง ผลประโยชน์และข้อยกเว้นตามกรมธรรม์ประกันภัย จากเอกสารประกอบการเสนอขายนี้ก่อนการตัดสินใจ ระยะเวลารวมถึงจำนวนเงินเอาประกันภัยที่บริษัทให้ความคุ้มครอง อาจมีความแตกต่างจาก ระยะเวลาและ/หรือจำนวนเงินกู้ที่ระบุในสัญญาเงินกู้กับทางธนาคาร',
    notes: [
      'โดยข้าพเจ้าได้รับทราบรายละเอียดดังต่อไปนี้ แล้ว',
      [
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้แนะนำตัวพร้อมกับมีการแสดงเอกสารใบอนุญาตตัวแทน/นายหน้าประกันชีวิต ',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายสิทธิประโยชน์และเงื่อนไขความคุ้มครองตามกรมธรรม์อย่างครบถ้วน',
        'ตัวแทน, นายหน้าประกันชีวิต, ลูกจ้าง, หรือพนักงานบริษัท ได้อธิบายว่าการชำระเงินในแต่ละงวดคือการชำระเบี้ยประกันภัย ไม่ได้เป็นการฝากเงินหรือออมเงินกับธนาคาร',
        'ในกรณีที่ข้าพเจ้าต้องการเวนคืนกรมธรรม์ข้าพเจ้าจะได้รับเงินค่าเวนคืนกรมธรรม์ประกันภัยตามที่ได้ระบุไว้ในเอกสารนี้ ซึ่งอาจน้อยกว่า\nเบี้ยประกันภัยที่ข้าพเจ้าได้ชำระมาแล้ว',
        'ข้าพเจ้ารับทราบและเข้าใจว่า ข้าพเจ้ามีความสามารถในการชำระเบี้ยประกันภัยได้ตรงตามกำหนดทุกงวด ตลอดระยะเวลาชำระเบี้ยประกันภัย\nที่ระบุในเอกสารนี้ เพื่อให้กรมธรรม์ประกันชีวิตมีผลคุ้มครองโดยสมบูรณ์และผู้เอาประกันภัยได้รับประโยชน์สูงสุด',
        'การยื่นขอทำประกันฉบับนี้เป็นไปตามความประสงค์และความสมัครใจของข้าพเจ้า',
      ],
    ],
  },
  REMARK_SIGNING_BOX:
    'KTB Call Center 02-111-1111 www.krungthai.com\nรับประกันชีวิตโดย บริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน) ธนาคารเป็นเพียงนายหน้าผู้ชี้ช่องทางให้ทำประกันเท่านั้น',
  HEALTH_CHECK_CASH_EXCLUDE_LOAN_HEADER: 'กฎเกณฑ์การตรวจสุขภาพและเอกสารทางการเงินสำหรับการชำระเงินสด',
  HEALTH_CHECK_CASH_INCLUDE_LOAN_HEADER: 'กฎเกณฑ์การตรวจสุขภาพและเอกสารทางการเงินสำหรับการกู้เบี้ยประกันภัยในวงเงินกู้',
  NO_HEALTH_CHECK: 'ไม่ต้องตรวจสุขภาพ (พร้อมกรอกใบสมัครทำประกันครบทุกข้อ)',
  LISTS_HEALTH_CHECK: [
    'MD : ตรวจร่างกาย',
    'MU : ตรวจปัสสาวะ',
    '*BP2 : ตรวจเลือด (HIV, FBS, HbA1c, Cholesterol, Triglycerides, HDL, LDL, CBC, ESR, Creatinine, BUN, Uric acid, eGFR, SGOT, SGPT, GGT, และ **HBsAg)',
    'HIV : ตรวจ Anti-HIV พร้อมแนบใบยินยอม UW07',
    'EST : ตรวจสมรรถภาพหัวใจขณะออกกำลังกาย (โดยวิ่งสายพาน) ',
  ],
  REMARK_HEALTH_CHECK: [
    '*งดอาหารและเครื่องดื่ม อย่างน้อย 8 ชั่วโมง กรณีตรวจน้ำตาลในเลือด และ อย่างน้อย 12 ชั่วโมง กรณีตรวจไขมันในเลือด',
    '**กรณี HBsAg เป็น POSITIVE ให้ตรวจ AFP และ HBeAg เพิ่มเติม',
  ],
  FINANCIAL_STATUS_REPORTING_RULES: 'กฎเกณฑ์การรายงานสถานะทางการเงิน',
  FINANCIAL_RULES: [
    'Loan Q/1 : ให้เจ้าหน้าที่ธนาคารกรุงไทยตอบแบบสอบถามสถานะทางการเงินสำหรับการทำประกันภาระหนี้สิน ข้อ 1',
    'Loan Q/2 : ให้เจ้าหน้าที่ธนาคารกรุงไทยตอบแบบสอบถามสถานะทางการเงินสำหรับการทำประกันภาระหนี้สิน ข้อ 1-5',
    [
      'LA : สำเนาหนังสืออนุมัติวงเงินสินเชื่อจากธนาคาร',
      'LAQ :  แบบสอบถามวงเงินสูงพร้อมลายมือชื่อผู้เอาประกันภัย',
      'FS : รายงานเอกสารทางการเงิน งบดุล งบกำไร ขาดทุนย้อนหลัง 3 ปี',
      'ITR : รายงานการเสียภาษีรายได้ย้อนหลัง 3 ปี',
      'IR : รายงานการตรวจสอบเพิ่มเติม (บริษัท เป็นผู้ดำเนินการ)',
    ],
  ],
  REMARK_OVERALL_SUMMARY_MRTA: [
    'อายุอาจมีการเปลี่ยนแปลงได้ ทั้งนี้ขึ้นอยู่กับวันที่ชำระเงินหรือวันที่ตรวจสุขภาพ ซึ่งจะมีผลกระทบต่อเบี้ยประกันภัย',
    'เบี้ยประกันภัยอาจมีการปรับเพิ่มขึ้นเนื่องจากสุขภาพได้',
  ],
}
